webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/P39IXH/%3F1728129215254&title=1%20and%202%20Thessalonians%2C%20Two%20Horizons%20New%20Testament%20Commentary%20%28THNTC%29&summary=A%20distinctively%20theological%20interpretation%20of%20the%20Thessalonian%20letters%20In%20this%20commentary%20Andy%20Johnson%20engages%20with%20the%20developing%20interpretive%20framework%20of%20missional%20hermeneutics%20to%20present%20a%20theological%20interpretation%20of%201%20%26amp%3B%202%20The&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/P39IXH/%3F1728129215254",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=A%20distinctively%20theological%20interpretation%20of%20the%20Thessalonian%20letters%20In%20this%20commentary%20Andy%20Johnson%20engages%20with%20the%20devel%0Dhttps://textcafe.co/books/P39IXH/%3F1728129215254&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/P39IXH/%3F1728129215254&posttype=link&caption=A%20distinctively%20theological%20interpretation%20of%20the%20Thessalonian%20letters%20In%20this%20commentary%20Andy%20Johnson%20engages%20with%20the%20developing%20interpretive%20framework%20of%20missional%20hermeneutics%20to%20present%20a%20theological%20interpretation%20of%201%20%26amp%3B%202%20The",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/P39IXH/%3F1728129215254&description=A%20distinctively%20theological%20interpretation%20of%20the%20Thessalonian%20letters%20In%20this%20commentary%20Andy%20Johnson%20engages%20with%20the%20developing%20interpretive%20framework%20of%20missional%20hermeneutics%20to%20present%20a%20theological%20interpretation%20of%201%20%26amp%3B%202%20The&media=https://textcafe.co/books/P39IXH/tc-custom/9781467446129.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/B07722XYW5?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=4zs8DwAAQBAJ&amp;rdid=book-4zs8DwAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }, {
        title: 'Kobo',
        img: 'https://textcafe.co/global-css/img/kobo_appicon.svg',
        url: 'https://www.kobo.com/us/en/search?Query=9781467446129',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467446129').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/P39IXH/tc-custom/9781467446129.jpg?1728129215254',
        alt: '1 and 2 Thessalonians, Two Horizons New Testament Commentary (THNTC)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "xhtml/contents", "xhtml/acknowledgments", "xhtml/abbreviations", "xhtml/introduction", "xhtml/bibliography", "xhtml/chapter001", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/P39IXH/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_frontmatter001__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_frontmatter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xhtml_frontmatter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_title__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_copyright__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xhtml_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_dedication__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_xhtml_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_xhtml_contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_acknowledgments__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_acknowledgments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_xhtml_acknowledgments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_abbreviations__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_xhtml_abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_introduction__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_xhtml_introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_bibliography__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_xhtml_bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter001__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter001a__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter001a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter001a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter002__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter003__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter003a__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter003a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter003a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_index001__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_index001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_xhtml_index001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_index002__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_index002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_xhtml_index002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_index003__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_index003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_xhtml_index003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_last__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_last__);
/*jshint esversion: 6 */

























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/xhtml/contents",
    "name": "xhtml/contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_xhtml_contents___default.a
  }, {
    "path": "/xhtml/acknowledgments",
    "name": "xhtml/acknowledgments",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_xhtml_acknowledgments___default.a
  }, {
    "path": "/xhtml/abbreviations",
    "name": "xhtml/abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_xhtml_abbreviations___default.a
  }, {
    "path": "/xhtml/introduction",
    "name": "xhtml/introduction",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_xhtml_introduction___default.a
  }, {
    "path": "/xhtml/bibliography",
    "name": "xhtml/bibliography",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_xhtml_bibliography___default.a
  }, {
    "path": "/xhtml/chapter001",
    "name": "xhtml/chapter001",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter001___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_22__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andy Johnson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Andy Johnson")]), _vm._v(" is professor of New Testament at Nazarene Theological Seminary, Kansas City, Missouri, and coeditor of "), _c('I', [_vm._v("Holiness and Ecclesiology in the New Testament.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/P39IXH/tc-custom/9781467446129.jpg?1728129215254",
      "alt": "This image is the cover for the book 1 and 2 Thessalonians, Two Horizons New Testament Commentary (THNTC)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1 and 2 Thessalonians, Two Horizons New Testament Commentary (THNTC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("A distinctively theological interpretation of the Thessalonian letters")]), _c('br'), _c('br'), _vm._v(" In this commentary Andy Johnson engages with the developing interpretive framework of missional hermeneutics to present a theological interpretation of 1 & 2 Thessalonians that aims to help the church more fully participate in the life and mission of the triune God."), _c('br'), _c('br'), _vm._v(" After a verse by-verse commentary, Johnson closely examines the theology of the two epistles, focusing especially on the topics of eschatology, holiness, and election in light of his missional reading of 1 and 2 Thessalonians. In his exegetical and theological analyses, Johnson considers canonical concerns, doctrinal commitments, ecclesial practices, proposals from contemporary systematic theology, and insights gleaned from the field of neuroscience regarding personal and community formation, all of which help to clarify and enrich readers' understanding of various passages.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "Tocb",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_c('i', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_c('b', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "intro1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro1"
    }
  }, [_vm._v("The General Interpretive Approach of This Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "intro2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro2"
    }
  }, [_vm._v("Specific Introductory Issues Related to 1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "intro3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro3"
    }
  }, [_vm._v("Acts 16–18:5 and the Thessalonian Correspondence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "intro4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro4"
    }
  }, [_vm._v("The Sociopolitical Context in Thessalonica")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "bib"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/bibliography#bib"
    }
  }, [_c('b', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "bib1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/bibliography#bib1"
    }
  }, [_vm._v("Commentaries on 1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "bib2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/bibliography#bib2"
    }
  }, [_vm._v("Other Works")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_c('b', [_vm._v("Commentary on 1 Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s01"
    }
  }, [_vm._v("1:1 The Letter’s Prescript")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s02"
    }
  }, [_vm._v("1:2–3:13 Faith Working through Love, Resulting from Paul’s Faithful Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s03"
    }
  }, [_c('i', [_vm._v("1:2-10 Thanksgiving for What God Has Done among and by the Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s04"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCURSUS ON THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANING OF “")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s05"
    }
  }, [_c('i', [_vm._v("2:1-12 “The Sort of People We Became among You”: An Explanation and a Model for Participation in the")]), _vm._v(" Missio Dei")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s06"
    }
  }, [_vm._v("The Rhetorical Function of 2:1-12")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s07"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s07"
    }
  }, [_vm._v("2:1-4 Paul’s Faithfulness to the Gospel in the Face of Opposition")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s08"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s08"
    }
  }, [_vm._v("2:5-12 Paul’s Concrete Embodiment of the Essence of the Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s09"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s09"
    }
  }, [_c('i', [_vm._v("2:13-16 Thanksgiving for God’s Word at Work: Imitating Faithful, Persecuted Jewish Churches in Judea")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s10"
    }
  }, [_c('i', [_vm._v("2:17–3:10 Paul and the Thessalonians: “Bringing Things Up-to-Date”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s11"
    }
  }, [_vm._v("2:17-20 An Explanation of Absence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s12"
    }
  }, [_vm._v("3:1-5 The Sending of Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s13"
    }
  }, [_vm._v("3:6-10 Timothy’s Good Report and Paul’s Desire to See the Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s14"
    }
  }, [_c('i', [_vm._v("3:11-13 First Petitionary Prayer for the Holiness of the Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s15"
    }
  }, [_vm._v("4:1–5:24 God’s Sanctifying Work in the Life of the Community in Anticipation of the Parousia on the Day of the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s16"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCURSUS ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLINESS/")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANCTIFICATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s17"
    }
  }, [_c('i', [_vm._v("4:1-8 God’s Will: The Sanctification of the Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s18"
    }
  }, [_c('i', [_vm._v("4:9-12 Flourishing in Love and Working to Avoid Dependence on Patrons")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s19"
    }
  }, [_c('i', [_vm._v("4:13-18 The Resurrection of Those “Sleeping” at the Royal Coming of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s20"
    }
  }, [_vm._v("The Main Issue in the Community")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s21"
    }
  }, [_vm._v("Death, Resurrection, and the Coming of the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#s22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("5:1-11 Living as Children of Light Awaiting the Day of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#s23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("5:12-22 Practices through Which God Continues Sanctifying the Audience’s Imagination")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#s24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("5:23-24 Concluding Petitionary Prayer for the Completion of God’s Sanctifying Work")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#s25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:25-28 The Letter’s Closing")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Commentary on 2 Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:1-2 The Letter’s Prescript")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:3-12 Thanksgiving and Eschatological Assurance")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s28"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:1-17 Pastoring an Eschatologically Confused People: The Day of the Lord and the Man of Lawlessness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Boundaries, Difficulty, and Overall Function of the Passage")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s30",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("2:1-2 Description of the Problem: The Timing of the Day of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s31",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("2:3-12 Paul’s Response: Events Preceding the Day of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s32",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("2:13-15 Thanksgiving and Admonition to Hold Fast to Paul’s Teaching regarding the Day of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s33",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("2:16-17 Petitionary Prayer for Encouragement and Strength")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:1-5 Paul’s Request for Prayer and His Confidence in, and Prayer for, the Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:6-16 Those Who Cultivate a Client Relationship with a Patron in Lieu of Working")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:17-18 The Letter’s Closing")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Theological Horizons")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Theology of 1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s38",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Death of Jesus and the")]), _vm._v(" Missio Dei "), _c('i', [_vm._v("in 1 and 2 Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s39",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Holiness in 1 and 2 Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness as Spirit Enabled and Derived from the Triune God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness, Election, and Faith(fulness): The Corporate and Public Nature of Holiness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness and Righteousness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness and Seeking Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness and Purity")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sanctification of the Imagination: Self-Giving Practices and the Ecclesial Framework")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness, Work, and Economic Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Holiness and the Missio Dei")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s48",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Eschatology in 1 and 2 Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Word about Eschatological Imagery")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resurrection and the Coming of the Lord Jesus as Parousia")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coming of the Lord Jesus as Eschatological Warfare")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coming of the Lord Jesus as Judgment Theophany")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s53"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary: Eschatology in 1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 and 2 Thessalonians and the Bible: Canonical Connections")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s55",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Ontology of Christian Scripture: Some Basic Assumptions")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s56",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Paul’s “Anti-Christology”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man of Lawlessness vs. the Man of Saving Justice/Righteousness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Actions of the Man of Lawlessness in Verse 4: The Epitome of Human Arrogance")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pinnacle of an OT Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippians 2:6-11 as the Reversal of the Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s61",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Summary and Concluding Reflections")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engaging Theology with the Thessalonian Correspondence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s63",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("On the (Secret) Rapture")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Theological Hermeneutic of Rapture Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Thessalonian Correspondence and the Rapture of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflections on Rapture Theology/Dispensationalism as a Theological Interpretation of Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Comments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s68",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("“You Wonder Where the Spirit Went”: The Parousia as a Pneumatological Event in the Thessalonian Correspondence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Once Again: Interpretive Assumptions and a Question")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture as an Echo Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc4",
    attrs: {
      "id": "s71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s71",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Son’s Shout/Voice and the Resurrection of the Dead in 1 Thessalonians and John’s Gospel")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc4",
    attrs: {
      "id": "s72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s72",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Forging a Canonical Warrant")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc4",
    attrs: {
      "id": "s73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s73",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Returning to 1 and 2 Thessalonians with This Canonical Warrant")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Parousia as a Pneumatological Event")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "s75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s75",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Election, Mission, and the Triune God")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Doctrine of Election: Introductory Remarks")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "s77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Election and Participation in the Mission/Being of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc4",
    attrs: {
      "id": "s78"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s78",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Election and Participation in the Thessalonian Correspondence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc4",
    attrs: {
      "id": "s79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s79",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Nature of the Elect’s Participation in the Missio Dei")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc4",
    attrs: {
      "id": "s80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s80",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Alternative Ontology of Election and the Being of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#s81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Election and the Church’s Continuing Sinfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca1",
    attrs: {
      "id": "ind1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#ind1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index of Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "ind2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#ind2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index of Subjects")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "ind3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#ind3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index of Scripture and Other Ancient Writings")])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush"
  }, [_vm._v("Since the manuscript of this commentary was delivered to the publisher, two major commentaries on the Thessalonian correspondence have appeared: Jeffrey Weima’s "), _c('i', [_vm._v("1–2 Thessalonians")]), _vm._v(" (Baker Academic, 2014) and Eugene Boring’s "), _c('i', [_vm._v("I & II Thessalonians")]), _vm._v(" (WJK, 2015). No doubt the present commentary would have been enriched if they had appeared in time for me to engage in dialogue with them. But this commentary has been in the making far too long as it is, too long in fact, for me even to remember, let alone explicitly acknowledge, all who have contributed in some way to its completion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the outset, I want to thank Joel Green, not only for the invitation to write a theological commentary, but for his extreme patience in allowing me to complete it. Several people have read and commented on parts of the commentary. I am grateful to my longtime friend and colleague, Steve McCormick, for his helpful suggestions on several sections in the Theological Horizons portion of the commentary and to George Hunsberger, who read and commented on what has become the last section of the commentary devoted to the doctrine of election. Two people in particular, however, stand out as good friends and colleagues to whom I owe a debt of gratitude. Dean Flemming has not only read various portions of the commentary and given generous feedback; our weekly breakfast conversations both helped to shape some of its content and gave me the kind of encouragement I needed to bring this book to completion. Michael Gorman, who has obviously influenced the way I understand Paul, read the entire manuscript, offering numerous helpful suggestions that have improved both the content and the clarity of the commentary. It would not do to speak about those who have helped clarify and improve the commentary without mentioning my copy editor, Craig Noll. I am in his debt for reading the manuscript with a fine-tooth comb, making numerous corrections, and suggesting incisive clarifications of ambiguous language. I also appreciate the "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("efforts of Jenny Hoffman, my project manager at Eerdmans, who took on this commentary in a period of transition and has worked diligently to make sure that it got the attention it needed.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Others have contributed to my thinking over the years about theological interpretation in general, and the Thessalonian correspondence in particular, not least my students at Nazarene Theological Seminary (NTS). Their probing questions have helped to shape various aspects of the commentary. Two of my teaching and research assistants have offered assistance at different stages of the commentary. Kara Lyons-Pardue, my first assistant when I came to NTS, worked on an initial bibliography and made copies of dozens of articles and essays. Tim Hahn, my current assistant, has chased down particular references for me and has helped with the indices. I want to thank NTS for providing these assistants and for giving me sabbaticals in 2007 and 2011, during which much of this commentary was written. In addition, I am grateful to my academic dean and fellow New Testament scholar, Roger Hahn, for his tireless administrative work in which he intentionally allowed me space to research and write.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, I want to thank my family, to whom the commentary is dedicated. My teenage sons, Zac and Ben, do not remember when their dad was not writing this commentary. I do not, though, want to thank them for giving up time with me that they might otherwise have had while I was writing. I did not sacrifice time with them to write as they were growing up. Instead, I coached both of them in hundreds of baseball and basketball games and practices over the years in which this commentary was taking shape, and I am forever grateful to them that they allowed their dad that opportunity. The joy it afforded me may have delayed the publication of this commentary, but it helped keep my life balanced as I was writing and I would happily do it all over again. No one, however, has helped bring balance to my life and given me more encouragement to complete this commentary than Gina, my wife of thirty-two years. She believed in me when I was having trouble believing that I would ever finish this project. Without her inspiration, it would not have come to fruition.")]), _vm._v(" "), _c('p', {
    staticClass: "Right"
  }, [_vm._v("Ascension Day, 2016")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("AB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Anchor Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("AnBib")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Analecta Biblica")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Ante-Nicene Fathers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ANTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Abingdon New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("AThR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Anglican Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("BBR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Bulletin for Biblical Research")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("BCH")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Bulletin de correspondance hellénique")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("BDAG")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Walter Bauer et al. "), _c('i', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature.")]), _vm._v(" 3rd ed. Revised and edited by Frederick William Danker. Chicago: University of Chicago Press, 2000.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("BDF")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("F. Blass, A. Debrunner, and R. W. Funk. "), _c('i', [_vm._v("A Greek Grammar of the New Testament and Other Early Christian Literature.")]), _vm._v(" Chicago: University of Chicago Press, 1961")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("BSac")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Bibliotheca Sacra")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CBQ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("CEB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Common English Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("CEV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Contemporary English Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ConBNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Coniectanea biblica: New Testament Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Calvin Theological Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CurTM")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Currents in Theology and Mission")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ÉBib")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Études bibliques")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("EDNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Exegetical Dictionary of the New Testament.")]), _vm._v(" Edited by Horst Balz and Gerhard Schneider. 3 vols. Grand Rapids: Eerdmans, 1990–93.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("EKKNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Evangelisch-katholischer Kommentar zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ESV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('i', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Evangelical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ExAud")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Ex Auditu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("GNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Good News Translation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("GNT"), _c('sup', [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Greek New Testament,")]), _vm._v(" 4th rev. ed.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("HBT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Horizons in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("HCSB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Holman Christian Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("HNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Handbuch zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("HTR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Harvard Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("IBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Interpretation: A Bible Commentary for Teaching and Preaching")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ICC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("IJST")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("International Journal of Systematic Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Int")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("IVPNTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("InterVarsity Press New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JBL")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JETS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JSNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal for the Study of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("JSNTSup")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JSOT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal for the Study of the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JSPL")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal for the Study of Paul and His Letters")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JTI")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Theological Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JTS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JTSA")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Theology for South Africa")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("KJV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("LNTS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Library of New Testament Studies")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("LXX")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("mng.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("meaning")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("MS(S)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("manuscript(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NA"), _c('sup', [_vm._v("28")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Nestle-Aland "), _c('i', [_vm._v("Greek New Testament,")]), _vm._v(" 28th ed.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NASB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New American Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NBBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Beacon Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NCB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Century Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NET")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New English Translation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NICNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Interpreter’s Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NIDB")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("New Interpreter’s Dictionary of the Bible.")]), _vm._v(" Edited by Katherine Doob Sakenfield. 5 vols. Nashville: Abingdon, 2006–9.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIGTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Greek Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NJB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Jerusalem Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("NLT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Living Translation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NovT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NPNF")]), _c('sup', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Nicene and Post-Nicene Fathers,")]), _vm._v(" Series 1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NPNF")]), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Nicene and Post-Nicene Fathers,")]), _vm._v(" Series 2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NRSV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NSBT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Studies in Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NTOA")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Novum Testamentum et Orbis Antiquus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NTS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("OBT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Overtures in Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("OG")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Old Greek")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("OT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Old Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("PBM")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Paternoster Biblical Monographs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("PNTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Pillar New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ProEccl")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Pro Ecclesia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("PTR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Princeton Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("RBL")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Review of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("RevExp")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Review and Expositor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("RSV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("SB")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Sammelbuch griechischer Urkunden aus Aegypten")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SBLDS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SHBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Smyth & Helwys Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("SJT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Scottish Journal of Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SNTSMS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Society of New Testament Studies Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SP")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Sacra Pagina")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("STJ")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Second Temple Judaism")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SUNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Studien zur Umwelt des Neuen Testaments")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TDNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Theological Dictionary of the New Testament.")]), _vm._v(" Edited by Gerhard Kittel and Gerhard Friedrich. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–76.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("THNTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Two Horizons New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("TNIV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Today’s New International Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Theology Today")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TynBul")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Tyndale Bulletin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("VT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("WBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Word Biblical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("WesTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Wesleyan Theological Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("WUNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("WW")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Word and World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("ZBK")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Zürcher Bibelkommentare")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft and die Kunde der älteren Kirche")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ZST")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Zeitschrift für systematische Theologie")])])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "h1top",
    attrs: {
      "id": "intro1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#intro1"
    }
  }, [_vm._v("The General Interpretive Approach of This Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Theological interpretation of Scripture is currently the subject of a robust conversation, primarily in Western academic circles, with no final consensus having yet emerged as to its particular shape."), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1"
    }
  }, [_vm._v("1")])]), _vm._v(" The following represents my current understanding of its nature and function."), _c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2"
    }
  }, [_vm._v("2")])]), _vm._v(" What constitutes a "), _c('i', [_vm._v("theological")]), _vm._v(" interpretation of Scripture is not always obvious and cannot be demarcated by methodological boundaries. Interpreting Scripture theologically is characterized more by a particular orientation toward Scripture in which interpreters self-consciously locate themselves and their interpretations within an ecclesial framework characterized by a commitment to the Christian canon(s), the ecumenical creeds, and a variety of ecclesial practices. They assume that canonical considerations, doctrinal commitments and concerns, and ecclesial practices might clarify and deepen understanding of Scripture, and that Scripture might clarify and deepen understanding of the church’s doctrine and practices. Hence, the aim of interpreting Scripture theologically is to stimulate critical reflection on the church’s beliefs and practices in order to facilitate the church’s ongoing formation into the visible body of the cruciform, living Christ, to whom Scripture bears witness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To speak of the church’s formation into such a visible body, however, "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("compels us to ask to what end. The formation of the church and members who make it up into conformity with Christ is not simply for the sake of ensuring the salvation of its individual members. Rather, the church is formed into the visible body of the living, cruciform Christ in order to participate in the life and mission of the Triune God. Hence, interpreting the Bible theologically for the sake of the church ought to be characterized by a missional orientation toward the interpretive task.")]), _c('a', {
    attrs: {
      "id": "fn3"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3"
    }
  }, [_vm._v("3")])]), _vm._v(" In other words, since the Triune God is by nature a “sending,” or “missional,” God,"), _c('a', {
    attrs: {
      "id": "fn4"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4"
    }
  }, [_vm._v("4")])]), _vm._v(" a properly theological interpretation of Scripture will itself be missionally oriented for the purpose of aiding in the continuing formation of the church as a missional community."), _c('a', {
    attrs: {
      "id": "fn5"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A variety of aspects proposed in the current discussion might need to be included in an engagement with Scripture to make it properly missional."), _c('a', {
    attrs: {
      "id": "fn6"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6"
    }
  }, [_vm._v("6")])]), _vm._v(" I cannot take all these aspects into consideration, however, in a commentary genre. In this commentary I trust that what I am calling a missional orientation to the interpretive task will be evident in two ways. First, I will consciously attempt to offer an interpretation of 1 and 2 Thessalonians that focuses on elements of the text most useful for facilitating the continuing formation of the church into its proper identity as a missional community. Second, throughout the commentary I will assume that Scripture has a roughly discernible shape that bears witness to God’s mission for the cosmos. I will employ this framework (along with the aspects of the Nicene-Constantinopolitan Creed) as a clarifying set of interpretive lenses for bringing 1 and 2 Thessalonians into clearer canonical focus, which in turn will contribute to a better understanding of the shape of Scripture’s missional framework and the church’s participation in that mission. It will be helpful, then, before moving on to specific matters relating to 1 and 2 Thessalonians, to describe briefly what I perceive to be this overall missional framework discernible in Scripture."), _c('a', {
    attrs: {
      "id": "fn7"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Genesis begins with God’s creating the world with great care, repeatedly calling it “good,” and it ends with Rev 21–22, with God’s “making all things new” (21:5). Although creation is “very good” in Gen 1, God does not make it “perfect,”")]), _c('a', {
    attrs: {
      "id": "fn8"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8"
    }
  }, [_vm._v("8")])]), _vm._v(" but in Gen 2 he gives humanity a job to do—a mission—from which he never releases humanity. There the holy God creates humans in his own image to reflect his gracious rule over creation so that it would flourish with well-ordered life (Gen 1:28; 2:15), reach its full potential, and thereby bring proper honor and glory to God. However, when humankind refuses to live under God’s rule and reflect that gracious rule and image to the rest of creation, God’s purposes for creation as a whole are delayed. Humanity’s refusal to engage in this image-bearing pattern of activity bars them from the tree of life, making them susceptible to the forces of death. It alienates people from the life-giving God, the created order, and each other, all of which leads to evil, violence, and more death (Gen 4:1–16; 6:5–6, 11–12). After Gen 3, therefore, God’s mission involves saving humanity from its guilt, as well as saving humanity and the entire created order from the consequences of human rebellion. This part of God’s mission, however, becomes a subplot to the main plot of the story of God’s mission, namely, to bring creation to its intended destiny through the agency of humanity in a way that brings proper honor and glory to God. Even after the flood, when God attempts to wipe creation clean, humanity remains inclined toward violence and death-dealing forces (Gen 8:21; 11:1–9). The disorder and chaos introduced into the garden are then magnified at Babel when “all the people on earth” are gathered together "), _c('i', [_vm._v("in one place,")]), _vm._v(" refusing to fulfill the creation mandate to move out and fill all the earth with the fruitful blessing of new life that expresses itself in diverse peoples and ways. So God has to forcefully divide and disperse them in order to restart the process of fulfilling his dream of bringing his whole creation to its intended destiny through the agency of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Gen 12 to the end of the Christian canon may be read, then, as the overarching story of God’s life-giving mission to reverse the consequences of human rebellion and bring humanity and the rest of creation to its full potential. In this story God never gives up on his dream of accomplishing his mission through the agency of humanity. The first step he takes is to single out—“set apart,” “call,” or “elect”—Abraham and his family, who became the people of Israel. God’s mission was not only to engender life in all its fullness for his beloved Israel (as Christians, we ought not to play down especially this aspect of God’s mission), but also, through Israel, to engender life in all its fullness for the nations and creation as a whole. As a response to God’s loving, gracious "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("election, they were to become a holy, set-apart, missional instrument reflecting God’s character/pattern of activity in a chaotic and disordered world, with God, though their obedience to Torah, molding their life together into a life-giving blessing for the rest of the nations and for creation as a whole. But as things turned out, the unleashed forces of Sin and Death proved powerful enough to co-opt even Torah into their service, and Israel as a whole, even when they had the best of intentions, was not able to avoid reflecting the chaos and disorder of a Sin-stricken world in their own life together. As is the case very often in the church, rather than confronting the surrounding nations’ idolatrous way of life, they were, instead, absorbed into it, something the prophets knew all too well. But in faithfulness to his covenant with Israel, God the Father sent the Spirit-inhabited, elect Son. This Jew from Nazareth was the locus of God’s holy presence, through which God’s mission went forward as he embodied true Israel and therefore true humanity.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Jesus’ story was characterized by a particular pattern of redemptive, reconciling activity directed ultimately toward God’s mission of bringing creation to its intended destiny. The "), _c('i', [_vm._v("imago Dei,")]), _vm._v(" and thus what it means to be truly human and truly holy, now has a visible form and location. It bears the stamp of the particular human being Jesus the Nazarene, Israel’s messianic representative, through whom God realized his dream of carrying out his life-giving mission through humanity. The pattern of activity that now constitutes both true divinity and true humanity—and thereby true holiness—thus has an unmistakable cruciform shape manifest in faithfulness to God’s life-giving, reconciling mission; it is expressed in costly, self-giving actions for others, even to the point of death. People become (elect) beneficiaries of this loving mission of the Triune God in order to participate in that mission. Hence the church, the very body of the Son in the world, becomes the primary locale of the mission in a variety of particular social settings. It becomes “the cultural explication of God’s identity.”")]), _c('a', {
    attrs: {
      "id": "fn9"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9"
    }
  }, [_vm._v("9")])]), _vm._v(" Enabled by the (Christ-shaped) Holy Spirit to embody a pattern of activity analogous to that of the Son’s, the church (both corporately and through its individual members) becomes a channel through which God continues his reconciling, redeeming, life-giving purposes. Thus, just as God’s being cannot be separated from God’s mission and acts,"), _c('a', {
    attrs: {
      "id": "fn10"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10"
    }
  }, [_vm._v("10")])]), _vm._v(" neither can those of the church. The church is truly itself only when it responds to the Spirit’s enabling by participating in God’s mission to address the consequences of human rebellion and ultimately bring creation to its intended destiny.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Before ending this first section on the general interpretive approach of this "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("commentary, I wish to make the reader aware of my own social and theological location, which no doubt shapes both the questions I bring to the Thessalonian correspondence and the particular exegetical judgments I make in addressing those questions.")]), _c('a', {
    attrs: {
      "id": "fn11"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11"
    }
  }, [_vm._v("11")])]), _vm._v(" I approach these texts as a white, middle-class, American male who currently lives in the U.S. Midwest. Most of my ecclesial experience is of the church in North America, and my assumption in this commentary is that most of its readers will be at least somewhat familiar with that context. Theologically, I am and have always been a part of the broad Wesleyan tradition, one open to being instructed by other traditions within the church catholic. As such, one of my orienting concerns in approaching Scripture is that of how we ourselves, and the community to which we belong, might embody the holy nature and will of the Triune God, how we might be and become a sanctified people in our particular historical and social settings. This goal, I believe, is also one of Paul’s primary concerns in the Thessalonian correspondence.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "intro2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#intro2"
    }
  }, [_vm._v("Specific Introductory Issues Related to 1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("My doctor father, Donald Juel, used to say regularly: “It is not a question as to whether background historical information is good. The question has more to do with "), _c('i', [_vm._v("what it is good for.")]), _vm._v("” With the overall interpretive orientation and aims laid out above in mind, I have attempted to decide what sort of historical information is good for a fruitful theological engagement with the Thessalonian correspondence. Hence, certain issues usually addressed in commentary introductions will either be given little attention or be ignored if they do not seem relevant to facilitating such an engagement with these letters.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For example, it is not clear that detailed descriptions of the history of Thessalonica or of its geography are relevant for an interpretation of the letters that focuses on theological matters. Nor do the date and location of Paul’s composition of these letters merit much attention. In this regard, I assume that Paul wrote 1 Thessalonians sometime between 49 and 52 CE, possibly a few weeks, but more likely a few months, after he left Thessalonica while he was engaged in his mission at Corinth, and that he wrote 2 Thessalonians within a few months to a year or so later."), _c('a', {
    attrs: {
      "id": "fn12"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12"
    }
  }, [_vm._v("12")])]), _vm._v(" The two letters are therefore probably the earliest extant letters of Paul, and hence also the earliest extant Christian writings. I see no reason of theological import to attempt to be more specific about the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Two other issues seem slightly more important for our purposes and merit only a brief discussion at this point, namely, attempts to nail down either the epistolary type(s) or the rhetorical species of the letters.")]), _c('a', {
    attrs: {
      "id": "fn13"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13"
    }
  }, [_vm._v("13")])]), _vm._v(" These Thessalonian letters are clearly epistles and do indeed exhibit certain characteristics that are common in some types of ancient letters as these are described in the ancient epistolary handbooks."), _c('a', {
    attrs: {
      "id": "fn14"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14"
    }
  }, [_vm._v("14")])]), _vm._v(" However, attempts to categorize them specifically in terms of the epistolary types detailed in the ancient handbooks (e.g., 1 Thessalonians as a friendship letter, a consolation letter, or a paraenetic letter) have been inconclusive, perhaps because they do have elements within them of various epistolary types. In my view, engaging in this debate simply would not bear enough theological fruit to make the endeavor worthwhile.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The same could be said of attempts to identify the classical rhetorical species of 1 Thessalonians in particular (i.e., usually understood as deliberative"), _c('a', {
    attrs: {
      "id": "fn15"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15"
    }
  }, [_vm._v("15")])]), _vm._v(" or epideictic"), _c('a', {
    attrs: {
      "id": "fn16"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16"
    }
  }, [_vm._v("16")])]), _vm._v(") and then focus in detail on its arrangement ("), _c('i', [_vm._v("dispositio")]), _vm._v(")."), _c('a', {
    attrs: {
      "id": "fn17"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17"
    }
  }, [_vm._v("17")])]), _vm._v(" Paul’s letters are clearly rhetorical documents attempting to make persuasive arguments to their audiences. As such, they do utilize various rhetorical strategies toward this end, some of which may be similar to rhetorical categories in the rhetorical handbooks. In my view, however, use of Greco-Roman rhetorical categories, particularly in formally specifying the species and arrangement of Paul’s argumentation, is simply one heuristic device among others that may or may not be helpful to explicate how Paul’s arguments actually work."), _c('a', {
    attrs: {
      "id": "fn18"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Such approaches do not seem either to have resulted in particularly unique interpretations of the actual content of 1 and 2 Thessalonians or to have generated readings that are any more fruitful for a theological engagement of their rhetoric than those generated by other approaches. Hence, while seeming at first to offer promise in helping to explicate the structure and content of the letters, to my knowledge, approaches directed toward such questions typically yield little that is theologically helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moving slightly further up the scale of theological importance is the issue "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("of the authorship of 2 Thessalonians. The question of whether Paul wrote 2 Thessalonians is certainly complex from a historical standpoint.")]), _c('a', {
    attrs: {
      "id": "fn19"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19"
    }
  }, [_vm._v("19")])]), _vm._v(" While I have nothing new to add to this discussion, I will make a few brief observations and state my assumptions about these matters. The primary factors leading many to question its authenticity include (1) the perception that 2 Thessalonians is literarily dependent on 1 Thessalonians, (2) perceived differences in the language and style of the two letters, and (3) perceived theological differences between the letters, particularly in terms of eschatology.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From a historical standpoint, while I do think that such arguments for its non-Pauline authorship have some force, I remain unconvinced. At the end of the day, all such attempts to argue that it is pseudonymous falter on the same historical rocks; that is, they fail to provide a convincing historical setting in which launching such a document would make better sense than simply attributing the letter to Paul in the first place. If someone knew 1 Thessalonians as part of a corpus of Pauline letters that had begun circulating in the late first or early second century, and if the theology of 2 Thessalonians really is so different from that of 1 Thessalonians and the rest of Paul’s letters, how would the person have hoped to persuade anyone—at least anyone familiar enough with Paul or his corpus to care about a writing in the name of Paul—that 2 Thessalonians was from Paul? All such reconstructed historical situations finally raise more questions than they answer."), _c('a', {
    attrs: {
      "id": "fn20"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From a theological standpoint, the possibility that someone could have written a letter in Paul’s name that later became part of the canon with which this same God gifted the church may not necessarily be problematic. In the overall biblical narrative, God is depicted as specifically choosing some who go on to intentionally deceive others (e.g., Abraham and Jacob) and who nevertheless continue to be instruments of his saving mission. That God might have chosen to use the product of a writer of a document that later became Scripture in spite of its “deceptive” beginnings would simply manifest a pattern similar to one found earlier in God’s story with Abraham’s family. It would mean that Scripture itself "), _c('i', [_vm._v("in its canonical form,")]), _vm._v(" a form set in motion by this deceptive act, continues nonetheless to be an instrument in God’s saving mission.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Assuming the Pauline authorship of both letters does not deliver one from the task of attempting to discern the occasion of 2 Thessalonians and how it relates to 1 Thessalonians, a task that inevitably involves some speculation and use of historical information. But attempting to do so by postulating a non-Pauline author severs these letters from the relationship that they are given by the shape of the canon in favor of situating 2 Thessalonians in an extremely speculative reconstructed historical context. Even if there are major theological differences between the two (and I am not convinced there are), the canon’s own shaping of their relationship to each other provides a framework within which such differences can be channeled in enriching rather than antagonistic ways. Hence, I will assume throughout that Paul is the author of 2 Thessalonians and will attempt to discern its occasion and relationship to 1 Thessalonians within the framework given by the canon. This interpretive decision reflects my conviction that, particularly in a theological commentary, canonical and theological considerations should not be ruled out of court in determining what sort of interpretive strategies to use and what sort of historical background to postulate as forming the larger framework within which one ought to imagine the story of Paul’s correspondence with his Thessalonian audiences.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("With these considerations in mind, we turn our attention to the canonical background provided by Acts on the founding of the church at Thessalonica.")])]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "intro3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#intro3"
    }
  }, [_vm._v("Acts 16:1–18:5 and the Thessalonian Correspondence")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("“For a "), _c('i', [_vm._v("theological")]), _vm._v(" commentary, the account of the beginnings of the church in [Thessalonica] found in Acts [17] will be most significant.”"), _c('a', {
    attrs: {
      "id": "fn21"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21"
    }
  }, [_vm._v("21")])]), _vm._v(" Kavin Rowe offers a hermeneutically, historically, and theologically sophisticated reading of the parts of the Acts narrative relevant for our purposes."), _c('a', {
    attrs: {
      "id": "fn22"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22"
    }
  }, [_vm._v("22")])]), _vm._v(" What follows is indebted in numerous ways to his reading. To preface the general narrative from Acts that we will sketch below—and for that matter, to specify some of the most important background assumptions in this commentary—I quote from Rowe’s words near the beginning of his second chapter:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Converting to the God of the Christians was not merely an adjustment of this or that aspect of an otherwise unaltered basic cultural pattern; rather, worshipping the God of the Christians simultaneously involved (1) an extraction or removal from constitutive aspects of pagan culture (e.g., sacrifice "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("to the gods), and (2) a concomitant cultural profile that rendered Christians identifiable as a group by outsiders. Yet the practices that created this cultural profile were themselves dependent upon the identity of God. "), _c('i', [_vm._v("Christian ecclesial life, in other words, was the cultural explication of God’s identity.")])]), _c('a', {
    attrs: {
      "id": "fn23"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Although these words are directed toward the Acts narrative, they are equally apropos to the communities addressed by Paul’s letters and resonate with what we have described above as the missional direction of this commentary. As we will see, in 1 and 2 Thessalonians, Paul attempts to further form his audience’s ecclesial life into a visible display of the very character of the holy God of Israel as a cultural explication of his Triune identity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Our concern in this section is not to reconcile all the details of the Acts narrative with Paul’s recounting of the founding of the church in 1 Thessalonians."), _c('a', {
    attrs: {
      "id": "fn24"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24"
    }
  }, [_vm._v("24")])]), _vm._v(" It is, rather, to sketch a general narrative from canonical material that is informed by basic social and historical data, which will then be assumed as part of the story that gives the letters their primary context.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We begin in Acts 16. There, Paul, Silas, and (apparently) Timothy are depicted as going from town to town handing over the decisions reached by the apostles in Jerusalem about “the Gentiles who are turning to God” (15:19–21; cf. 1 Thess 1:9) so that their instructions would be observed in various churches (16:4–5). In Philippi, Paul and Silas were accused of stirring up trouble in the city and advocating customs that were unlawful for Romans to observe (16:20–21). They were then “treated shamefully” (1 Thess 2:2) by being publicly stripped, beaten with Roman rods, flogged, and then thrown into prison, where their feet were fastened in stocks (Acts 16:22–24). After being freed from prison by a divine earthquake, the Roman jailer guarding them (along with his household) became “a believer in God” (16:34) and showed Paul and Silas hospitality at his house. When the magistrates ordered that they be released the next morning, Paul refused to simply go away and sent word to them to remind them just how shamefully they had treated Silas and himself, publicly humiliating two Roman citizens (16:35–38)."), _c('a', {
    attrs: {
      "id": "fn25"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25"
    }
  }, [_vm._v("25")])]), _vm._v(" After an apology from the city officials and a brief respite in Lydia’s house, they went through Amphipolis and Apollonia and arrived in Thessalonica (16:40–17:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Paul and Silas were in Thessalonica over a time period that included at least three Sabbaths. While Acts does not tell us what they did during the week, 1 Thessalonians would lead us to imagine that Paul was publicly proclaiming the good news of Jesus’ lordship in the city, perhaps in the workshop as he was working with his hands in order not to burden any of the Gentiles (probably artisans) who were responding (e.g., 1 Thess 2:9; 2 Thess 3:8). But on the Sabbath, as was Paul’s custom, he entered the synagogue and began attempting to persuade those gathered there, not only that it was scripturally necessary that the Messiah had to suffer and rise from the dead, but that, indeed, Jesus was that Messiah (17:2–3). Here we might fill out the details of his attempt to persuade those in synagogues by appealing to his paradigmatic speech in the synagogue at Antioch in Pisidia (Acts 13:16–41). It is clear that a great many devout Greeks (i.e., nonproselyte synagogue adherents) and a good many leading (Greek) women who were at the synagogue were persuaded and joined themselves with Paul and Silas (17:4). And although the English translations and the commentators assume it to be so, it is not completely clear whether Paul and Silas had success in convincing "), _c('i', [_vm._v("any")]), _vm._v(" Jews in the synagogue in Thessalonica.")]), _c('a', {
    attrs: {
      "id": "fn26"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26"
    }
  }, [_vm._v("26")])]), _vm._v(" Whatever the case historically at the church’s beginning, 1 Thess 1:9–10, 2:14, and 4:13 imply that, by the time Paul writes to the church in Thessalonica, his rhetoric is primarily directed toward a Gentile audience (male and female)."), _c('a', {
    attrs: {
      "id": "fn27"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27"
    }
  }, [_vm._v("27")])]), _vm._v(" In any case, whatever the precise makeup of Paul’s historical audience for the letters and the way this fact is related to the Acts narrative, the epistles’ primary ecclesial function today is to address communities of (at least mostly) non-Jewish followers of Christ, both male and female. With this conclusion in "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("mind, perhaps more important than nailing down the composition of “those persuaded” in Acts 17:4, then, is highlighting the fact that it is precisely the concrete "), _c('i', [_vm._v("formation of a community")]), _vm._v(" who had responded to the preaching of Paul and Silas—not simply their preaching itself—that led to the reaction narrated in vv. 5–9. In other words, odd-sounding preaching is one thing, but when a visible community forms around that proclamation, then the trouble starts.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("We are not told how much time transpires between Paul’s success in persuading some Gentiles to adopt a noticeably different pattern of life that declares the kingship of Jesus in v. 4 and the time the Jews from the synagogue in Thessalonica instigate a riot in v. 5 by enlisting the aid of “evil men from the marketplaces,”")]), _c('a', {
    attrs: {
      "id": "fn28"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28"
    }
  }, [_vm._v("28")])]), _vm._v(" apparently Gentiles themselves, perhaps unemployed day laborers."), _c('a', {
    attrs: {
      "id": "fn29"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29"
    }
  }, [_vm._v("29")])]), _vm._v(" The latter (i.e., their “own compatriots”; see 1 Thess 2:14) join in forcibly dragging Jason and some other brothers off to face the city officials. There the riotous crowd refers to Paul and Silas as “upsetting the stability of the empire” or “turning the world upside-down” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀναστατώσαντες")]), _vm._v(", "), _c('i', [_vm._v("anastatōsantes")]), _vm._v(") and accuses Jason of giving them hospitality (vv. 6–7), perhaps implying that the community formed had already taken shape as a house church."), _c('a', {
    attrs: {
      "id": "fn30"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30"
    }
  }, [_vm._v("30")])]), _vm._v(" Noting that Luke uses the same word to describe Jewish revolutionary activity against Rome in Acts 21:38, Rowe argues that “the charge is not simply the complaint that the Christians are a social nuisance, but rather that the Christian mission is a force for sedition in an otherwise civilized world—"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἡ οἰκουμένη")]), _vm._v(".”"), _c('a', {
    attrs: {
      "id": "fn31"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The crowd then continues fleshing out that charge, saying, “"), _c('i', [_vm._v("All these")]), _vm._v(" [including Paul, Silas, Jason, and the others] are acting against the decrees of Caesar by saying that there is another king/emperor, namely, Jesus” (v. 7, my translation). In other words, what those charging them understand “all these” to be saying when they assert the kingship or lordship of Jesus is that “there is a contender for the imperial throne, namely, Jesus.”"), _c('a', {
    attrs: {
      "id": "fn32"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32"
    }
  }, [_vm._v("32")])]), _vm._v(" Whatever might have been the historical cause behind the hostile response,"), _c('a', {
    attrs: {
      "id": "fn33"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33"
    }
  }, [_vm._v("33")])]), _vm._v(" the Acts narrative itself "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("identifies the specific practice of saying that there is another king or emperor, namely, Jesus, as being what is “against the decrees of Caesar.” Such charges are similar to the charges leveled against Jesus in Luke’s gospel when, after he rides into Jerusalem as king (19:38), he is accused of claiming such (23:2) and is then crucified as a seditious rebel with an inscription identifying him as king (23:38). Hence, if Jason and the others are to be imagined as part of the nucleus of the church at Thessalonica, it would certainly be true to say that they had indeed become “imitators of [Paul and Silas] and of the Lord when [they] received the word in much tribulation” (1 Thess 1:6).")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A tension, however, exists in the Acts narrative in this episode and others like it. While the characters "), _c('i', [_vm._v("outside")]), _vm._v(" the new community might interpret their aims and actions as in direct competition with Rome as a politically seditious movement, this is not the way Luke narrates the view from "), _c('i', [_vm._v("inside")]), _vm._v(" the community. Again, Rowe’s comments along these lines are insightful:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("For Luke, the kingdom is obviously not a “human kingdom” in the straightforward simplistic sense, and in this way the Christian mission does not threaten Rome as did, for example, the Parthian kingdom. Yet, against every Gnosticizing impulse, the vision in Acts is of a kingdom that is every bit as much a human presence as it is a divine work. That is, the kingdom of which Jesus is King is not simply “spiritual” but also material and social, which is to say that it takes up space in public. The very fact of the disturbance in Thessalonica—that this is what happens—attests to the publicly disruptive consequences of the conversions (17:4). There is no such thing, at least in Acts, as being a Christian in private.")])]), _c('p', {
    staticClass: "EX1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The tension that surrounds the earthly nature of the Kingdom mirrors that of the charges against the Christians in Thessalonica. For the opponents’ accusations are at one and the same time both true and false. They are false in that they attempt to place Jesus in competitive relation to Caesar. Such a positioning can only lead to a politics of revolt. The accusations are true, however, in that the Christian mission entails a call to another way of life, one that is—on virtually every page of the Acts of the Apostles—turning the world upside down.")]), _c('a', {
    attrs: {
      "id": "fn34"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("These sorts of accusations put the city officials in an awkward spot. Apparently eager to avoid their own loyalty to Rome being called into question, "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("they demand security money from Jason and the rest to guarantee that they will behave, before they let them go. Verse 10 seems to indicate that their guarantee was constituted in part by Paul and Silas agreeing to leave the city quietly. The whole episode illustrates the kind of social pressure that might plausibly be put on a community in Thessalonica whose public speech and arguments about a crucified and raised Jewish messiah (i.e., king) might be heard as having unsettling political and cultural implications, "), _c('i', [_vm._v("even if this was not the intent.")]), _vm._v(" Given that this canonical story raises the issue for us, a slightly fuller description of first-century Thessalonica and its sociopolitical context than Luke’s story offers will be helpful as we move forward.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "intro4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#intro4"
    }
  }, [_vm._v("The Sociopolitical Context in Thessalonica")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In Thessalonica, which had been granted the status of a free city, there was on offer a salvation story that would have been heard alongside of Paul’s “good news” ("), _c('i', [_vm._v("euangelion")]), _vm._v(") of God’s “salvation” ("), _c('i', [_vm._v("sōtēria")]), _vm._v("). It was the imperial “good news,”"), _c('a', {
    attrs: {
      "id": "fn35"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35"
    }
  }, [_vm._v("35")])]), _vm._v(" a story about a savior ("), _c('i', [_vm._v("sōtēr")]), _vm._v("), a son of a god (Augustus) who had brought peace and security to the empire and whose coming was indeed “glad tidings” ("), _c('i', [_vm._v("euangelia")]), _vm._v(") for the world."), _c('a', {
    attrs: {
      "id": "fn36"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36"
    }
  }, [_vm._v("36")])]), _vm._v(" From Augustus onward, "), _c('i', [_vm._v("kyrios")]), _vm._v(" (lord) was used as an imperial honorific, and Augustus’s successors could also be called "), _c('i', [_vm._v("sōtēr")]), _vm._v(" (savior). Both titles were rooted in the larger salvific narrative, where the inhabitants of the empire were depicted as having been granted "), _c('i', [_vm._v("charis")]), _vm._v(" (grace or favor) by their benefactor, Caesar. As beneficiaries of the peace and security that the empire provided, they were to respond with loyalty to the emperor, the head of the imperial household, the primary "), _c('i', [_vm._v("kyrios")]), _vm._v(" to whom one owed loyalty.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This political setup was theologically legitimated in that the current emperor, even if not always conceived as divine in some parts of the empire, was understood as the elect agent of the gods who had shown favor to him (and through him, to Rome). The perpetuity of the empire and its values (i.e., the present world order) was guaranteed by a form of “realized eschatology”"), _c('a', {
    attrs: {
      "id": "fn37"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37"
    }
  }, [_vm._v("37")])]), _vm._v(" in "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("that imperial propaganda depicted Augustus and his rule as representing “the culmination of Providence in the universal history of humankind,”")]), _c('a', {
    attrs: {
      "id": "fn38"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38"
    }
  }, [_vm._v("38")])]), _vm._v(" the new age of peace and security. In addition, when Paul wrote 1 and 2 Thessalonians, Augustus was understood to have experienced a postmortem translation and was depicted as still exercising his universal rule in the presence of his deified father, Julius Caesar."), _c('a', {
    attrs: {
      "id": "fn39"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39"
    }
  }, [_vm._v("39")])]), _vm._v(" He could be petitioned in prayer and would continue to foster the development of human reason as he maintained the sociopolitical status quo, legitimating the rule of his successors."), _c('a', {
    attrs: {
      "id": "fn40"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One can recognize a number of similarities between the language and concepts of the sociopolitical world of the Roman Empire and Paul’s language in 1 and 2 Thessalonians and his other letters. It is possible that the use of at least some of these terms by Paul and other early Christians could have derived from the LXX rather than being borrowed directly from this sociopolitical language that was in the cultural air. It seems likely, however, that in 1 and 2 Thessalonians Paul may have deliberately used language current in the sociopolitical realm as “reactive discourse,” that is, as a reaction to the suffering of his audience caused by their refusal to participate in “normal” Greco-Roman life. Doing so would have been a way of sustaining the present faithfulness of his suffering audience by asserting that Christian hope is finally superior to any imperial (Roman or otherwise) “realized” hope."), _c('a', {
    attrs: {
      "id": "fn41"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41"
    }
  }, [_vm._v("41")])]), _vm._v(" Again, such language is not “coup” language but language that seeks to fund and sustain a present, public pattern of ecclesial life that is visibly different from the “normal” life undergirded by Roman imperial ideology and pagan religiosity. One might imagine that, if the appropriate Roman officials somehow became aware of such a group regularly using this sort of language, they might indeed interpret it (rightly!) as putting them on notice that they were allowed to exist by the Creator God of Israel and that their tendency to absolutize their power stood opposed to that God and would result in God shortening their days."), _c('a', {
    attrs: {
      "id": "fn42"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I have chosen to highlight the particular historical information above on the social and political context of Thessalonica because I believe that it will help facilitate a theologically fruitful engagement with 1 and 2 Thessalonians throughout both letters."), _c('a', {
    attrs: {
      "id": "fn43"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43"
    }
  }, [_vm._v("43")])]), _vm._v(" Clearly, numerous other matters could be treated in "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("this introduction (e.g., background on the various religious cults in Thessalonica)")]), _c('a', {
    attrs: {
      "id": "fn44"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44"
    }
  }, [_vm._v("44")])]), _vm._v(" that might turn out to be important in the interpretation of the letters. If need be, I will introduce such material at the appropriate places. For now, however, we have enough introductory material on the table to begin our engagement with these two epistles.")]), _vm._v(" "), _c('p', {
    staticClass: "imageL3"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". There are now far too many contributions to the conversation to mention them all. A sampling of some of the more important would include Billings, "), _c('i', [_vm._v("The Word of God;")]), _vm._v(" Green, "), _c('i', [_vm._v("Practicing Theological Interpretation;")]), _vm._v(" Hays, “Reading the Bible”; Fowl, "), _c('i', [_vm._v("Theological Interpretation;")]), _vm._v(" Jenson, "), _c('i', [_vm._v("Canon and Creed;")]), _vm._v(" Rae, “On Reading Scripture” and “Texts in Context”; Treier, "), _c('i', [_vm._v("Introducing Theological Interpretation;")]), _vm._v(" Vanhoozer, "), _c('i', [_vm._v("Dictionary for Theological Interpretation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". The rest of this paragraph is adapted from the opening paragraph of my “Theological Interpretation of the Gospels,” 962.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". What is entailed in a “missional” interpretation of Scripture is also the current subject of a robust conversation. For an overview of the conversation through 2008, see Hunsberger, “Starting Points.” A sampling of voices in the conversation include Barram, “The Bible, Mission”; Brownson, "), _c('i', [_vm._v("Speaking the Truth;")]), _vm._v(" Goheen, “Continuing Steps” and "), _c('i', [_vm._v("Light to the Nations;")]), _vm._v(" Guder, “Missional Hermeneutics: The Missional Authority of Scripture” and “Missional Hermeneutics: The Missional Vocation of the Congregation”; C. J. H. Wright, "), _c('i', [_vm._v("The Mission of God.")]), _vm._v(" For a recent overview of the whole conversation surrounding the missional church, see Van Gelder and Zscheile, "), _c('i', [_vm._v("The Missional Church")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". On which, see Flett, "), _c('i', [_vm._v("The Witness of God;")]), _vm._v(" McCormick, “The Church after the Likeness”; Noble, “The Mission.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". See Guder, who argues that this purpose is primary in all the written testimonies that constitute the NT (“Missional Hermeneutics: The Missional Authority of Scripture,” 113–14).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Hunsberger, “Starting Points.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". For similar ways of framing the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" see C. J. H. Wright, "), _c('i', [_vm._v("The Mission of God;")]), _vm._v(" Goheen, “Continuing Steps.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". On this way of putting the matter, see Fretheim, "), _c('i', [_vm._v("Creation Untamed,")]), _vm._v(" 9–38.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". Rowe, "), _c('i', [_vm._v("World,")]), _vm._v(" 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". Flett, "), _c('i', [_vm._v("The Witness of God;")]), _vm._v(" Gunton, "), _c('i', [_vm._v("Act and Being;")]), _vm._v(" Webster, "), _c('i', [_vm._v("Holiness,")]), _vm._v(" 39–40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". While I cannot defend this claim here, I do not believe that social or theological locatedness necessarily leads to viciously circular interpretations of Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". See the more detailed discussion in Malherbe, 71–74, 349–50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". For examples and evaluations of both epistolary and rhetorical analysis along these lines, see the essays in Donfried and Beutler, "), _c('i', [_vm._v("The Thessalonians Debate")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". See Malherbe, "), _c('i', [_vm._v("Ancient Epistolary Theorists")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Rhetoric whose primary purpose is to persuade or dissuade an audience about future actions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16"
    }
  }, [_vm._v("16")]), _vm._v(". Rhetoric whose primary purpose is to give praise or blame and that encourages an audience to agree with or reject some value in the present.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17"
    }
  }, [_vm._v("17")]), _vm._v(". The most recent example I know of is Witherington. While there is much to commend in his commentary, it is not clear to me that the place Witherington gives to this sort of approach adds significantly to the actual content of his interpretation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18"
    }
  }, [_vm._v("18")]), _vm._v(". See the similar perspectives of Reed (“Using Ancient Rhetorical Categories,” 292–324, esp. 322) and Porter (“The Theoretical Justification,” 100–122).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Recent interpreters who argue for its authenticity include Foster, “Who Wrote 2 Thessalonians?”; Nicholl, "), _c('i', [_vm._v("From Hope to Despair,")]), _vm._v(" 3–16; Malherbe, 349–74; Witherington, 9–16; Fee, 238–41; Marshall, 28–45. For the opposite view, see Richard (19–29), Furnish (131–37), and Gaventa (93–95).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20"
    }
  }, [_vm._v("20")]), _vm._v(". One might say something similar with regard to attempts to address the differences between the two letters (particularly with regard to their eschatological scenarios) by arguing that 2 Thessalonians was written and sent prior to 1 Thessalonians. Although not the first to put it forward, see Wanamaker’s sustained argument for this position (37–45) and Malherbe’s critical response to such arguments (61–64).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21"
    }
  }, [_vm._v("21")]), _vm._v(". A sentence modified from Fowl, "), _c('i', [_vm._v("Philippians,")]), _vm._v(" 12 (my italics).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22"
    }
  }, [_vm._v("22")]), _vm._v(". Rowe, "), _c('i', [_vm._v("World,")]), _vm._v(" esp. 24–27, 91–137.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Rowe, "), _c('i', [_vm._v("World,")]), _vm._v(" 18 (my italics).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24"
    }
  }, [_vm._v("24")]), _vm._v(". While it is striking how closely this section of Acts coheres with what we learn about the church in Thessalonica from 1 Thessalonians, I am not convinced that all the details as Acts presents them can be persuasively reconciled with those in these letters (e.g., the travel details). In my view, however, these details and attempts to reconcile them hold little, if any, theological importance.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25"
    }
  }, [_vm._v("25")]), _vm._v(". On the historical issues involved in the depiction in Acts of Paul’s appealing to Roman citizenship, see Witherington, "), _c('i', [_vm._v("Acts,")]), _vm._v(" 499–502.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26"
    }
  }, [_vm._v("26")]), _vm._v(". The issue relates to an ambiguity in v. 4. The NRSV is typical in rendering the verse “Some of them were persuaded and joined Paul and Silas, as did a great many of the devout Greeks and not a few of the leading women.” This translation makes good sense of the syntax of the verse. But the verse might also be rendered by taking the first "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τε")]), _vm._v(" ("), _c('i', [_vm._v("te,")]), _vm._v(" “namely”) epexegetically: “Some of them were persuaded and joined Paul and Silas, namely ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τε")]), _vm._v(", "), _c('i', [_vm._v("te")]), _vm._v("], a great number of God-fearers and not a few leading women.” Briefly put, the ambiguity lies in the meaning of the some “of them” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐξ αὐτῶν")]), _vm._v(", "), _c('i', [_vm._v("ex autōn")]), _vm._v(") who “were persuaded” in v. 4. Does it refer to some of the Jews from the synagogue with whom Paul was arguing, or only to some out of the number of people who were gathered in the synagogue, who are then specifically identified as a great many devout Greeks (i.e., God-fearers) and a good many leading (almost assuredly Greek) women who had been attracted to the synagogue? In the latter case, the “some persuaded” would include no Jews from Thessalonica.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27"
    }
  }, [_vm._v("27")]), _vm._v(". While some understand the rhetoric of 1 Thessalonians on its own as referring exclusively to Gentile males (e.g., Fatum, “Brotherhood in Christ”; Bridges, “Terms of Endearment”; Ascough, “The Thessalonian Christian Community”), it need not be understood that way, whether or not one brings in Luke’s claim in 17:4 that the community at least initially contained some leading (Gentile) women (so also Furnish, 30).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28"
    }
  }, [_vm._v("28")]), _vm._v(". Aspects of the Thessalonian correspondence (1 Thess 2:9–12, 17, 19–20), as well as the travel implications of Phil 4:16, seem to imply that Paul was in the city longer than simply over three Sabbaths (see Fee, 6–7).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29"
    }
  }, [_vm._v("29")]), _vm._v(". Witherington, "), _c('i', [_vm._v("Acts,")]), _vm._v(" 506.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30"
    }
  }, [_vm._v("30")]), _vm._v(". Witherington, "), _c('i', [_vm._v("Acts,")]), _vm._v(" 506.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31"
    }
  }, [_vm._v("31")]), _vm._v(". Rowe, "), _c('i', [_vm._v("World,")]), _vm._v(" 96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32"
    }
  }, [_vm._v("32")]), _vm._v(". Rowe, "), _c('i', [_vm._v("World,")]), _vm._v(" 97.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33"
    }
  }, [_vm._v("33")]), _vm._v(". For example, it is historically plausible that the content of “the decrees of Caesar” might have forbidden predicting the change of emperors, with the result that language like that of 1 Thess 4:13–18 and Paul’s references to the Lord’s royal coming in 2 Thess 1–2 might have been heard as being in tension with such imperial decrees. Or perhaps, as Harrison maintains, following E. A. Judge, the hostile reaction is better explained against the background of the crowds’ fear that failure to take action against this Christian community would violate oaths of loyalty they might have taken to the emperor ("), _c('i', [_vm._v("Paul and the Imperial Authorities,")]), _vm._v(" 52–54). But this suggestion remains speculative (see Rowe, "), _c('i', [_vm._v("World,")]), _vm._v(" 96–97).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34"
    }
  }, [_vm._v("34")]), _vm._v(". Rowe, "), _c('i', [_vm._v("World,")]), _vm._v(" 101–2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35"
    }
  }, [_vm._v("35")]), _vm._v(". For the details of much of what follows, I am in debt to Harrison, “Paul and the Imperial Gospel,” 71–96, and his enlargement of this earlier article in "), _c('i', [_vm._v("Paul and the Imperial Authorities")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36"
    }
  }, [_vm._v("36")]), _vm._v(". The particular Greek terms in this sentence come from the Priene provincial calendar inscription (on which, see Harrison, "), _c('i', [_vm._v("Paul and the Imperial Authorities,")]), _vm._v(" 63–65), but the ideas implied in the inscription could be expressed with other language.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37"
    }
  }, [_vm._v("37")]), _vm._v(". In using this sort of language, I do not mean that there was some sort of unified system of beliefs that represented “Roman imperial eschatology” (see the nuanced comments of Bryan, "), _c('i', [_vm._v("Render to Caesar,")]), _vm._v(" 117–18). I am simply using such language heuristically to describe some of the popular concepts that would have been “in the air” in first-century Thessalonica.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38"
    }
  }, [_vm._v("38")]), _vm._v(". Again, see Harrision, "), _c('i', [_vm._v("Paul and the Imperial Authorities,")]), _vm._v(" 63–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39"
    }
  }, [_vm._v("39")]), _vm._v(". Indeed, one inscription has him “shining with the brilliance of the great heavenly savior” (Harrison, “Paul and the Imperial Gospel,” 90).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40"
    }
  }, [_vm._v("40")]), _vm._v(". Harrison, “Paul and the Imperial Gospel,” 89–95, and "), _c('i', [_vm._v("Paul and the Imperial Authorities,")]), _vm._v(" 63–68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41"
    }
  }, [_vm._v("41")]), _vm._v(". Oakes, “Re-mapping,” 318.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42"
    }
  }, [_vm._v("42")]), _vm._v(". Bryan, "), _c('i', [_vm._v("Render to Caesar,")]), _vm._v(" 125 and throughout.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43"
    }
  }, [_vm._v("43")]), _vm._v(". Not everyone agrees with my judgment on this point. For a sustained critique of interpreting Paul using the sort of political categories I am suggesting, see Kim, "), _c('i', [_vm._v("Christ and Caesar.")]), _vm._v(" Harrison rightly critiques Kim on several points ("), _c('i', [_vm._v("Paul and the Imperial Authorities,")]), _vm._v(" 6–8); in my view, Carter’s critique of Kim is not only incisive but devastating ("), _c('a', {
    attrs: {
      "href": "http://www.bookreviews.org/pdf/6957_7550.pdf",
      "target": "_blank"
    }
  }, [_vm._v("www.bookreviews.org/pdf/6957_7550.pdf")]), _vm._v("). Coming from a different slant in a recent article, Miller has argued that there is “absolutely "), _c('i', [_vm._v("no evidence")]), _vm._v("” (his italics) for an imperial temple in Thessalonica (“Imperial Cult,” 322). However, given that at least some fragmentary evidence in Thessalonica seems to indicate the presence of a first-century temple dedicated to the imperial cult (see Miller, 322n25, and Hendrix, “Archaeology,” 115), he may have overstated his case. But even if there was no official imperial temple in Thessalonica at the time Paul was there, it does not mean that the imperial cult was absent from civic life (see Harrison, "), _c('i', [_vm._v("Paul and the Imperial Authorities,")]), _vm._v(" 55–56).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "rfn44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44"
    }
  }, [_vm._v("44")]), _vm._v(". On which, see Donfried and Marshall, "), _c('i', [_vm._v("The Theology,")]), _vm._v(" 12–15.")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "bib"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#bib"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara2a"
  }, [_vm._v("With the exception of Chrysostom, commentaries on 1 and 2 Thessalonians are cited by author’s name only. To avoid confusion, citations of Chrysostom will reference the particular homily from which the citation comes. All other works will be cited by author’s name and short title only.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara-x",
    attrs: {
      "id": "bib1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#bib1"
    }
  }, [_c('b', [_vm._v("Commentaries on 1 and 2 Thessalonians")])])]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Beale, G. K. "), _c('i', [_vm._v("1–2 Thessalonians.")]), _vm._v(" IVPNTC. Downers Grove, IL: InterVarsity Press, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bridges, Linda McKinnish. "), _c('i', [_vm._v("1 and 2 Thessalonians.")]), _vm._v(" SHBC. Macon, GA: Smyth & Helwys, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bruce, F. F. "), _c('i', [_vm._v("1–2 Thessalonians.")]), _vm._v(" WBC 45. Waco, Texas: Word, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Chrysostom, John. "), _c('i', [_vm._v("Homilies on First and Second Thessalonians.")]), _vm._v(" Translated by John A. Broadus. In "), _c('i', [_vm._v("The Nicene and Post-Nicene Fathers,")]), _vm._v(" Series 1. 14 vols. Edited by Philip Schaff. 1886–89. Repr. Peabody, MA: Hendrickson, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Constable, Thomas. “1 Thessalonians,” “2 Thessalonians.” In "), _c('i', [_vm._v("The Bible Knowledge Commentary: New Testament,")]), _vm._v(" ed. John Walvoord and Roy B. Zuck, 687–725. Wheaton, IL: Victor Books, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Dibelius, Martin. "), _c('i', [_vm._v("An die Thessalonicher I. II. An die Philipper.")]), _vm._v(" 3rd ed. HNT 11. Tübingen: Mohr Siebeck, 1937.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Fee, Gordon D. "), _c('i', [_vm._v("The First and Second Letters to the Thessalonians.")]), _vm._v(" NICNT. Grand Rapids: Eerdmans, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Furnish, Victor Paul. "), _c('i', [_vm._v("1 Thessalonians, 2 Thessalonians.")]), _vm._v(" ANTC. Nashville: Abingdon, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Gaventa, Beverly. "), _c('i', [_vm._v("First and Second Thessalonians.")]), _vm._v(" IBC. Louisville: John Knox, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Green, Gene L. "), _c('i', [_vm._v("The Letters to the Thessalonians.")]), _vm._v(" PNTC. Grand Rapids: Eerdmans, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Holtz, Traugott. "), _c('i', [_vm._v("Der erste Brief an die Thessalonicher.")]), _vm._v(" 3rd ed. EKKNT 13. Zürich: Benziger Verlag; Neukirchen-Vluyn: Neukirchener Verlag, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Malherbe, Abraham. "), _c('i', [_vm._v("The Letters to the Thessalonians.")]), _vm._v(" AB. New York: Doubleday, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Marshall, I. Howard. "), _c('i', [_vm._v("1 and 2 Thessalonians.")]), _vm._v(" NCB. Grand Rapids: Eerdmans, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Marxsen, Willi. "), _c('i', [_vm._v("Der Erste Brief an die Thessalonicher.")]), _vm._v(" ZBK 11/1. Zürich: Theologischer Verlag, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Richard, Earl J. "), _c('i', [_vm._v("First and Second Thessalonians.")]), _vm._v(" SP. Collegeville, MN: Liturgical Press, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Rigaux, Beda. "), _c('i', [_vm._v("Saint Paul: Les Épîtres aux Thessaloniciens.")]), _vm._v(" ÉBib. Paris: Gabalda, 1956.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Thiselton, Anthony. "), _c('i', [_vm._v("1 and 2 Thessalonians through the Centuries.")]), _vm._v(" Blackwell Bible Commentaries. Malden, MA: Wiley-Blackwell, 2011.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Thomas, Robert L. “1 Thessalonians,” “2 Thessalonians.” In "), _c('i', [_vm._v("The Expositor’s Bible Commentary,")]), _vm._v(" vol. 11, ed. Frank E. Gaebelein, 229–337. Grand Rapids: Zondervan, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wanamaker, Charles A. "), _c('i', [_vm._v("The Epistles to the Thessalonians.")]), _vm._v(" NIGTC. Grand Rapids: Eerdmans, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Witherington, Ben. "), _c('i', [_vm._v("1 and 2 Thessalonians: A Socio-Rhetorical Commentary.")]), _vm._v(" Grand Rapids: Eerdmans, 2006.")])]), _c('p', {
    staticClass: "HPara-x",
    attrs: {
      "id": "bib2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#bib2"
    }
  }, [_c('b', [_vm._v("Other Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Allison, Dale. “Day of the Lord.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 1:46–47.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Anderson, Gary A. “Ezekiel 28, the Fall of Satan, and the Adam Books.” In "), _c('i', [_vm._v("Literature on Adam and Eve: Collected Essays,")]), _vm._v(" ed. Gary A. Anderson et al., 133–47. Leiden: Brill, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Ascough, Richard S. "), _c('i', [_vm._v("Paul’s Macedonian Associations: The Social Context of Philippians and 1 Thessalonians.")]), _vm._v(" WUNT 2/161. Tübingen: Mohr Siebeck, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Thessalonian Christian Community as a Professional Voluntary Association.” "), _c('i', [_vm._v("JBL")]), _vm._v(" 119 (2000): 311–28.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Baker, Mark D., and Joel B. Green. "), _c('i', [_vm._v("Recovering the Scandal of the Cross: Atonement in New Testament and Contemporary Contexts.")]), _vm._v(" 2nd ed. Downers Grove, IL: IVP Academic, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Barclay, John M. G. “Conflict in Thessalonica.” "), _c('i', [_vm._v("CBQ")]), _vm._v(" 55 (1993): 512–30.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Thessalonica and Corinth: Social Contrasts in Pauline Christianity.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 47 (1992): 49–74.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Barram, Michael. “The Bible, Mission, and Social Location: Toward a Missional Hermeneutic.” "), _c('i', [_vm._v("Int")]), _vm._v(" 61 (2007): 42–58.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Barrett, C. K. "), _c('i', [_vm._v("A Critical and Exegetical Commentary on the Acts of the Apostles,")]), _vm._v(" Vol. 2. ICC. Edinburgh: T&T Clark, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Barton, Stephen C. “Dislocating and Relocating Holiness: A New Testament Study.” In "), _c('i', [_vm._v("Holiness Past and Present,")]), _vm._v(" ed. Stephen C. Barton, 193–213. London: T&T Clark, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bassler, Jouette M. “The Enigmatic Sign: 2 Thessalonians 1:5.” "), _c('i', [_vm._v("CBQ")]), _vm._v(" 46 (1984): 496–510.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bauckham, Richard. "), _c('i', [_vm._v("Jesus and the God of Israel: “God Crucified” and Other Studies on the New Testament’s Christology of Divine Identity.")]), _vm._v(" Grand Rapids: Eerdmans, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Millennium.” In "), _c('i', [_vm._v("God Will Be All in All: The Eschatology of Jürgen Moltmann,")]), _vm._v(" ed. Richard J. Bauckham, 123–48; Edinburgh: T&T Clark, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Theology of the Book of Revelation.")]), _vm._v(" Cambridge: Cambridge University Press, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bauckham, Richard, and Trevor Hart, "), _c('i', [_vm._v("Hope against Hope: Christian Eschatology at the Turn of the Millennium.")]), _vm._v(" Grand Rapids: Eerdmans, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Beale, G. K. "), _c('i', [_vm._v("The Temple and the Church’s Mission: A Biblical Theology of the Dwelling Place of God.")]), _vm._v(" NSBT 17. Downers Grove, IL: InterVarsity Press, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Billings, J. Todd. The "), _c('i', [_vm._v("Word of God for the People of God: An Entryway to the Theological Interpretation of Scripture.")]), _vm._v(" Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bingaman, Brock. “Learning from "), _c('i', [_vm._v("Left Behind?")]), _vm._v(" A Call for Coherent Accounts of Scripture.” "), _c('i', [_vm._v("AThR")]), _vm._v(" 91 (2009): 255–72.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Blackwell, Ben G. "), _c('i', [_vm._v("Christosis: Pauline Soteriology in Light of Deification in Irenaeus and Cyril of Alexandria.")]), _vm._v(" WUNT 2/314. Tübingen: Mohr Seibeck, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("———. “Immortal Glory and the Problem of Death in Romans 3:23.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 32 (2010): 285–308.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Blaising, Craig, and Darrell Bock, "), _c('i', [_vm._v("Progressive Dispensationalism.")]), _vm._v(" Wheaton, IL: BridgePoint, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Blevins, Dean G. “Neuroscience, John Wesley, and the Christian Life.” "), _c('i', [_vm._v("WesTJ")]), _vm._v(" 44 (2009): 219–47.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bockmuehl, Markus. “1 Thessalonians 2:14–16 and the Church in Jerusalem.” "), _c('i', [_vm._v("TynBul")]), _vm._v(" 52 (2001): 1–31.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Boone, Dan. "), _c('i', [_vm._v("The Way We Work: How Faith Makes a Difference on the Job.")]), _vm._v(" Kansas City: Beacon Hill, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bowers, Paul. “Church and Mission in Paul.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 44 (1991): 89–111.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bridges, Linda M. “Terms of Endearment: Paul’s Words of Comfort in First Thessalonians.” "), _c('i', [_vm._v("RevExp")]), _vm._v(" 96 (1999): 211–32.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Brinton, Henry G. “We Worship the God of Security.” "), _c('i', [_vm._v("USA Today,")]), _vm._v(" October 18, 2010, ")]), _c('a', {
    attrs: {
      "href": "http://www.usatoday.com/news/opinion/forum/2010-10-18-column18_ST_N.htm",
      "target": "_blank"
    }
  }, [_vm._v("www.usatoday.com/news/opinion/forum/2010-10-18-column18_ST_N.htm")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Brower, Kent. "), _c('i', [_vm._v("Living as God’s Holy People: Holiness and Community in Paul.")]), _vm._v(" Milton Keynes, UK: Paternoster, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Brown, Warren, and Brad Strawn. "), _c('i', [_vm._v("The Physical Nature of Christian Life: Neuroscience, Psychology, and the Church.")]), _vm._v(" Cambridge: Cambridge University Press, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Brownson, James V. "), _c('i', [_vm._v("Speaking the Truth in Love: New Testament Resources for a Missional Hermeneutic.")]), _vm._v(" Harrisburg, PA: Trinity Press International, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bruckner, James K. “Justice in Scripture.” "), _c('i', [_vm._v("ExAud")]), _vm._v(" 22 (2006): 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bryan, Christopher. "), _c('i', [_vm._v("Render to Caesar: Jesus, the Early Church, and the Roman Superpower.")]), _vm._v(" Oxford: Oxford University Press, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Bumstead, Elaine. “Pure Grace: A Simple Well Helps a Bangladeshi Congregation Break Down Barriers and Pour Out Hope.” "), _c('i', [_vm._v("NCM Magazine,")]), _vm._v(" Summer 2011, 14–16.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Burke, Trevor J. "), _c('i', [_vm._v("Family Matters: A Socio-Historical Study of Kinship Metaphors in 1 Thessalonians.")]), _vm._v(" JSNTSup 247. London: T&T Clark, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Burridge, Richard A. "), _c('i', [_vm._v("Imitating Jesus: An Inclusive Approach to New Testament Ethics.")]), _vm._v(" Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Byrne, Brendan. "), _c('i', [_vm._v("Romans.")]), _vm._v(" SP. Collegeville, MN: Liturgical Press, 1996.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Byrskog, Samuel. “Co-Senders, Co-Authors, and Paul’s Use of the First Person Plural.” "), _c('i', [_vm._v("ZNW")]), _vm._v(" 87 (1996): 230–50.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Campbell, Douglas A. "), _c('i', [_vm._v("The Deliverance of God: An Apocalyptic Rereading of Justification in Paul.")]), _vm._v(" Grand Rapids: Eerdmans, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Quest for Paul’s Gospel: A Suggested Strategy.")]), _vm._v(" JSNTSup 274. London: T&T Clark, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Carter, Warren. Review of "), _c('i', [_vm._v("Christ and Caesar: The Gospel and the Roman Empire in the Writings of Paul and Luke,")]), _vm._v(" by Seyoon Kim. "), _c('i', [_vm._v("RBL,")]), _vm._v(" July 2009, "), _c('a', {
    attrs: {
      "href": "http://www.bookreviews.org/pdf/6957_7550.pdf",
      "target": "_blank"
    }
  }, [_vm._v("www.bookreviews.org/pdf/6957_7550.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Castelli, Elizabeth A. "), _c('i', [_vm._v("Imitating Paul: A Discourse of Power.")]), _vm._v(" Literary Currents in Biblical Interpretation. Louisville: Westminster John Knox, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Cavanaugh, William T. "), _c('i', [_vm._v("Torture and Eucharist: Theology, Politics, and the Body of Christ.")]), _vm._v(" Malden, MA: Blackwell, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Cohick, Lynn H. "), _c('i', [_vm._v("Women in the World of the Earliest Christians: Illuminating Ancient Ways of Life.")]), _vm._v(" Grand Rapids: Baker Academic, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Cooper, David L. "), _c('i', [_vm._v("When Gog’s Armies Meet the Almighty in the Land of Israel.")]), _vm._v(" Los Angeles: Biblical Research Society, 1940.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Cosby, Michael R. “Hellenistic Formal Receptions and Paul’s Use of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ΑΠΑΝΤΗΣΙΣ")]), _vm._v(" in 1 Thessalonians 4:17.” "), _c('i', [_vm._v("BBR")]), _vm._v(" 4 (1994): 15–34.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Crump, David. "), _c('i', [_vm._v("Knocking on Heaven’s Door: A New Testament Theology of Petitionary Prayer.")]), _vm._v(" Grand Rapids: Baker Academic, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Dabney, D. L. “ ‘Justified by the Spirit’: Soteriological Reflections on the Resurrection.” "), _c('i', [_vm._v("IJST")]), _vm._v(" 3 (2001): 46–68.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Dempsey, Michael T., ed., "), _c('i', [_vm._v("Trinity and Election in Contemporary Theology.")]), _vm._v(" Grand Rapids: Eerdmans, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("deSilva, David. “ ‘Worthy of His Kingdom’: Honor Discourse and Social Engineering in 1 Thessalonians.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 64 (1996): 49–79.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Donfried, Karl P. “The Cults of Thessalonica and the Thessalonian Correspondence.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 31 (1985): 342–52.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Imperial Cults of Thessalonica and Political Conflict in 1 Thessalonians.” In "), _c('i', [_vm._v("Paul and Empire: Religion and Power in Roman Imperial Society,")]), _vm._v(" ed. Richard A. Horsley, 215–23. Harrisburg, PA: Trinity, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Donfried, Karl P., and Johannes Beutler, eds. "), _c('i', [_vm._v("The Thessalonians Debate: Methodological Discord or Methodological Synthesis?")]), _vm._v(" Grand Rapids: Eerdmans, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Donfried, Karl P., and I. Howard Marshall. "), _c('i', [_vm._v("The Theology of the Shorter Pauline Letters.")]), _vm._v(" Cambridge: Cambridge University Press, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Dunn, James D. G. “Christ, Adam, and Preexistence.” In "), _c('i', [_vm._v("Where Christology Began: Essays on Philippians 2,")]), _vm._v(" ed. R. P. Martin and Brian J. Dodd, 74–83. Louisville: Westminster John Knox, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Cults of Thessalonica and the Thessalonian Correspondence.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 31 (1985): 342–52.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ΕΚ ΠΙΣΤΕΩΣ")]), _vm._v(": A Key to the Meaning of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ΠΙΣΤΙΣ ΧΡΙΣΤΟΥ")]), _vm._v("” In "), _c('i', [_vm._v("The Word Leaps the Gap,")]), _vm._v(" ed. J. Ross Wagner, C. Kavin Rowe, and A. Katherine Grieb, 351–66. Grand Rapids: Eerdmans, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Theology of Paul the Apostle.")]), _vm._v(" Grand Rapids: Eerdmans, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Easter, Matthew C. “The "), _c('i', [_vm._v("Pistis Christou")]), _vm._v(" Debate: Main Arguments and Responses in Summary.” "), _c('i', [_vm._v("Currents in Biblical Research")]), _vm._v(" 9 (2010): 33–47.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Eastman, Susan. “Imitating Christ.” In "), _c('i', [_vm._v("The Word Leaps the Gap,")]), _vm._v(" ed. J. Ross Wagner, C. Kavin Rowe, and A. Katherine Grieb, 427–51. Grand Rapids: Eerdmans, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Edgar, Thomas R. “The Meaning of ‘Sleep’ in 1 Thessalonians 5:10.” "), _c('i', [_vm._v("JETS")]), _vm._v(" 22 (1979): 345–49.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Ellis, J. Edward. "), _c('i', [_vm._v("Paul and Ancient Views of Sexual Desire: Paul’s Sexual Ethics in 1 Thessalonians 4, 1 Corinthians 7, and Romans 1.")]), _vm._v(" LNTS 354. London: T&T Clark, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Engberg-Pederson, Troels. "), _c('i', [_vm._v("Cosmology and Self in the Apostle Paul: The Material Spirit.")]), _vm._v(" Oxford: Oxford University Press, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Fatum, Lone. “Brotherhood in Christ: A Gender Hermeneutic Reading of 1 Thessalonians.” In "), _c('i', [_vm._v("Constructing Early Christian Families: Families as Social Reality and Metaphor,")]), _vm._v(" ed. H. Moxnes, 183–97. London: Routledge, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Fee, Gordon. "), _c('i', [_vm._v("God’s Empowering Presence: The Holy Spirit in the Letters of Paul.")]), _vm._v(" Peabody, MA: Hendrickson, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Paul’s Letter to the Philippians.")]), _vm._v(" NICNT. Grand Rapids: Eerdmans, 1995.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("———. "), _c('i', [_vm._v("To What End Exegesis? Essays Textual, Exegetical, and Theological.")]), _vm._v(" Grand Rapids: Eerdmans, 2011.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Finlan, Stephen. “Can We Speak of "), _c('i', [_vm._v("Theosis")]), _vm._v(" in Paul?” In "), _c('i', [_vm._v("Partakers of the Divine Nature: The History and Development of Deification in the Christian Traditions,")]), _vm._v(" ed. Michael J. Christensen and Jeffery A. Wittung, 81–92. Grand Rapids: Baker, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Finny, Philip. "), _c('i', [_vm._v("The Origins of Pauline Pneumatology: The Eschatological Bestowal of the Spirit upon Gentiles in Judaism and in the Early Development of Paul’s Theology.")]), _vm._v(" WUNT 194. Tübingen: Mohr Siebeck, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Flemming, Dean. "), _c('i', [_vm._v("Philippians: A Commentary in the Wesleyan Tradition.")]), _vm._v(" NBBC. Kansas City: Beacon Hill Press, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Recovering the Full Mission of God: A Biblical Perspective on Being, Doing, and Telling.")]), _vm._v(" Downers Grove, IL: IVP Academic, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Fletcher-Louis, C. H. T. “The Destruction of the Temple and the Relativization of the Old Covenant: Mark 13:31 and Matthew 5:18.” In "), _c('i', [_vm._v("Eschatology in Bible and Theology: Evangelical Essays at the Dawn of a New Millennium,")]), _vm._v(" ed. K. E. Brower and M. W. Elliot, 156–62. Downers Grove, IL: InterVarsity Press, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Flett, John. "), _c('i', [_vm._v("The Witness of God: The Trinity,")]), _vm._v(" Missio Dei, "), _c('i', [_vm._v("Karl Barth, and the Nature of Christian Community.")]), _vm._v(" Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Foster, Paul. “Who Wrote 2 Thessalonians? A Fresh Look at an Old Problem.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 35 (2012): 150–75.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Fowl, Stephen E. “A Metaphor in Distress: A Reading of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ΝΗΠΙΟΙ")]), _vm._v(" in 1 Thessalonians 2.7.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 36 (1990): 469–73.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Philippians.")]), _vm._v(" THNTC. Grand Rapids: Eerdmans, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Theological Interpretation of Scripture.")]), _vm._v(" Eugene, OR: Cascade Books, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Fredrickson, David. “Passionless Sex in 1 Thessalonians 4:4–5.” "), _c('i', [_vm._v("WW")]), _vm._v(" 23 (2003): 23–30.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Fretheim, Terrence E. "), _c('i', [_vm._v("Creation Untamed: The Bible, God, and Natural Disasters.")]), _vm._v(" Grand Rapids: Baker Academic, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Suffering of God.")]), _vm._v(" OBT. Philadelphia: Fortress, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Theological Reflections on the Wrath of God in the Old Testament.” "), _c('i', [_vm._v("HBT")]), _vm._v(" 24 (2002): 1–26.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Frykholm, Amy J. "), _c('i', [_vm._v("Rapture Culture:")]), _vm._v(" Left Behind "), _c('i', [_vm._v("in Evangelical America.")]), _vm._v(" Oxford: Oxford University Press, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Gaventa, Beverly. "), _c('i', [_vm._v("Our Mother Saint Paul.")]), _vm._v(" Louisville: Westminster John Knox Press, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Giblin, C. H. "), _c('i', [_vm._v("The Threat to Faith: An Exegetical-Theological Re-examination of 2 Thessalonians 2.")]), _vm._v(" AnBib 31. Rome: Pontifical Biblical Institute, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Gilliard, Frank D. “Paul and the Killing of the Prophets in 1 Thess. 2:15.” "), _c('i', [_vm._v("NovT")]), _vm._v(" 36 (1994): 259–70.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Problem of the Antisemitic Comma between 1 Thessalonians 2.14 and 15.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 35 (1989): 481–502.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Goheen, Michael W. “Continuing Steps toward a Missional Hermeneutic.” "), _c('i', [_vm._v("Fideles: A Journal of Redeemer Pacific College")]), _vm._v(" 3 (2008): 49–99.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("A Light to the Nations: The Missional Church and the Biblical Story.")]), _vm._v(" Grand Rapids: Baker Academic, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Gorman, Michael J. “ ‘Although/Because He Was in the Form of God’: The Theological Significance of Paul’s Master Story (Phil 2:6–11).” "), _c('i', [_vm._v("JTI")]), _vm._v(" 1 (2007): 147–69.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("———. "), _c('i', [_vm._v("Cruciformity: Paul’s Narrative Spirituality of the Cross.")]), _vm._v(" Grand Rapids: Eerdmans, 2001.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Inhabiting the Cruciform God: Kenosis, Justification, and")]), _vm._v(" Theosis "), _c('i', [_vm._v("in Paul’s Narrative Soteriology.")]), _vm._v(" Grand Rapids: Eerdmans, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Lord of Peace: Christ Our Peace in Pauline Theology.” "), _c('i', [_vm._v("JSPL")]), _vm._v(" 3 (2013): 219–53.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Reading Paul.")]), _vm._v(" Eugene, OR: Cascade Books, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Reading Revelation Responsibly: Uncivil Worship and Witness; Following the Lamb into the New Creation.")]), _vm._v(" Eugene, OR: Cascade Books, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Romans: The First Christian Treatise on Theosis.” "), _c('i', [_vm._v("JTI")]), _vm._v(" 5 (2011): 13–34.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Saints.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 5:41–43.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “ ‘You Shall Be Cruciform for I Am Cruciform’: Paul’s Trinitarian Reconstruction of Holiness.” In "), _c('i', [_vm._v("Holiness and Ecclesiology in the New Testament,")]), _vm._v(" ed. Kent Brower and Andy Johnson, 148–66. Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Grant, Deena. “Wrath of God.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 5:932–37.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Green, Joel B. "), _c('i', [_vm._v("Body, Soul, and Human Life: The Nature of Humanity in the Bible.")]), _vm._v(" Grand Rapids: Baker Academic, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("First Peter.")]), _vm._v(" THNTC. Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Gospel of Luke.")]), _vm._v(" NICNT. Grand Rapids: Eerdmans, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Practicing Theological Interpretation: Engaging Biblical Texts for Faith and Formation.")]), _vm._v(" Grand Rapids: Eerdmans, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Salvation.")]), _vm._v(" St. Louis: Chalice Press, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Theology of the Gospel of Luke.")]), _vm._v(" Cambridge: Cambridge University Press, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Grieb, A. Katherine. “ ‘The One Who Called You . . .’: Vocation and Leadership in the Pauline Literature.” "), _c('i', [_vm._v("Int")]), _vm._v(" 59 (2005): 154–65.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “ ‘So That in Him We Might Become the Righteousness of God’ (2 Cor 5:21): Some Theological Reflections on the Church Becoming Justice.” "), _c('i', [_vm._v("ExAud")]), _vm._v(" 22 (2006): 58–80.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Guder, Darrell. “Missional Hermeneutics: The Missional Authority of Scripture—Interpreting Scripture as Missional Formation” (with response by Mary Schertz). "), _c('i', [_vm._v("Mission Focus: Annual Review")]), _vm._v(" 15 (2007): 106–24, ")]), _c('a', {
    attrs: {
      "href": "http://www.ambs.edu/files/documents/news-and-publications/publications/mf/Mission_Focus_Vol_15.pdf",
      "target": "_blank"
    }
  }, [_vm._v("www.ambs.edu/files/documents/news-and-publications/publications/mf/Mission_Focus_Vol_15.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Missional Hermeneutics: The Missional Vocation of the Congregation—and How Scripture Shapes That Calling” (with “Response and Waterford Story” by Neil Amstutz). "), _c('i', [_vm._v("Mission Focus: Annual Review")]), _vm._v(" 15 (2007): 125–46, "), _c('a', {
    attrs: {
      "href": "http://www.ambs.edu/files/documents/news-and-publications/publications/mf/Mission_Focus_Vol_15.pdf",
      "target": "_blank"
    }
  }, [_vm._v("www.ambs.edu/files/documents/news-and-publications/publications/mf/Mission_Focus_Vol_15.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Worthy Living: Work and Witness from the Perspective of Missional Church Theology.” "), _c('i', [_vm._v("WW")]), _vm._v(" 25 (2005): 424–32.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Gumerlock, Francis. “A Rapture Citation in the Fourteenth Century.” "), _c('i', [_vm._v("BSac")]), _vm._v(" 159 (2002): 349–62.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Gundry, Robert H. “A Brief Note on ‘Hellenistic Formal Receptions’ and Paul’s Use of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ΑΠΑΝΤΗΣΙΣ")]), _vm._v(" in 1 Thessalonians 4:17.” "), _c('i', [_vm._v("BBR")]), _vm._v(" 6 (1996): 39–41.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Gunton, Colin. "), _c('i', [_vm._v("Act and Being: Towards a Theology of the Divine Attributes.")]), _vm._v(" Grand Rapids: Eerdmans, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Guroian, Vigen. “Salvation: Divine Therapy.” "), _c('i', [_vm._v("TT")]), _vm._v(" 61 (2004): 309–21.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Harink, Douglas. "), _c('i', [_vm._v("Paul among the Postliberals: Pauline Theology beyond Christendom and Modernity.")]), _vm._v(" Grand Rapids: Brazos, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Harrington, Hannah K. "), _c('i', [_vm._v("Holiness: Rabbinic Judaism and the Graeco-Roman World.")]), _vm._v(" New York: Routledge, 2001.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Harrison, James R. "), _c('i', [_vm._v("Paul and the Imperial Authorities at Thessalonica and Rome: A Study in the Conflict of Ideology.")]), _vm._v(" WUNT 273. Tübingen: Mohr Siebeck, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Paul and the Imperial Gospel at Thessaloniki.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 25 (2002): 71–96.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hay, David M. “Paul’s Understanding of Faith as Participation.” In "), _c('i', [_vm._v("Paul and His Theology,")]), _vm._v(" ed. Stanley E. Porter, 45–76. Leiden: Brill, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hays, Richard B. “Christology and Ethics in Galatians: The Law of Christ.” "), _c('i', [_vm._v("CBQ")]), _vm._v(" 49 (1987): 268–90.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Conversion of the Imagination: Scripture and Eschatology in Corinth.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 45 (1999): 391–412.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Faith of Jesus Christ: The Narrative Substructure of Galatians 3:1–4:11.")]), _vm._v(" 2nd ed. Grand Rapids: Eerdmans, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("First Corinthians.")]), _vm._v(" IBC. Louisville: John Knox, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Reading Scripture in Light of the Resurrection.” In "), _c('i', [_vm._v("The Art of Reading Scripture,")]), _vm._v(" ed. Ellen F. Davis and Richard B. Hays, 216–38. Grand Rapids: Eerdmans, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Reading the Bible with Eyes of Faith: The Practice of Theological Exegesis.” "), _c('i', [_vm._v("JTI")]), _vm._v(" 1 (2007): 5–21.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Spirit, Church, Resurrection: The Third Article of the Creed as a Hermeneutical Lens for Reading Romans.” "), _c('i', [_vm._v("JTI")]), _vm._v(" 5 (2011): 35–48.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Story of God’s Son: The Identity of Jesus in the Letters of Paul.” In "), _c('i', [_vm._v("Seeking the Identity of Jesus: A Pilgrimage,")]), _vm._v(" ed. Beverly Roberts Gaventa and Richard B. Hays, 180–99. Grand Rapids: Eerdmans, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Healey, Nicholas M. “Practices and the New Ecclesiology: Misplaced Concreteness?” "), _c('i', [_vm._v("IJST")]), _vm._v(" 5 (2003): 287–308.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Heen, Eric M. “Philippians 2:6–11 and Resistance to Local Timocratic Rule: "), _c('i', [_vm._v("Isa Theō")]), _vm._v(" and the Cult of the Emperor in the East.” In "), _c('i', [_vm._v("Paul and the Roman Imperial Order,")]), _vm._v(" ed. Richard A. Horsley, 125–53. Harrisburg, PA: Trinity Press International, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Heil, John Paul. “Those Now ‘Asleep’ (Not Dead) Must Be ‘Awakened’ for the Day of the Lord in 1 Thess 5.9–10.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 46 (2000): 464–71.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hellerman, Joseph. "), _c('i', [_vm._v("Reconstructing Honor in Roman Philippi: Carmen Christi as")]), _vm._v(" Cursus Pudorum. SNTSMS 132. New York: Cambridge, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hendrix, Holland Lee. “Archaeology and Eschatology at Thessalonica.” In "), _c('i', [_vm._v("The Future of Christianity: Essays in Honor of Helmut Koester,")]), _vm._v(" ed. Birger A. Pearson, 107–18. Minneapolis: Fortress, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hill, Wesley. "), _c('i', [_vm._v("Paul and the Trinity: Persons, Relations, and the Pauline Letters.")]), _vm._v(" Grand Rapids: Eerdmans, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Holtz, Traugott. “The Judgment on the Jews and the Salvation of All Israel: 1 Thes 2,15–16 and Rom 11,25–26.” In "), _c('i', [_vm._v("The Thessalonian Correspondence,")]), _vm._v(" ed. R. F. Collins, 284–95. Leuven: Leuven University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Letter to the Philippians.” NIB 11. Nashville: Abingdon, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “On the Background of 1 Thessalonians 2:1–12.” In "), _c('i', [_vm._v("The Thessalonian Debate,")]), _vm._v(" ed. K. P. Donfried and J. Beutler, 275–92. Grand Rapids: Eerdmans, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hoppe, Rudolf. “Der Topos der Prophetenverfolgung bei Paulus.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 50 (2004): 535–49.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Horbury, W. “1 Thessalonians ii.3 as Rebutting the Charge of False Prophecy.” "), _c('i', [_vm._v("JTS")]), _vm._v(" 33 (1982): 492–508.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Horrell, David. “Paul, the ‘Gospel,’ and ‘Narrative Prompts’: ‘Just the Same Thing, for Ever.’ ” "), _c('i', [_vm._v("HBT")]), _vm._v(" 26 (2004): 94–114.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hughes, Kevin L. "), _c('i', [_vm._v("Constructing Antichrist: Paul, Biblical Commentary, and the Development of Doctrine in the Early Middle Ages.")]), _vm._v(" Washington, DC: Catholic University of America Press, 2005.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Hunsberger, George R. “Starting Points, Trajectories, and Outcomes in Proposals for a Missional Hermeneutic: Mapping the Conversation.” Presented at the AAR (Nov 1) and SBL (Nov 22) Meetings: Fall of 2008. ")]), _c('a', {
    attrs: {
      "href": "http://www.gocn.org/resources/articles/proposals-missional-hermeneutic-mapping-conversation",
      "target": "_blank"
    }
  }, [_vm._v("http://www.gocn.org/resources/articles/proposals-missional-hermeneutic-mapping-conversation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Hurtado, Larry. "), _c('i', [_vm._v("Lord Jesus Christ: Devotion to Jesus in Early Christianity.")]), _vm._v(" Grand Rapids: Eerdmans, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Jensen, Joseph. “Does "), _c('i', [_vm._v("Porneia")]), _vm._v(" Mean Fornication? A Critique of Bruce Malina.” "), _c('i', [_vm._v("NovT")]), _vm._v(" 20 (1978):161–84.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Jenson, Robert W. "), _c('i', [_vm._v("Canon and Creed.")]), _vm._v(" Louisville: Westminster John Knox, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Ezekiel.")]), _vm._v(" BTCB. Grand Rapids: Brazos, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Religious Power of Scripture.” "), _c('i', [_vm._v("SJT")]), _vm._v(" 52 (1999): 89–105.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “You Wonder Where the Spirit Went.” "), _c('i', [_vm._v("ProEccl")]), _vm._v(" 2 (1993): 296–304.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Jersak, Bradley. "), _c('i', [_vm._v("Her Gates Will Never Be Shut: Hope, Hell, and the New Jerusalem.")]), _vm._v(" Eugene, OR: Wipf & Stock, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Jervis, L. Ann. "), _c('i', [_vm._v("At the Heart of the Gospel: Suffering in the Earliest Christian Message.")]), _vm._v(" Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Jewett, Robert. "), _c('i', [_vm._v("Romans.")]), _vm._v(" Hermeneia. Minneapolis: Fortress, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Thessalonian Correspondence: Pauline Rhetoric and Millenarian Piety.")]), _vm._v(" Philadelphia: Fortress, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Johanson, Bruce C. "), _c('i', [_vm._v("To All the Brethren: A Text-Linguistic and Rhetorical Approach to 1 Thessalonians.")]), _vm._v(" ConBNT 16. Stockholm: Almqvist & Wiksell, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Johnson, Andy. “Ecclesiology, Election, and the Life of God: A Missional Reading of the Thessalonian Correspondence.” "), _c('i', [_vm._v("JTI")]), _vm._v(" 9 (2015): 247–66.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Firstfruits and Death’s Defeat: Metaphor in Paul’s Rhetorical Strategy in 1 Corinthians 15:20–28.” "), _c('i', [_vm._v("WW")]), _vm._v(" 16 (1996): 456–64.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Holy, Holiness, NT.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 2:846–50.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Lord.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 3:687.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Missional from First to Last: Paul’s Letters and the "), _c('i', [_vm._v("Missio Dei.")]), _vm._v("” In Missio Dei: "), _c('i', [_vm._v("A Wesleyan Understanding,")]), _vm._v(" ed. Keith Schwanz and Joseph Coleson, 67–74. Kansas City: Beacon Hill, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The ‘New Creation,’ the Crucified and Risen Christ, and the Temple: A Pauline Audience for Mark.” "), _c('i', [_vm._v("JTI")]), _vm._v(" 1 (2007): 171–91.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “On Removing a Trump Card: Flesh and Blood and the Reign of God.” "), _c('i', [_vm._v("BBR")]), _vm._v(" 13 (2003): 175–92.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Paul’s ‘Anti-Christology’ in 2 Thessalonians 2:3–12 in Canonical Context.” "), _c('i', [_vm._v("JTI")]), _vm._v(" 8 (2014): 125–43.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Resurrection, Ascension, and the Developing Portrait of the God of Israel in Acts.” "), _c('i', [_vm._v("SJT")]), _vm._v(" 57 (2004): 146–62.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Ripples of the Resurrection in the Triune Life of God: Reading Luke 24 with Eschatological and Trinitarian Eyes.” "), _c('i', [_vm._v("HBT")]), _vm._v(" 24 (2002): 87–110")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Sanctification of the Imagination in 1 Thessalonians.” In "), _c('i', [_vm._v("Holiness and Ecclesiology "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("in the New Testament,")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v(" ed. Kent Brower and Andy Johnson, 275–92. Grand Rapids: Eerdmans, 2007..")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Sanctify, Sanctification.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 5:96–101.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Self-Control.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 5:160–61.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Theological Interpretation of the Gospels.” In "), _c('i', [_vm._v("Dictionary of Jesus and the Gospels,")]), _vm._v(" 2nd ed., ed. Joel B. Green, Jeannine K. Brown, and Nicholas Perrin, 963–66. Downers Grove, IL: IVP Academic, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Turning the World Upside Down in 1 Corinthians 15: Apocalyptic Epistemology, the Resurrected Body, and the New Creation.” "), _c('i', [_vm._v("EvQ")]), _vm._v(" 75 (2003): 291–309.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Kaminsky, Joel S. "), _c('i', [_vm._v("Yet I Loved Jacob: Reclaiming the Biblical Concept of Election.")]), _vm._v(" Nashville: Abingdon, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Karrer, Martin. “Der Zweite Thessalonicherbrief und Gottes Widersacher.” "), _c('i', [_vm._v("HBT")]), _vm._v(" 29 (2007): 101–31.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Keck, Leander. "), _c('i', [_vm._v("Romans.")]), _vm._v(" ANTC. Nashville: Abingdon, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Keesmaat, Sylvia C. “Crucified Lord or Conquering Saviour: Whose Story of Salvation?” "), _c('i', [_vm._v("HBT")]), _vm._v(" 26 (2004): 69–93.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Keown, Mark J. "), _c('i', [_vm._v("Congregational Evangelism in Philippians: The Centrality of an Appeal for Gospel Proclamation to the Fabric of Philippians.")]), _vm._v(" PBM. Milton Keynes: Paternoster, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Kim, Seyoon. "), _c('i', [_vm._v("Christ and Caesar: The Gospel and the Roman Empire in the Writings of Paul and Luke.")]), _vm._v(" Grand Rapids: Eerdmans, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Paul’s Entry ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἴσοδος")]), _vm._v(") and the Thessalonians’ Faith (1 Thessalonians 1–3).” "), _c('i', [_vm._v("NTS")]), _vm._v(" 51 (2005): 519–42.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Klassen, William. “The Sacred Kiss in the New Testament: An Example of Social Boundary Lines.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 39 (1993): 122–35.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Koester, Craig. "), _c('i', [_vm._v("Revelation and the End of All Things.")]), _vm._v(" Grand Rapids: Eerdmans, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Koester, Helmut. “Imperial Ideology and Paul’s Eschatology in 1 Thessalonians.” In "), _c('i', [_vm._v("Paul and Empire: Religion and Power in Roman Imperial Society,")]), _vm._v(" ed. Richard A. Horsley, 158–66. Harrisburg, PA: Trinity, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Konstan, David, and Ilaria Ramelli. “The Syntax of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν Χριστῷ")]), _vm._v(" in 1 Thess 4:16.” "), _c('i', [_vm._v("JBL")]), _vm._v(" 126 (2007): 579–93.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Krodel, Gerhard. “The ‘Religious Power of Lawlessness’ ("), _c('i', [_vm._v("Katechon")]), _vm._v(") as Precursor of the ‘Lawless One’ ("), _c('i', [_vm._v("Anomos")]), _vm._v("): 2 Thess 2:6–7.” "), _c('i', [_vm._v("CurTM")]), _vm._v(" 17 (1990): 440–46.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Lane, Tony. “The Wrath of God as an Aspect of the Love of God.” In "), _c('i', [_vm._v("Nothing Greater, Nothing Better: Theological Essays on the Love of God,")]), _vm._v(" ed. Kevin J. Vanhoozer, 138–67. Grand Rapids: Eerdmans, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Lautenschlager, M. “"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Εἴτε γρηγορῶμεν εἴτε καθεύδωμεν")]), _vm._v(": Zum Verhältnis von Heiligung und Heil in 1 Thess 5,10.” "), _c('i', [_vm._v("ZNW")]), _vm._v(" 81 (1990): 39–59.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Leithart, Peter J. "), _c('i', [_vm._v("Between Babel and Beast: America and Empires in Biblical Perspective.")]), _vm._v(" Eugene, OR: Cascade Books, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Levison, John R. "), _c('i', [_vm._v("Filled with the Spirit.")]), _vm._v(" Grand Rapids: Eerdmans, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Lichtenberger, Hermann. “"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("σάλπιγξ")]), _vm._v(".” In "), _c('i', [_vm._v("EDNT")]), _vm._v(" 3:225–26.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Lindsey, Hal. "), _c('i', [_vm._v("The Late Great Planet Earth.")]), _vm._v(" Grand Rapids: Zondervan, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Litwa, M. David “2 Corinthians 3:18 and Its Implications for "), _c('i', [_vm._v("Theosis.")]), _vm._v("” "), _c('i', [_vm._v("JTI")]), _vm._v(" 2 (2008): 117–33.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Luckensmeyer, David. "), _c('i', [_vm._v("The Eschatology of First Thessalonians.")]), _vm._v(" NTOA/SUNT 71. Göttingen: Vandenhoeck & Ruprecht, 2009.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Lyons, George. “Modeling the Holiness Ethos: A Study Based on First Thessalonians.” "), _c('i', [_vm._v("WesTJ")]), _vm._v(" (1995): 187–211.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Pauline Autobiography: Toward a New Understanding.")]), _vm._v(" SBLDS 73. Atlanta: Scholars Press, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Lyons, George, and William H. Malas Jr. “Paul and His Friends within the Greco-Roman Context.” "), _c('i', [_vm._v("WesTJ")]), _vm._v(" 42 (2007): 50–69.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Maarten, M. J. J. “Paradise Regained or Still Lost? Eschatology and Disorderly Behavior in 2 Thessalonians.” "), _c('i', [_vm._v("NTS")]), _vm._v(" (1992): 271–89.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Macchia, Frank D. "), _c('i', [_vm._v("Justified in the Spirit: Creation, Redemption, and the Triune God.")]), _vm._v(" Pentecostal Manifestos. Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Malherbe, Abraham J. "), _c('i', [_vm._v("Ancient Epistolary Theorists.")]), _vm._v(" Atlanta: Scholars Press, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Exhortation in First Thessalonians.” "), _c('i', [_vm._v("NovT")]), _vm._v(" 25 (1983): 238–56.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Gentle as a Nurse: The Cynic Background to 1 Thessalonians 2:7.” "), _c('i', [_vm._v("NovT")]), _vm._v(" 12 (1970): 203–17.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Malina, Bruce. “Does "), _c('i', [_vm._v("Porneia")]), _vm._v(" Mean Fornication?” "), _c('i', [_vm._v("NovT")]), _vm._v(" 14 (1972): 10–17.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Marcus, Joel. “Idolatry in the New Testament.” "), _c('i', [_vm._v("Int")]), _vm._v(" 60 (2006): 152–64.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Markham, Paul N. "), _c('i', [_vm._v("Rewired: Exploring Religious Conversion.")]), _vm._v(" Eugene, OR: Wipf & Stock, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Marshall, I. Howard. “Election and Calling to Salvation in 1 and 2 Thessalonians.” In "), _c('i', [_vm._v("The Thessalonian Correspondence,")]), _vm._v(" ed. R. F. Collins, 259–76. Leuven: Leuven University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Martin, Dale B. "), _c('i', [_vm._v("The Corinthian Body.")]), _vm._v(" New Haven: Yale University Press, 1999.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("McCormick, K. Steve. “The Church after the Likeness of the Holy Trinity Is the Church after the Missio Dei.” "), _c('i', [_vm._v("Didache")]), _vm._v(" 6. Available at ")]), _c('a', {
    attrs: {
      "href": "http://didache.nts.edu/pdfs/GTIIE_McCormick.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://didache.nts.edu/pdfs/GTIIE_McCormick.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("McDonald, Nathan. “Did God Choose the Patriarchs: Reading for Election in Genesis.” In "), _c('i', [_vm._v("Genesis and Christian Theology,")]), _vm._v(" ed. Nathan McDonald, Mark W. Elliott, Grant Macaskill, 245–66. Grand Rapids: Eerdmans, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("McDonald, Suzanne. "), _c('i', [_vm._v("Re-Imaging Election: Divine Election as Representing God to Others and Others to God.")]), _vm._v(" Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("McGinn, Bernard. "), _c('i', [_vm._v("Anti-Christ: Two Thousand Years of the Human Fascination with Evil.")]), _vm._v(" New York: Columbia University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("McKnight, Scot. "), _c('i', [_vm._v("A Community Called Atonement.")]), _vm._v(" Nashville: Abingdon, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The King Jesus Gospel: The Original Good News Revisited.")]), _vm._v(" Grand Rapids: Zondervan, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Meeks, Wayne. "), _c('i', [_vm._v("The First Urban Christians: The Social World of the Apostle Paul.")]), _vm._v(" 2nd ed. New Haven: Yale University Press, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Origins of Christian Morality: The First Two Centuries.")]), _vm._v(" New Haven: Yale University Press, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Metzger, Bruce M. "), _c('i', [_vm._v("A Textual Commentary on the Greek New Testament, Second Edition: A Companion Volume to the United Bible Societies’ Greek New Testament.")]), _vm._v(" 4th rev. ed. London/New York: United Bible Societies, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Meyer, Ben F. “Did Paul’s View of the Resurrection of the Dead Undergo Development?” "), _c('i', [_vm._v("TS")]), _vm._v(" 47 (1986): 363–87.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Election-Historical Thinking in Romans 9–11, and Ourselves.” "), _c('i', [_vm._v("ExAud")]), _vm._v(" 4 (1988): 1–7.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Milgrom, Jacob. “Holy, Holiness, OT.” In "), _c('i', [_vm._v("NIDB")]), _vm._v(" 2:850–58.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Leviticus 1–16.")]), _vm._v(" AB 3. New York: Doubleday, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Miller, Colin. “The Imperial Cult in the Pauline Cities of Asia Minor and Greece.” "), _c('i', [_vm._v("CBQ")]), _vm._v(" 72 (2010): 314–32.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Minear, Paul. “The Holy and the Sacred.” "), _c('i', [_vm._v("TT")]), _vm._v(" 47 (1990–91): 5–12.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Moberly, R. W. L. "), _c('i', [_vm._v("Old Testament Theology: Reading the Hebrew Bible as Christian Scripture.")]), _vm._v(" Grand Rapids: Baker Academic, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Whose Justice? Which Righteousness? The Interpretation of Isaiah V 16.” "), _c('i', [_vm._v("VT")]), _vm._v(" 51 (2001): 55–68.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Newman, Carey C. “Election and Predestination in Ephesians 1:4–6a: An Exegetical-Theological Study of the Historical, Christological Realization of God’s Purpose.” "), _c('i', [_vm._v("RevExp")]), _vm._v(" 93 (1996): 237–47.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Nicholl, Colin R. "), _c('i', [_vm._v("From Hope to Despair in Thessalonica: Situating 1 and 2 Thessalonians.")]), _vm._v(" SNTSMS 126. Cambridge/New York: Cambridge University Press, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Noble, Thomas A. "), _c('i', [_vm._v("Holy Trinity: Holy People: The Theology of Christian Perfecting.")]), _vm._v(" Eugene, OR: Cascade Books, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Mission of the Holy Trinity.” In Missio Dei: "), _c('i', [_vm._v("A Wesleyan Understanding,")]), _vm._v(" ed. Keith Schwanz and Joseph Coleson, 77–84. Kansas City: Beacon Hill, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Novenson, Matthew. “ ‘God Is Witness’: A Classical Rhetorical Idiom in Its Pauline Usage.” "), _c('i', [_vm._v("NovT")]), _vm._v(" 52 (2010): 355–75.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Oakes, Peter. “Re-mapping the Universe: Paul and the Emperor in 1 Thessalonians and Philippians.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 27 (2005): 301–22.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("O’Brien, Peter T. "), _c('i', [_vm._v("The Epistle to the Philippians: A Commentary on the Greek Text.")]), _vm._v(" NIGTC. Grand Rapids: Eerdmans, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("O’Keffe, John J., and R. R. Reno. "), _c('i', [_vm._v("Sanctified Vision: An Introduction to Early Christian Interpretation of the Bible.")]), _vm._v(" Baltimore/London: The Johns Hopkins University Press, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Olson, Carl E. "), _c('i', [_vm._v("Will Catholics Be Left Behind? A Catholic Critique of the Rapture and Today’s Prophecy Preachers.")]), _vm._v(" San Francisco: Ignatius, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Paddison, Angus. "), _c('i', [_vm._v("Theological Hermeneutics and 1 Thessalonians.")]), _vm._v(" SNTSMS 133. Cambridge: Cambridge University Press, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Pahl, Michael W. "), _c('i', [_vm._v("Discerning the ‘Word of the Lord’: The ‘Word of the Lord’ in 1 Thessalonians 4:15.")]), _vm._v(" LNTS 389. London: T&T Clark, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Pearson, B. A. “1 Thessalonians 2:13–16: A Deutero-Pauline Interpretation.” "), _c('i', [_vm._v("HTR")]), _vm._v(" 64 (1971): 79–94.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Peterson, Brian K. “Being the Church in Philippi.” "), _c('i', [_vm._v("HBT")]), _vm._v(" 30 (2008): 163–78.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Peterson, Eric. “Die Einholung des "), _c('i', [_vm._v("Kyrios.")]), _vm._v("” "), _c('i', [_vm._v("ZST")]), _vm._v(" 1 (1930): 682–702.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Piper, John. “Five Reasons to Embrace Unconditional Election.” Blog accessed online on November 21, 2014, at ")]), _c('a', {
    attrs: {
      "href": "http://www.desiringgod.org/blog/posts/five-reasons-to-embrace-unconditional-election",
      "target": "_blank"
    }
  }, [_vm._v("http://www.desiringgod.org/blog/posts/five-reasons-to-embrace-unconditional-election")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Plevnik, Joseph. "), _c('i', [_vm._v("Paul and the Parousia: An Exegetical and Theological Investigation.")]), _vm._v(" Peabody, MA: Hendrickson, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Taking Up of the Faithful and the Resurrection of the Dead in 1 Thessalonians 4:13–18.” "), _c('i', [_vm._v("CBQ")]), _vm._v(" 46 (1984): 274–83.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Porter, Stanley. “The Theoretical Justification for Application of Rhetorical Categories to Pauline Epistolary Literature.” In "), _c('i', [_vm._v("Rhetoric and the New Testament: Essays from the 1992 Heidelberg Conference,")]), _vm._v(" ed. Stanley E. Porter and Thomas H. Olbricht, 100–122. Sheffield: JSOT Press, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Powell, Samuel M., and Michael E. Lodahl, eds. "), _c('i', [_vm._v("Embodied Holiness: Toward a Corporate Theology of Spiritual Growth.")]), _vm._v(" Downers Grove, IL: InterVarsity Press, 1999.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Rae, Murray. “On Reading Scripture Theologically.” "), _c('i', [_vm._v("PTR")]), _vm._v(" 14 (2008): 13–26.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Texts in Context: Scripture in the Divine Economy.” "), _c('i', [_vm._v("JTI")]), _vm._v(" 1 (2007): 23–45.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Rabens, Volker. “1 Thessalonians.” In "), _c('i', [_vm._v("A Biblical Theology of the Holy Spirit,")]), _vm._v(" ed. Trevor J. Burke and Keith Warrington, 198–212. London: SPCK, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Rainbow, Paul A. “Justification According to Paul’s Thessalonian Correspondence.” "), _c('i', [_vm._v("BBR")]), _vm._v(" 19 (2009): 249–74.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Reed, Jeffrey T. “Using Ancient Rhetorical Categories to Interpret Paul’s Letters: A Question of Genre.” In "), _c('i', [_vm._v("Rhetoric and the New Testament: Essays from the 1992 Heidelberg Conference,")]), _vm._v(" ed. Stanley E. Porter and Thomas H. Olbricht, 292–324. Sheffield: JSOT Press, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Rengstorf, K. H. “"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δοῦλος")]), _vm._v(", et al.” In "), _c('i', [_vm._v("TDNT,")]), _vm._v(" 2:261–68.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Rossing, Barbara. "), _c('i', [_vm._v("The Rapture Exposed: The Message of Hope in the Book of Revelation.")]), _vm._v(" New York: Basic Books, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Rowe, C. Kavin. “New Testament Iconography? Situating Paul in the Absence of Material Evidence.” In "), _c('i', [_vm._v("Picturing the New Testament: Studies in Ancient Visual Images,")]), _vm._v(" ed. Annetee Weissenrieder, 289–312. Göttingen: Mohr Siebeck, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("World Upside Down: Reading Acts in the Graeco-Roman Age.")]), _vm._v(" Oxford: Oxford University Press, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Sailors, Timothy B. “Wedding Textual and Rhetorical Criticism to Understand the Text of 1 Thessalonians 2:7.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 80 (2000): 81–98.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Sand, A. “"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καρδία, ας, ἡ")]), _vm._v(".” In "), _c('i', [_vm._v("EDNT")]), _vm._v(" 2:250.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Sandness, K. O. "), _c('i', [_vm._v("Paul—One of the Prophets?")]), _vm._v(" WUNT 2/43. Tübingen: Mohr-Siebeck, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Schlueter, Carol H. "), _c('i', [_vm._v("Filling Up the Measure: Polemical Hyperbole in 1 Thessalonians 2.14–16.")]), _vm._v(" JSNTSup 98. Sheffield: JSOT Press, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Schottroff, Luise. “ ‘Give to Caesar What Belongs to Caesar and to God What Belongs to God’: A Theological Response of the Early Christian Church to Its Social and Political Environment.” In "), _c('i', [_vm._v("The Love of Enemy and Nonretaliation in the New Testament,")]), _vm._v(" ed. Willard M. Swartley, 223–57. Louisville: Westminster John Knox, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Schunack, G. “"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τύπος")]), _vm._v(".” In "), _c('i', [_vm._v("EDNT")]), _vm._v(" 3:372–76.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Scofield, C. I. "), _c('i', [_vm._v("The New Scofield Reference Bible.")]), _vm._v(" New York: Oxford University Press, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Sherman, Amy L. "), _c('i', [_vm._v("Kingdom Calling: Vocational Stewardship for the Common Good.")]), _vm._v(" Downers Grove, IL: InterVarsity Press, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Smith, Jay E. “1 Thessalonians 4:4: Breaking the Impasse.” "), _c('i', [_vm._v("BBR")]), _vm._v(" 11 (2001): 65–105.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Stanley, Christopher D. “Who’s Afraid of a Thief?” "), _c('i', [_vm._v("NTS")]), _vm._v(" 48 (2002): 68–86.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Still, Todd D. "), _c('i', [_vm._v("Conflict at Thessalonica: A Pauline Church and Its Neighbors.")]), _vm._v(" JSNTSup 183. Sheffield: Sheffield Academic Press, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Did Paul Loathe Manual Labor? Revisiting the Work of Ronald Hock on the Apostle’s Tentmaking and Social Class.” "), _c('i', [_vm._v("JBL")]), _vm._v(" 125 (2006): 781–95.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Stubbs, David L. “The Shape of Soteriology and the "), _c('i', [_vm._v("Pistis Christou")]), _vm._v(" Debate.” "), _c('i', [_vm._v("SJT")]), _vm._v(" 61 (2008): 137–57.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Swartley, Willard M. "), _c('i', [_vm._v("Covenant of Peace: The Missing Peace in New Testament Theology and Ethics.")]), _vm._v(" Grand Rapids: Eerdmans, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Relation of Justice/Righteousness to "), _c('i', [_vm._v("Shalom")]), _vm._v("/"), _c('i', [_vm._v("Eirēnē.")]), _vm._v("” "), _c('i', [_vm._v("ExAud")]), _vm._v(" 22 (2006): 29–53.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Tellbe, Mikael. "), _c('i', [_vm._v("Paul between Synagogue and State: Christians, Jews and Civic Authorities ")])]), _c('i', [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("in 1 Thessalonians, Romans, and Philippians.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v(" ConBNT 34. Stockholm: Almqvist and Wiksell, 2001.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Thiselton, Anthony. "), _c('i', [_vm._v("Life after Death: A New Approach to the Last Things.")]), _vm._v(" Grand Rapids: Eerdmans, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Thomas, Gordon J. “The Perfection of Christ and the Perfecting of Believers in Hebrews.” In "), _c('i', [_vm._v("Holiness and Ecclesiology in the New Testament,")]), _vm._v(" ed. Kent E. Brower and Andy Johnson, 293–310. Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Thomas, Günter. “Resurrection to New Life: Pneumatological Implications of the Eschatological Transition.” In "), _c('i', [_vm._v("Resurrection: Theological and Scientific Assessments,")]), _vm._v(" ed. Ted Peters, Robert John Russell, Michael Welker, 255–76. Grand Rapids: Eerdmans, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Tonstad, Sigve. “The Restrainer Removed: A Truly Alarming Thought (2 Thess 2:1–12).” "), _c('i', [_vm._v("HBT")]), _vm._v(" 29 (2007): 133–51.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Treier, Daniel J. "), _c('i', [_vm._v("Introducing Theological Interpretation of Scripture: Recovering a Christian Practice.")]), _vm._v(" Grand Rapids: Baker Academic, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Turner, Seth. “The Interim, Earthly Messianic Kingdom in Paul.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 25 (2003): 323–42.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Van Duzer, Jeff. "), _c('i', [_vm._v("Why Business Matters to God (And What Still Needs to Be Fixed).")]), _vm._v(" Downers Grove, IL: IVP Academic, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Van Gelder, Craig, and Dwight J. Zscheile. "), _c('i', [_vm._v("The Missional Church in Perspective: Mapping Trends and Shaping the Conversation.")]), _vm._v(" Grand Rapids: Baker Academic, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Vanhoozer, Kevin J., ed. "), _c('i', [_vm._v("Dictionary for Theological Interpretation of the Bible.")]), _vm._v(" Grand Rapids: Baker Academic, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Volf, Miroslav. "), _c('i', [_vm._v("After Our Likeness: The Church as the Image of the Trinity.")]), _vm._v(" Grand Rapids: Eerdmans, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Work in the Spirit: Toward a Theology of Work.")]), _vm._v(" Eugene, OR: Wipf & Stock, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wagner, J. Ross. “Working Out Salvation: Holiness and Community in Philippians.” In "), _c('i', [_vm._v("Holiness and Ecclesiology in the New Testament,")]), _vm._v(" ed. Kent Brower and Andy Johnson, 257–74. Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wall, Robert. “Reading Paul with Acts: The Canonical Shaping of a Holy Church.” In "), _c('i', [_vm._v("Holiness and Ecclesiology in the New Testament,")]), _vm._v(" ed. Kent Brower and Andy Johnson, 129–47. Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Walton, Steve. "), _c('i', [_vm._v("Leadership and Lifestyle: The Portrait of Paul in the Miletus Speech and 1 Thessalonians.")]), _vm._v(" SNTSMS 108. Cambridge: Cambridge University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wanamaker, Charles. “Like a Father Treats His Own Children: Paul and the Conversion of the Thessalonians.” "), _c('i', [_vm._v("JTSA")]), _vm._v(" 92 (1995): 46–55.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Ware, James. “The Thessalonians as a Missionary Congregation: 1 Thessalonians 1,5–8.” "), _c('i', [_vm._v("ZNW")]), _vm._v(" 83 (1992): 126–31.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Watson, Francis. "), _c('i', [_vm._v("Paul, Judaism, and the Gentiles: Beyond the New Perspective.")]), _vm._v(" Rev. ed. Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Webster, John. "), _c('i', [_vm._v("Holiness.")]), _vm._v(" Grand Rapids: Eerdmans, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Weima, Jeffrey A. D. “An Apology for the Apologetic Function of 1 Thessalonians 2:1–12.” "), _c('i', [_vm._v("JSNT")]), _vm._v(" 68 (1997): 73–99.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “ ‘But We Became Infants among You’: The Case for "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ΝΗΠΙΟΙ")]), _vm._v(" in 1 Thess 2.7.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 46 (2000): 547–64.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “ ‘How You Must Walk to Please God’: Holiness and Discipleship in 1 Thessalonians.” In "), _c('i', [_vm._v("Patterns of Discipleship in the New Testament,")]), _vm._v(" ed. Richard N. Longenecker, 98–119. Grand Rapids: Eerdmans, 1996.")])]), _c('p', {
    staticClass: "Hang-x"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("———. “Infants, Nursing Mother, and Father: Paul’s Portrayal of a Pastor.” "), _c('i', [_vm._v("CTJ")]), _vm._v(" 37 (2002): 209–29.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Slaying of Satan’s Superman and the Sure Salvation of the Saints: Paul’s Apocalyptic Word of Comfort (2 Thessalonians 2:1–17).” "), _c('i', [_vm._v("CTJ")]), _vm._v(" 41 (2006): 67–88.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wesley, John. "), _c('i', [_vm._v("Explanatory Notes upon the New Testament.")]), _vm._v(" Kansas City: Beacon Hill, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “A Letter to a Roman Catholic.” "), _c('i', [_vm._v("The Works of John Wesley,")]), _vm._v(" 3rd ed., ed. Thomas Jackson, 10:80–86. Kansas City: Beacon Hill, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Westermann, Claus. "), _c('i', [_vm._v("Genesis 1–11: A Commentary.")]), _vm._v(" Minneapolis: Augsburg, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wiles, G. P. "), _c('i', [_vm._v("Paul’s Intercessory Prayers: The Significance of the Intercessory Prayer Passages in the Letters of Paul.")]), _vm._v(" SNTSMS 24. Cambridge: Cambridge University Press, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wilken, Robert Louis. “Interpreting the New Testament.” "), _c('i', [_vm._v("ProEccl")]), _vm._v(" 14 (2005): 15–25.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wilkinson, David. "), _c('i', [_vm._v("Christian Eschatology and the Physical Universe.")]), _vm._v(" London: T&T Clark, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Winter, Bruce. "), _c('i', [_vm._v("After Paul Left Corinth: The Influence of Secular Ethics and Social Change.")]), _vm._v(" Grand Rapids: Eerdmans, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “The Entries and Ethics of Orators and Paul (1 Thessalonians 2:1–12).” "), _c('i', [_vm._v("TynBul")]), _vm._v(" 44 (1993): 55–74.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Seek the Welfare of the City: Christians as Benefactors and Citizens.")]), _vm._v(" Grand Rapids: Eerdmans, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Witherington, Ben, III. "), _c('i', [_vm._v("The Acts of the Apostles: A Socio-Rhetorical Commentary.")]), _vm._v(" Grand Rapids: Eerdmans, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Paul’s Letter to the Romans.")]), _vm._v(" Grand Rapids: Eerdmans, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Problem with Evangelical Theology: Testing the Exegetical Foundations of Calvinism, Dispensationalism, and Wesleyanism.")]), _vm._v(" Baylor: Baylor University Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Work: A Kingdom Perspective on Labor.")]), _vm._v(" Grand Rapids: Eerdmans, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Witherington, Ben, III, with Darlene Hyatt. "), _c('i', [_vm._v("Paul’s Letter to the Romans: A Socio-Rhetorical Commentary.")]), _vm._v(" Grand Rapids: Eerdmans, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Witmer, Stephen. “"), _c('span', {
    staticClass: "grk"
  }, [_vm._v("θεοδίδακτοι")]), _vm._v(" in 1 Thessalonians: A Pauline Neologism.” "), _c('i', [_vm._v("NTS")]), _vm._v(" 52 (2006): 239–50.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wright, Christopher J. H. "), _c('i', [_vm._v("The Mission of God: Unlocking the Bible’s Grand Narrative.")]), _vm._v(" Downers Grove, IL: InterVarsity Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Wright, N. T. "), _c('i', [_vm._v("The Climax of the Covenant: Christ and the Law in Pauline Theology.")]), _vm._v(" Minneapolis: Fortress, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Justification: God’s Plan and Paul’s Vision.")]), _vm._v(" Downers Grove, IL: IVP Academic, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “New Perspectives on Paul.” In "), _c('i', [_vm._v("Justification in Perspective: Historical Developments and Contemporary Challenges,")]), _vm._v(" ed. Bruce L. McCormack, 243–64. Grand Rapids: Baker Academic, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Paul and the Faithfulness of God.")]), _vm._v(" Book 2. Minneapolis: Fortress, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("Paul in Fresh Perspective.")]), _vm._v(" Minneapolis: Fortress, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Resurrection of the Son of God.")]), _vm._v(" Minneapolis: Fortress, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("———. “Romans.” "), _c('i', [_vm._v("NIB")]), _vm._v(" 10. Nashville: Abingdon, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang-x"
  }, [_vm._v("Yeago, David S. “The New Testament and the Nicene Dogma.” In "), _c('i', [_vm._v("The Theological Interpretation of Scripture: Classic and Contemporary Readings,")]), _vm._v(" ed. Stephen E. Fowl, 87–100. Malden, MA/Oxford: Blackwell, 1997.")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch001"
    }
  }, [_vm._v("Commentary on 1 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "h1top",
    attrs: {
      "id": "s01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s01"
    }
  }, [_vm._v("1:1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Letter’s Prescript")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_vm._v("Paul, Silas, and Timothy: to the church of the Thessalonians assembled by/in God the Father and the Lord Jesus Christ. Grace to you all and peace.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Both 1 and 2 Thessalonians begin with a standard, albeit modified,"), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" epistolary prescript including the sender(s), addressees, and a greeting. Both letters come from Paul, Silvanus, and Timothy, with no further description of who they are. Throughout the commentary, I will assume that Paul is primarily responsible for the content of both letters as their actual author and speaks for the latter two, who are best described as cosenders."), _c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Silvanus is the Latinized form of Silas, to whom we are introduced in Acts (15:27, 40), closely followed there by the introduction of Timothy (16:1). There Paul, Silas, and Timothy are depicted as being present at the founding of the church in Thessalonica (17:1–9),"), _c('a', {
    attrs: {
      "id": "fn3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" which takes place on a journey in which they set out to deliver the admonitions of the so-called apostolic decree to the Gentiles "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“who are turning ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπιστρέφουσιν")]), _vm._v(", "), _c('i', [_vm._v("epistrephousin")]), _vm._v("] to God” (Acts 15:19), that is, the churches formed in the account in Acts 13–14 (16:4). Although not explicitly narrated in Acts, the implication is that they deliver these same commands to churches they form on that journey, like the ones in Philippi and Thessalonica. While the exact content and purpose of these admonitions remain debated, the general tenor of two of the commands remains consistent throughout (Acts 15:20; cf. 15:29; 21:25)—in particular, “to abstain ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀπέχεσθαι")]), _vm._v(", "), _c('i', [_vm._v("apechesthai")]), _vm._v("] from pollutions of idols ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδώλων")]), _vm._v(", "), _c('i', [_vm._v("eidōlōn")]), _vm._v("]/food sacrificed to idols ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδωλόθυτον")]), _vm._v(", "), _c('i', [_vm._v("eidōlothyton")]), _vm._v("] and sexual immorality ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πορνείας")]), _vm._v(", "), _c('i', [_vm._v("porneias")]), _vm._v("].”")]), _c('a', {
    attrs: {
      "id": "fn4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Such language resonates with Paul’s description of the Thessalonians, who “turned ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπεστρέψατε")]), _vm._v(", "), _c('i', [_vm._v("epestrepsate")]), _vm._v("] from idols ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδώλων")]), _vm._v(", "), _c('i', [_vm._v("eidōlōn")]), _vm._v("]” in 1:9, and his command in 4:3 “to abstain ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀπέχεσθαι")]), _vm._v(", "), _c('i', [_vm._v("apechesthai")]), _vm._v("] from sexual immorality ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πορνείας")]), _vm._v(", "), _c('i', [_vm._v("porneias")]), _vm._v("].” Hence, in both Acts and 1 Thessalonians, Paul, Silas, and Timothy are associated with Gentile churches who have turned from idols to God, are commanded to avoid being polluted with the realm of idolatry, and are commanded to avoid sexual immorality. The avoidance of idolatry and sexual immorality, which is constituent of Israel’s response to their call to be a holy people, is also assumed of the (Gentile) church in both Acts and in 1 Thessalonians. In both places the church is to engage in “public practices that demonstrate purity, thereby bearing witness to the church’s faithfulness to Israel’s God.”"), _c('a', {
    attrs: {
      "id": "fn5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This public engagement in practices demonstrating purity is consistent with the letter’s being addressed to the "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐκκλησία")]), _vm._v(" ("), _c('i', [_vm._v("ekklēsia,")]), _vm._v(" “church”) of the Thessalonians. The word "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" is often used in the LXX in reference to the called and gathered people of Israel whom Yahweh had redeemed and from whom he demanded loyalty,"), _c('a', {
    attrs: {
      "id": "fn6"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" to be expressed in actions that bore witness to his character."), _c('a', {
    attrs: {
      "id": "fn7"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Hence, together with the language of “beloved by God” (v. 4), “election” (v. 4), and “calling” (2:12; 4:7; 5:24), the term "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" connects this Gentile audience to the story of God’s dealings with Israel, marking them out as a redeemed, visible people whose public practices are to make clear the character of Israel’s God. In the larger Greco-Roman world, "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" commonly referred to both informal (e.g., Acts 19:32) and formal public gatherings, e.g., the regular assembly of free males in a body gathered to conduct the political affairs of a Greco-Roman city (e.g., Acts 19:39)."), _c('a', {
    attrs: {
      "id": "fn8"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" The term therefore evokes theological and political imagery "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("from the Jewish and the Greco-Roman milieu, effectively describing the audience as a public body whose ultimate loyalty was due, not to the empire and its gods, but to one particular god, namely, the God of Israel. Such exclusive loyalty distinguishes this "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" from any others in Thessalonica and calls attention to the audience’s vocation as public witness.")]), _c('a', {
    attrs: {
      "id": "fn9"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This point is underscored by the way Paul modifies the standard epistolary prescript by adding a description of his audience as being "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν")]), _vm._v(" ("), _c('i', [_vm._v("en,")]), _vm._v(" “in, by”) God the Father and the Lord Jesus Christ. There are two main possibilities for understanding the force of the "), _c('i', [_vm._v("en")]), _vm._v(" in this phrase: (1) “in” or (2) “by.” Is Paul depicting the audience as in some way "), _c('i', [_vm._v("located in")]), _vm._v(" God and the Lord, Jesus Christ, or is he thinking of it as being "), _c('i', [_vm._v("established by")]), _vm._v(" God and Christ? It may not be necessary to make an either/or choice in this case. Given his further description of the audience as loved, elected (1:4), and called by God (2:12; 4:7; 5:24), Paul certainly understands this audience both here and in 2 Thess 1:1 as existing "), _c('i', [_vm._v("by means of")]), _vm._v(" the actions of God and Christ."), _c('a', {
    attrs: {
      "id": "fn10"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Taking into account that "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" might have retained its verbal connotations of “being assembled,” one might, then, translate the "), _c('i', [_vm._v("en")]), _vm._v(" as “assembled by God the Father and the Lord Jesus Christ.”"), _c('a', {
    attrs: {
      "id": "fn11"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" On this understanding of "), _c('i', [_vm._v("en")]), _vm._v(" at the very beginning of the letter, Paul would be highlighting the divine action that brought this community into existence, distinguishing this "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" from any others in Thessalonica"), _c('a', {
    attrs: {
      "id": "fn12"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" and thereby making everything that follows dependent on this "), _c('i', [_vm._v("priority of divine grace.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But translating "), _c('i', [_vm._v("en")]), _vm._v(" as “in” would be no less an affirmation that everything that follows in these letters would be dependent on the priority of divine grace. While Paul often speaks of believers as being “in Christ,” other than here and in 2 Thess 1:1, he does not use the language of persons being “in God” in a parallel way. However, he does use similar terminology in Col 3:3 to refer to his audience’s life being “hidden with Christ "), _c('i', [_vm._v("in God")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν τῷ θεῷ")]), _vm._v(", "), _c('i', [_vm._v("en tō theō")]), _vm._v("].” Moreover, since the one "), _c('i', [_vm._v("en")]), _vm._v(" (in) is used in reference to both God the Father and the Lord Jesus Christ in Paul’s initial characterization of his audience, the fact that he uses the language of “in Christ” to initially characterize the audience of some of his other letters (e.g., 1 Cor 1:2; Phil 1:1; Col 1:2) makes it probable that this whole phrase in 1 Thess 1:1 is a variation of “in Christ.” Michael Gorman thus rightly argues that here in 1 Thess 1:1 Paul does not sharply distinguish between being “in Christ” and being “in God.”"), _c('a', {
    attrs: {
      "id": "fn13"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" In his words, “To be in Christ is to be in God and to be the ongoing recipient of God’s Holy Spirit (4:8); this is, in Paul’s earliest "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("letter, an indication of his experience of a trinitarian participatory holiness. Paul’s concern is inhabiting God—inhabiting the cruciform God.”")]), _c('a', {
    attrs: {
      "id": "fn14"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" This is the language of theosis, and as we will argue at various points in the commentary, it is appropriate for characterizing the soteriological process into which God has incorporated this ecclesial community."), _c('a', {
    attrs: {
      "id": "fn15"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s phraseology, then, underscores the priority of divine grace, "), _c('i', [_vm._v("by which")]), _vm._v(" the community is brought into existence "), _c('i', [_vm._v("in order to share in")]), _vm._v(" the life of the Triune God. But it is important to note at the outset that this God is “the God/Lord of peace” (1 Thess 5:23; 2 Thess 3:16), and so Paul extends not only grace to his audience but peace as well. Here he does not explicitly designate the source of either of these qualities as he does in 2 Thess 1:2 and elsewhere (e.g., Rom 1:7 et al.) as being “from God our Father and the Lord Jesus Christ,” but there can be no real question as to their origin. If everything in the letter presumes the priority of divine grace, it also assumes the presence and availability of divine peace, or shalom. For Paul, the divinely promised messianic peace has decisively begun with the death and resurrection of Jesus, although even a cursory read through Paul’s letters will reveal that it has not yet arrived in its fullness. Such peace is not simply “inner peace of mind,” as in some popular understandings. Rather, the shalom that has been divinely provided flows from God’s provision of saving justice ("), _c('i', [_vm._v("dikaiosynē")]), _vm._v("),"), _c('a', {
    attrs: {
      "id": "fn16"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" which restores and reconciles relationships between God and humans, as well as relationships between people who had been at odds with each other. This divine shalom, then, is a concrete social reality whose arrival is good news indeed. As we will see, a community that has been granted it will also be called upon, as a Spirit-inhabited community, to act as God’s channel of granting that shalom to others in Thessalonica."), _c('a', {
    attrs: {
      "id": "fn17"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the outset, these comments need more clarification with regard to the relationship between God (i.e., the Father, in Paul’s terminology) and the Lord Jesus Christ. The community owes its existence to the actions of both and inhabits both. At times in these letters, their actions can be clearly distinguished (e.g., 1:10), and at other times they are quite difficult to distinguish (e.g., 3:11; 2 Thess 2:16–17). There is, then, a kind of blurring of the lines between the "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("actions on behalf of the audience of God the Father and those of the Lord Jesus Christ. On the one hand, this situation bears some analogy—albeit with significant differences—to the way that the current emperor, even if not always conceived of as divine, was called lord ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κύριος")]), _vm._v(", "), _c('i', [_vm._v("kyrios")]), _vm._v(") and was perceived to act on behalf of the gods as their special agent because the gods had shown favor to him,")]), _c('a', {
    attrs: {
      "id": "fn18"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" and through him to Rome. Hence, there could be a blurring of the lines between the actions of the emperor and the actions of the gods, between human action and divine action. Such a theological legitimation of the political situation had deep roots in the ancient world, and the resulting conceptual framework funded the demand for loyalty to the emperor, the various gods of Rome, and the polity over which the emperor was the head.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This framework was less problematic in a polytheistic Greco-Roman context than in the context of Judaism, with its concern for the unique identity of Israel’s God Yahweh, a context that Paul never abandoned. It is therefore significant that, in the opening of both epistles, Paul makes a close connection between God the Father and the "), _c('i', [_vm._v("Lord")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κύριος")]), _vm._v(", "), _c('i', [_vm._v("kyrios")]), _vm._v("), Jesus Christ, whom 1:10 identifies as “his [God’s] son.” In most cases the LXX uses "), _c('i', [_vm._v("kyrios")]), _vm._v(" as a reverential circumlocution for Yahweh, a common practice among religious Greek-speaking Jews."), _c('a', {
    attrs: {
      "id": "fn19"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The use of "), _c('i', [_vm._v("kyrios")]), _vm._v(" to refer to Jesus permeates not only Paul’s letters but also the entirety of the New Testament. While in some contexts it carries no divine connotations (e.g., Matt 15:27), other contexts use language from OT texts that originally refer to Yahweh and apply it directly to Jesus as "), _c('i', [_vm._v("kyrios")]), _vm._v(" (e.g., Rom 10:13; 1 Cor 1:8; 2 Cor 3:15–18; Acts 2:21, 36; Mark 1:2–3)."), _c('a', {
    attrs: {
      "id": "fn20"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Such linguistic practice is all the more significant when one recognizes that the NT continues to use "), _c('i', [_vm._v("kyrios")]), _vm._v(" to refer to God as well (e.g., Rom 11:34; Mark 13:20; Luke 1:6). Hence, both God the Father and his Son, Jesus, share the divine name, or identity. The cumulative effect is to include Jesus as Lord in the unique identity of the one God of Israel in a way that makes the relationship between the Father and the Son constitutive of that God’s identity."), _c('a', {
    attrs: {
      "id": "fn21"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" As such, there is a theological legitimation of the new sociopolitical situation in which the Thessalonians "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("find themselves, somewhat analogous to that of the imperial Roman order. As members of an alternative polity, their loyalty could be to only one God, the God of Israel, whose identity included a Jew crucified by the empire, vindicated by God (the Father’s) raising him from the dead by means of the life-giving Spirit.")]), _c('a', {
    attrs: {
      "id": "fn22"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Only by means of this Spirit’s activity (1:6; cf. 1 Cor 12:3) were they able to confess this crucified and raised Jew, the Son of the Father, as Lord of the entire cosmos."), _c('a', {
    attrs: {
      "id": "fn23"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Hence, the identity of the God whom the Thessalonians had encountered included the Father, the Son, and the Spirit and was constituted by the reciprocal relations between them.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s02"
    }
  }, [_vm._v("1:2–3:13"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Faith Working through Love, Resulting from Paul’s Faithful Ministry")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("As was typical of ancient letters, after the prescript Paul begins the letter with a thanksgiving section. In some letters it is easy to see where a thanksgiving section starts and stops (e.g., 1 Cor 1:4–9; Phil 1:3–11). But in 1 Thessalonians Paul mentions giving thanks to God regarding the audience again in 2:13 and 3:9 and never seems to make a clear break in the text until starting the petitionary prayer at 3:11. The effect is to make it unclear where any identifiable thanksgiving section stops and the body of the letter proper begins. Hence, various interpreters see the end of this section in different places (e.g., 1:10; 2:12 or 13; 3:10 or 13). The variety of attempts to address this issue utilizing both epistolary and rhetorical categories testifies to the difficulty, if not the impossibility, of arriving at a full consensus as to the letter’s structure."), _c('a', {
    attrs: {
      "id": "fn24"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Such difficulty may suggest that Paul himself simply was not concerned with operating within the constraints of either formal epistolary or rhetorical categories in this letter. In any case, it is not clear that the continuing debate over such issues ultimately has much theological impact.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The following brief outline of the first major section of this letter will be sufficient for our purposes. We will assume that the letter’s first major section begins with a thanksgiving in 1:2–10, the body of the letter starts in 2:1–12, and the first major section ends with Paul’s petitionary prayer for the audience "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("in 3:13.")]), _c('a', {
    attrs: {
      "id": "fn25"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" In this first major section (1:2–3:13) Paul attempts to reinforce and shape the audience’s understanding of who they are and how they ought to conduct their life together by focusing on (1) the audience’s “faith working through love” as their thankful response to the gospel, and (2) the model of Christian living manifest in his own faithful ministry and concern for the audience. The focus of 1:2–10 is on Paul’s thanksgiving for what God has accomplished "), _c('i', [_vm._v("among and by")]), _vm._v(" the addressees. In these verses Paul gives thanks for the audience primarily because of God’s election of them (1:4), which is evident because of the way his gospel came ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθη")]), _vm._v(", "), _c('i', [_vm._v("egenēthē")]), _vm._v(") to them (v. 5) and because of what the audience themselves became ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθητε")]), _vm._v(", "), _c('i', [_vm._v("egenēthēte,")]), _vm._v(" vv. 6–7) as a result of their reception of this good news (vv. 6–10). Paul begins the body of the letter in 2:1–12 by enlarging on the way his gospel came to the audience, specifically in terms of the “sort of people” (1:5) Paul and his companions proved to be. He then moves back to focus on the audience in 2:13–16 with another thanksgiving for what the audience became as a result of their reception of the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 2:17–3:10 Paul focuses on what has transpired in his relationship with the audience since he left Thessalonica, including his concern for their bearing up under persecution and Timothy’s good report regarding their faithfulness. The latter evokes another expression of thanks for the audience in 3:9–10 before Paul finishes off this first major section with a petionary prayer (3:11–13) that touches on important themes of the second major section of the letter, namely, holiness and eschatology.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s03"
    }
  }, [_c('i', [_vm._v("1:2–10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Thanksgiving for What God Has Done among and by the Thessalonians")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("2")]), _vm._v("We’re always giving thanks to God for all of you by making mention [of you]"), _c('a', {
    attrs: {
      "id": "fn26"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" in our prayers time and time again"), _c('a', {
    attrs: {
      "id": "fn27"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('sup', [_vm._v("3")]), _vm._v("because we remember your work engendered by faithfulness, your labor flowing from love, and your perseverance that results from your hope for the Lord, Jesus Christ, [to come] in the presence of our God and Father. "), _c('sup', [_vm._v("4")]), _vm._v("We offer this thanks, brothers and sisters"), _c('a', {
    attrs: {
      "id": "fn28"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" whom God loves, because "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("we know God’s election of you all. "), _c('sup', [_vm._v("5")]), _vm._v("We know this because our good news did not come to you in word only, but indeed with power; that is,")]), _c('a', {
    attrs: {
      "id": "fn29"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" it came empowered by the Holy Spirit and in a fully persuasive way—just as you know what sort of people we became among you for your sake. "), _c('sup', [_vm._v("6")]), _vm._v("And [we know that God has elected you all because]"), _c('a', {
    attrs: {
      "id": "fn30"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" you began imitating us and the Lord after you received the word in much tribulation with joy that came from the Holy Spirit. "), _c('sup', [_vm._v("7")]), _vm._v("The result of this [evidenced election] is that together you became a [singular] pattern"), _c('a', {
    attrs: {
      "id": "fn31"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" for all those who are exercising believing allegiance in Macedonia and Achaia. "), _c('sup', [_vm._v("8")]), _vm._v("For from you, the word about the Lord has rung out echoing in every direction, not only in Macedonia and Achaia, but in every place your faithfulness to God has gone forth, so that we do not need to say anything [about it]. "), _c('sup', [_vm._v("9")]), _vm._v("For they themselves are talking publicly about us, about the sort of first visit we had with you. That is,"), _c('a', {
    attrs: {
      "id": "fn32"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" [they are talking publicly about] how you turned to God from idols to be enslaved to the living and true God "), _c('sup', [_vm._v("10")]), _vm._v("and to await his Son from heaven, whom he raised from the dead, Jesus, who is rescuing ("), _c('i', [_vm._v("or")]), _vm._v(" is going to rescue) us from the coming wrath.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Paul begins the section by giving his audience reasons"), _c('a', {
    attrs: {
      "id": "fn33"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" why he and his cosenders are always giving thanks to God for them. They are doing so, first, because they remember the audience’s work, labor, and perseverance (v. 3), and second, because they know that God has elected the audience (v. 4). Each reason deserves further comment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first reason (v. 3) that Paul and his companions are giving thanks for the audience is that they remember the Thessalonians’ work engendered by faithfulness ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πίστεως")]), _vm._v(", "), _c('i', [_vm._v("pisteōs")]), _vm._v("), their labor flowing from love ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγάπης")]), _vm._v(", "), _c('i', [_vm._v("agapēs")]), _vm._v("), and their perseverance resulting from hope ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐλπίδος")]), _vm._v(", "), _c('i', [_vm._v("elpidos")]), _vm._v("). Although there are other possibilities,"), _c('a', {
    attrs: {
      "id": "fn34"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" it makes the most sense to take the three genitive nouns (faithfulness, love, hope) as indicating the origin of the noun that precedes them."), _c('a', {
    attrs: {
      "id": "fn35"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" In any "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("case, the point is that the nouns before each genitive noun (work, labor, perseverance) derive from, and embody a particular form of, the noun that follows it.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("In Paul’s usage, there is little, if any, difference between “work” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἔργον")]), _vm._v(", "), _c('i', [_vm._v("ergon")]), _vm._v(") and “labor” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κόπος")]), _vm._v(", "), _c('i', [_vm._v("kopos")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn36"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Both terms connote low-status activity, a pattern of life that is burdensome, requiring exertion and hardship. As we will see, in 1 and 2 Thessalonians such exertion and hardship is depicted as having a cruciform character, that is, as laborious activity connected with proclaiming and embodying the gospel for the sake of others."), _c('a', {
    attrs: {
      "id": "fn37"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Hence, Paul initially depicts the audience as engaging in “work” and “labor,” just as he and his companions had done as the very means of proclaiming and embodying the good news (2:9–10)."), _c('a', {
    attrs: {
      "id": "fn38"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" This response constitutes an “imitation” of both Paul and the Lord (1:6, enlarged on in vv. 7–8) and portrays the audience right up front as engaging in a pattern of life in which they are participants in the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" the mission of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first time we encounter the word "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πίστις")]), _vm._v(" ("), _c('i', [_vm._v("pistis,")]), _vm._v(" “faithfulness, loyalty, faith, trust”) in 1 Thessalonians (v. 3), Paul is recalling this cruciform work of the audience that was engendered by their "), _c('i', [_vm._v("pistis")]), _vm._v(" (faithfulness, faith). For some this may seem odd, given the common claim that, for Paul (particularly the Paul of Galatians and Romans), work(s) is opposed to faith ("), _c('i', [_vm._v("pistis")]), _vm._v("). Such a view is only partly true at best and positively misleading at worst!"), _c('a', {
    attrs: {
      "id": "fn39"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Part of the problem is that many translators and interpreters fail to acknowledge the larger field of meaning of "), _c('i', [_vm._v("pistis.")]), _vm._v(" While its semantic range includes belief and trust, in 1 and 2 Thessalonians Paul most often uses "), _c('i', [_vm._v("pistis")]), _vm._v(" in the sense of faithfulness or loyalty,"), _c('a', {
    attrs: {
      "id": "fn40"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("and its verbal cognate, "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πιστεύω")]), _vm._v(" ("), _c('i', [_vm._v("pisteuō,")]), _vm._v(" “I trust, I believe, I am faithful”), in the sense of “exercising believing allegiance.”")]), _c('a', {
    attrs: {
      "id": "fn41"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Hence, "), _c('i', [_vm._v("pistis")]), _vm._v(" in these letters has in its very essence an element of fidelity and obedience. Michael Gorman’s words appropriately describe the way Paul uses "), _c('i', [_vm._v("pistis")]), _vm._v(" in these letters: “Faith is humanity’s appropriate posture before God. It is devotion, total commitment, faithfulness.”"), _c('a', {
    attrs: {
      "id": "fn42"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" The first thing, then, in the list causing Paul and his companions to give thanks is his audience’s work engendered by, or embodying, their faithfulness. That is, he gives thanks for their work that flows from, and embodies, their believing allegiance or total commitment to God the Father and the Lord Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, the audience’s labor flows from their love ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγάπη")]), _vm._v(", "), _c('i', [_vm._v("agapē")]), _vm._v("), which means that their love is embodied by activities requiring exertion and hardship. The sort of love to which Paul is referring, then, is not simply an inner emotion “but a total disposition of one’s life that involves deliberate choices and determined effort.”"), _c('a', {
    attrs: {
      "id": "fn43"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" It is embodied in the kind of self-giving practices Paul narrates in 2:6–12, practices that exhibit a cruciform structure paralleling the actions of Christ in Phil 2:6–8."), _c('a', {
    attrs: {
      "id": "fn44"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, the audience’s perseverance is their capacity to endure suffering under extreme pressure (like Paul himself, as in 2 Cor 6:4; 12:12),"), _c('a', {
    attrs: {
      "id": "fn45"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" a capacity that is engendered by and embodies the hope they have for the royal coming ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παρουσία")]), _vm._v(", "), _c('i', [_vm._v("parousia")]), _vm._v(") of the Lord Jesus Christ, as in 1:10, and the salvation it brings."), _c('a', {
    attrs: {
      "id": "fn46"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" It seems likely that “hope” has this specific content, given the way Paul uses the word elsewhere in 1 Thessalonians. In 5:8 the specific content of hope is “salvation,” which clearly takes place at the parousia, and in 2:19 and 4:13 “hope” appears with the parousia in view. As the translation indicates, this hope for the Lord’s royal coming is connected with and brings with it the very “presence of God our Father.”"), _c('a', {
    attrs: {
      "id": "fn47"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" And as I will argue later, we have at least "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("an implicit theological warrant for affirming the Spirit’s presence and activity in this royal coming, so that one ought to imagine the Son’s royal coming as a pneumatological—and thus, fully Trinitarian—event.")]), _c('a', {
    attrs: {
      "id": "fn48"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As attentive readers of Paul would have already noticed, prominent in these two verses is the familiar Pauline triad of faith(fulness) ("), _c('i', [_vm._v("pistis")]), _vm._v("), love ("), _c('i', [_vm._v("agapē")]), _vm._v("), and hope ("), _c('i', [_vm._v("elpis")]), _vm._v(") (e.g., 1 Cor 13:13; Gal 5:5–6; Col 1:4–5). This triad appears again in 5:8, where Paul depicts "), _c('i', [_vm._v("pistis")]), _vm._v(" and "), _c('i', [_vm._v("agapē")]), _vm._v(" as one singular “breastplate.” Hence, while faith(fulness) and love can indeed be distinguished, they cannot be separated. In fact, it is precisely the audience’s "), _c('i', [_vm._v("pistis")]), _vm._v(" and "), _c('i', [_vm._v("agapē")]), _vm._v(" that form the content of the good news that Timothy reports back to Paul in 3:6. The other defensive piece of armor in 5:8 is a helmet, which is explicated as the “"), _c('i', [_vm._v("hope")]), _vm._v(" for salvation,” a salvation that, according to the context, is clearly eschatological. Hence, at the beginning of this letter as well as toward the end, this audience is depicted as characterized by the Pauline triad of “faith(fulness), love, and hope.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While it would be forced to argue that this triad actually structures the rest of the letter, it does give the audience a preview of the letter’s coming attractions. The audience’s faithfulness is clearly an issue and is positively referred to at various points throughout the letter (1:8; 2:10, 13; 3:1–8; 5:8), as is their love (3:6; 5:8). And in both 1:3 and 5:8, the audience has hope for the coming salvation connected with the Lord’s royal coming (parousia), which is the catalyst for the Day of the Lord. But their faithfulness, love, and hope are not static. Their faithfulness has something that is lacking, which Paul thinks he can remedy (3:10). Their love is something that Paul prays that the Lord will enable to increase and abound (3:12). And their hope clearly needs refining, lest they grieve “like those who have no hope” (4:13). Hence, in spite of all the positive things Paul will go on to say about this audience, it is clear that their life together, like that of any flesh and blood church of any time or place, is a work—both divine and human—in progress.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 4 Paul gives the second reason why he and his cosenders are giving thanks for the audience, namely, because they know their election ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐκλογή")]), _vm._v(", "), _c('i', [_vm._v("eklogē")]), _vm._v("). Here Paul draws on language that relates this Gentile audience in some way with the story of God’s dealings with Israel. The language of election (electing, elect, chosen) occurs throughout the OT to refer to God’s choosing Israel."), _c('a', {
    attrs: {
      "id": "fn49"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Such "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("language reflects OT covenantal language about God’s love for, and choice of, Israel to be God’s holy people (e.g., Deut 7:6; 14:2). It recalls the entire complex of ideas about God’s electing Israel "), _c('i', [_vm._v("as a whole people,")]), _vm._v(" saving them, rescuing them, and setting them apart—or “sanctifying” them—both because of his love for them and so that they might become an instrument for his saving mission (Ps 105:6; Isa 41:8–10; 42:1; 44:2; 49:1–7 [LXX]).")]), _c('a', {
    attrs: {
      "id": "fn50"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Similarly, here Paul refers to his Gentile audience as “brothers and sisters beloved by God,” those who have experienced God’s love when he elected them and continue to experience that love in the present."), _c('a', {
    attrs: {
      "id": "fn51"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At this juncture, it is important to state explicitly a theological assumption that will undergird our understanding of the concept of election in this commentary, namely, that the concept of election in the NT has been christologically reconfigured. A number of NT texts describe Jesus as God’s elect or holy one (Luke 9:35; 23:35; Mark 1:24; John 6:68–69), and 1 Pet 1:20 affirms that he was “chosen beforehand before the foundation of the world.” While the Pauline corpus does not explicitly use the language of Jesus being God’s Elect One, a good case can be made that the writer of Ephesians (whether Paul or someone else) implies this very thing in 1:4–6, describing Jesus in Israel-like terms as “the beloved one” (v. 6) "), _c('i', [_vm._v("in whom he elected")]), _vm._v(" the audience “from before the foundation of the world.”"), _c('a', {
    attrs: {
      "id": "fn52"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Arguably, these verses encapsulate a current that runs throughout Paul’s writings, namely that, in Jesus, Israel’s representative Messiah, the theology of election has been definitively reconfigured."), _c('a', {
    attrs: {
      "id": "fn53"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" We will therefore assume that Jesus is indeed God’s primary Elect One and that others are secondarily elect in him. Hence, individual Thessalonians are indeed elect and holy, but only insofar as they are “in Christ,” God’s Elect, Holy One; that is, only insofar as they are an ongoing part of a "), _c('i', [_vm._v("corporate")]), _vm._v(" body of the risen, cruciform Christ in Thessalonica.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Only in 1 Cor 1:26–28 does Paul use the verb “elect,” and there he implicitly "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("equates God’s election, or choosing, with God’s calling ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κλῆσις")]), _vm._v(", "), _c('i', [_vm._v("klēsis")]), _vm._v("), as he does elsewhere (e.g., Rom 9:11–12; 11:28–29; cf. 8:30 with 8:33; cf. 2 Pet 1:10).")]), _c('a', {
    attrs: {
      "id": "fn54"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" In 2 Thess 2:13 Paul uses a synonym of “elect” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("αἱρέομαι")]), _vm._v(", "), _c('i', [_vm._v("haireomai")]), _vm._v(") in a way that makes God’s choosing functionally equivalent to God’s calling in 2:14 (see comments). Hence, although Paul does not use the specific term for election in the remainder of 1 and 2 Thessalonians, he refers to God’s calling of the audience several times (1 Thess 2:12; 4:7; 5:24; 2 Thess 1:11), rhetorically emphasizing that God’s initiative of election underlies everything in the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is worth making explicit at this point that the language of election and call in this letter or in Paul as a whole does not have to do with the predestination of only some “elect” individuals for salvation and the predestination of other individuals, the “nonelect,” for damnation (so-called double predestination). Rather, the language of election has to do with “goal and actualization.”"), _c('a', {
    attrs: {
      "id": "fn55"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Ben Meyer’s succinct definition of election in the biblical tradition is to the point: “It is divine love sovereignly choosing its instruments for the realization of a divine plan.”"), _c('a', {
    attrs: {
      "id": "fn56"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The purpose of their election is so that, as beneficiaries of the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" they themselves might become participants in it. Following Suzanne McDonald, we could say that this is to characterize election as “election to representation.”"), _c('a', {
    attrs: {
      "id": "fn57"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Her full-length theological analysis of election moves along representational lines, insisting that God’s election is very particular, involving only the specific ecclesial community (contra Barth), those “in Christ” by means of the Spirit. However, this community is elect so that")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("they can represent God to others and others to God, and that in doing so . . . [hold] those who are apparently rejected within the sphere of God’s promised blessing. . . . Election to representation insists that the elect are those through whom God’s purpose of blessings unfolds, partially and proleptically, in the sphere of human history. . . . God’s purpose in electing a people for himself is that God’s loving justice and salvation might reach to the ends of the earth."), _c('a', {
    attrs: {
      "id": "fn58"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("They are elect, in other words, so that they might proclaim and embody the “good news,” or the “gospel” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐαγγέλιον")]), _vm._v(", "), _c('i', [_vm._v("euangelion")]), _vm._v("), a term we first encounter "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("in v. 5. “Gospel” in Paul’s letters and in the NT as a whole is not a “plan of salvation” for individuals, although it is certainly related to the salvation of individual persons.")]), _c('a', {
    attrs: {
      "id": "fn59"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Even though Paul nowhere explicitly defines the word "), _c('i', [_vm._v("euangelion,")]), _vm._v(" I, as well as all other interpreters of Paul, make very important interpretive decisions based on what we assume as its content. Based on a number of summary-type passages, and taking into account the imperial background of Paul’s context sketched in the introduction to the commentary, I briefly set out here my understanding of this important word.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s04"
    }
  }, [_vm._v("Excursus on the Meaning of “Gospel”")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In Paul’s letters, I take "), _c('i', [_vm._v("euangelion")]), _vm._v(" to be a narrative account about a particular version of good news that, whether by design or consequence, stood in contrast to Rome’s imperial version of good news and its (false) claim to have brought lasting peace to the world."), _c('a', {
    attrs: {
      "id": "fn60"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" This good news is that the Creator God, in a display of saving covenant faithfulness to Israel, has graciously invaded the cosmos in order to reclaim and reestablish sovereignty over a world enslaved by the powers of Sin and Death. This invasive act of covenant faithfulness is constituted by (1) Jesus’ whole life of covenant faithfulness (i.e., his fidelity to God and love toward others) who, in the power of the Holy Spirit, went to his death in obedience;"), _c('a', {
    attrs: {
      "id": "fn61"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" and (2) God, through that same Spirit, justifying, or vindicating, Jesus via a transformative resurrection and subsequent exaltation, declaring him to be both Israel’s Messiah and, consequently,"), _c('a', {
    attrs: {
      "id": "fn62"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" the true Lord of the whole world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This good news is indeed a theopolitical announcement, an announcement "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("of good news that the Savior God has begun effecting the salvation characterized by the true peace, or shalom, that he had promised (e.g., Isa 52:7–10). It is a salvation that will be consummated at the royal coming of the Lord, Jesus Messiah, when God will make the world right by bringing judgment, raising the dead, and renewing and sanctifying all of creation. In the meantime, humans can share proleptically in that final salvation through "), _c('i', [_vm._v("pistis")]), _vm._v(" and baptism into Christ, becoming part of a community that has experienced God’s peace in their forgiveness and reconciliation with God and each other. This people analogously shares Christ’s cruciform life of covenant faithfulness, thereby publicly embodying a way of living that challenges the current values of any manifestation of empire, whether in a first-century or twenty-first-century version.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Michael Gorman describes the “gospel” similarly:")])]), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('i', [_vm._v("The gospel of God is not a set of propositions; it is the account of the planned, executed, and soon-to-be-consummated benevolent invasion of God into the history of Israel, human history more generally, and the entire cosmos to set right a world gone awry.")]), _vm._v(" Both the invasion itself and the retelling of it (in various forms and with various emphases) effect transformation in those who receive the message for what it is—good news of God’s action in Christ and the Spirit. This is why Paul can say that the gospel is “the power of God for salvation to everyone who has faith, to the Jew first and also to the Greek” (Rom 1:16).")]), _c('a', {
    attrs: {
      "id": "fn63"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Hence, I understand the word "), _c('i', [_vm._v("euangelion")]), _vm._v(" to function as a “metaleptic prompt,” a word that is intended to evoke something like the above when heard by the audience of the letter."), _c('a', {
    attrs: {
      "id": "fn64"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" I also assume that Paul might have appealed to any number of its aspects in his initial preaching.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Verses 5–6 (with v. 6 further explicated in vv. 7–10) constitute the two-part reason"), _c('a', {
    attrs: {
      "id": "fn65"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" why Paul can say that he and his companions know that his audience has been elected by God: (1) because of the way their gospel came ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθη")]), _vm._v(", "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('i', [_vm._v("egenēthē")]), _vm._v(") to the audience (v. 5) and (2) because of what the audience themselves became ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθητε")]), _vm._v(", "), _c('i', [_vm._v("egenēthēte,")]), _vm._v(" vv. 6–7)")]), _c('a', {
    attrs: {
      "id": "fn66"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" as a result of their reception of this good news (vv. 6–10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, the audience’s election is clear to Paul and his cosenders because their gospel not only came to the audience in word/speech ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("λόγος")]), _vm._v(", "), _c('i', [_vm._v("logos")]), _vm._v("), that is, as an oral proclamation."), _c('a', {
    attrs: {
      "id": "fn67"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" It also came in a way that Paul associates with “power,” the “Holy Spirit,” and a “fully persuasive way.” Each of these terms follows the preposition "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν")]), _vm._v(" ("), _c('i', [_vm._v("en,")]), _vm._v(" “in, by, with”),"), _c('a', {
    attrs: {
      "id": "fn68"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" indicating that they are functioning adverbially to describe how “our gospel came,” and each of them is grammatically connected with the other two with a "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καί")]), _vm._v(" ("), _c('i', [_vm._v("kai,")]), _vm._v(" “and, indeed, that is”). The main interpretive question is how they are connected with each other. Are they three separate elements in Paul’s description of how the gospel came to the audience, or are they more closely related?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul associates power with the Holy Spirit in a similar context (1 Cor 2:4; cf. Rom 15:13), which makes it likely that they are connected here as well. Hence, while there are other options,"), _c('a', {
    attrs: {
      "id": "fn69"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" it makes good sense to take the second "), _c('i', [_vm._v("kai")]), _vm._v(" as explanatory (“that is”), with the next two terms functioning to clarify the phrase “with power.”"), _c('a', {
    attrs: {
      "id": "fn70"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" On this reading, the sense would be that their oral account of the gospel came to the audience with a power that (1) was generated by the Holy Spirit and (2) was connected with “full persuasion” of the truth of the proclamation, which itself corresponded to the sort of people Paul and his cosenders were among them."), _c('a', {
    attrs: {
      "id": "fn71"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" That is, not only did the Spirit empower their gospel proclamation, but the Spirit-enabled way Paul acted among them embodied the truth of the content of the proclaimed gospel, which contributed to its power to persuade the audience to confess Jesus as Lord of the cosmos. In 2:1–12 Paul "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("describes in detail this way of acting in terms that draw on what would have been familiar friendship language,")]), _c('a', {
    attrs: {
      "id": "fn72"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" as well as the language of popular moral philosophy."), _c('a', {
    attrs: {
      "id": "fn73"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" And he uses such language in ways that depict these actions in terms of an overall pattern of life, that is, one that is cruciform in nature and thereby analogous to the covenant faithfulness of Jesus himself expressed in loyalty to God and self-giving actions toward others. Hence, not only did the proclamation of this gospel take the empowering presence of the Holy Spirit acting upon its hearers to give it persuasive and liberating power; it took a concrete, Spirit-enabled reembodiment of its essence by its proclaimers."), _c('a', {
    attrs: {
      "id": "fn74"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" One part of the reason, then, that Paul and his companions know that God has elected this audience is the powerful way their gospel came to the Thessalonians.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second part of the reason they know that God has elected the audience is "), _c('i', [_vm._v("what the audience themselves became")]), _vm._v(" as a result of their reception of this good news, initially described in v. 6 as “imitators of us and of the Lord” (cf. 2:14). The meaning of this phrase is disputed."), _c('a', {
    attrs: {
      "id": "fn75"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Contextually, it makes little sense if Paul is trying to draw an analogy between his and (especially) the Lord’s "), _c('i', [_vm._v("reception")]), _vm._v(" of the good news and that of the Thessalonians. It would make better sense if the passage is referring to a pattern of life that the audience exhibited after they received the good news that is somehow analogous to that of Paul and his cosenders and to that of the Lord."), _c('a', {
    attrs: {
      "id": "fn76"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" In other contexts when Paul encourages his congregations to imitate him (1 Cor 4:16; 11:1; Phil 3:17; cf. Eph 5:1; 1 Tim 4:12; Titus 2:7), such imitation has to do with an overall cruciform pattern of life, that is, fidelity to God and self-giving love for others (see comments on 2 Thess 3:7, 9)."), _c('a', {
    attrs: {
      "id": "fn77"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" Hence, in light of the letter’s emphasis on the fidelity of the audience in "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("the face of tribulation (including the immediate context of 1:8–10), as well as the pattern of Paul’s own life that emerges in 2:1–12, the meaning of v. 6 is reasonably clear. Being “imitators of us and of the Lord” would entail the audience themselves exhibiting their own “nonidentical repetition”")]), _c('a', {
    attrs: {
      "id": "fn78"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" of the covenant faithfulness of Jesus expressed in faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and self-giving actions toward others that they had seen exemplified in the actions of Paul and his cosenders."), _c('a', {
    attrs: {
      "id": "fn79"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" In other words, they are not necessarily slavishly imitating specific actions of Paul or of the Lord."), _c('a', {
    attrs: {
      "id": "fn80"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" Rather, they have been formed by, and are now embodying, an overall life pattern in their own particular context that is analogous to the pattern of life displayed by Paul and the Lord in theirs. This is the essential meaning of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τύπος")]), _vm._v(" ("), _c('i', [_vm._v("typos,")]), _vm._v(" “example, pattern”) in v. 7, namely, a pattern into which something has been formed that can then be used as the pattern to form other things into an analogous pattern."), _c('a', {
    attrs: {
      "id": "fn81"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To be clear, while such a life pattern does not exclude human effort, to place the emphasis on human effort per se would miss the nuances of what the imitation of Christ entails in the Pauline corpus. Imitating Christ is more the result of a power at work—none other than the Spirit of God and of Christ—that “enables the exalted crucified Christ to take shape in and among those who belong to him and live in him . . . [which therefore] enables the narrative of the cross to be retold and relived.”"), _c('a', {
    attrs: {
      "id": "fn82"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" This result is basically what Paul goes on to describe in the next few verses (esp. v. 8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Their exhibition of fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and self-giving actions toward others (e.g., 3:12; 5:15) began after they received the word (i.e., the gospel) in much "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("θλῖψις")]), _vm._v(" ("), _c('i', [_vm._v("thlipsis,")]), _vm._v(" “tribulation,” v. 6; cf. Mark 4:17). This is the first time in the letter that Paul mentions the audience’s tribulation and suffering. As Acts 17 affirms, he depicts them as having undergone tribulation and suffering in the past (1 Thess 1:6; 2:14–15; 3:3–4), which we should probably imagine as continuing (see comments on 1 Thess 3:3, 8). This is not generic suffering (i.e., sickness, accidental injuries) but suffering that is part of the vocation of Christians."), _c('a', {
    attrs: {
      "id": "fn83"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" In every case, the audience is depicted as suffering at the hands of others, which is "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("not surprising, given the way Paul describes their actions in v. 9. From a contemporary perspective, their “turning to the living and true God from idols” (1:9) may look like a change in their religious affections—granted, a rather large change in their “religious life.” But such a conclusion would fail to see that “religion” in antiquity was not a separate category from the rest of cultural life. It permeated every aspect—social, political, economic—of the culture. As Kavin Rowe puts it, “To call into question pagan religion is to critique pagan culture: tear out the threads of pagan religiousness and the cultural fabric itself comes unraveled.”")]), _c('a', {
    attrs: {
      "id": "fn84"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Thessalonians’ “turning to the living and true God from idols” would mean becoming a part of a particular community known for publicly visible actions of refusing to honor (at least) the gods of traditional Greco-Roman religion. Refusing to engage in “normal” activities like public festivals, trade association meetings in temples, or various private celebrations (e.g., birthday parties, weddings) in local temples might indeed be understood by others as threatening to destabilize the culture."), _c('a', {
    attrs: {
      "id": "fn85"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" In fact, given that the gods were seen as the city’s benefactors, such refusals might be conceived as bringing their wrath (e.g., in the form of earthquakes, floods, or agricultural failure)."), _c('a', {
    attrs: {
      "id": "fn86"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" If, as is likely, such a failure to honor the gods extended to the deified Caesars, others would have probably perceived this behavior as threatening not only the peace and security of the city but that of the empire as a whole, "), _c('i', [_vm._v("even if Christians never intended any such thing.")]), _c('a', {
    attrs: {
      "id": "fn87"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" At the very least, such actions would have been economically and socially costly for the Thessalonians. The result would no doubt have been “much tribulation or pressure” (1:6), most probably in the form of social ostracism, verbal harassment, possible political sanctions, and perhaps even sporadic physical violence."), _c('a', {
    attrs: {
      "id": "fn88"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to Paul, such tribulation/suffering in the Thessalonians’ sociopolitical context is simply inevitable (1 Thess 3:3–4). It would have brought with it a clear ascription of public dishonor from the audience’s neighbors and probably "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("from those within their own households (esp. if the head of their extended household was not a member of the "), _c('i', [_vm._v("ekklēsia")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn89"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" Hence, in their social context, it is a "), _c('i', [_vm._v("distinct possibility")]), _vm._v(" that their loyalty to God and their self-giving actions toward others would have resulted in physical violence directed toward them, but a "), _c('i', [_vm._v("virtual certainty")]), _vm._v(" that it would have resulted in their having dishonor publicly ascribed to them, both individually and corporately. Even so, in the midst of this tribulation and the ensuing dishonor, they received the gospel, not only with Spirit-empowered, active faith and faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") and love, but also with joy produced by that same Holy Spirit. As a result, they proved themselves not to be “short-time” disciples without root who fell away when tribulations or persecutions came (Mark 4:17); rather, they were those whose lives evidenced the fruit of the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" as Paul goes on to describe in the next few verses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In imitating Paul, his companions, and the Lord, "), _c('i', [_vm._v("their corporate life together, their ecclesial body as a whole,")]), _vm._v(" in turn became a singular "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τύπος")]), _vm._v(" ("), _c('i', [_vm._v("typos,")]), _vm._v(" “pattern, model”) to all those who were exercising believing allegiance in Macedonia and Achaia (v. 7). Hence, the faithful way this audience conducted their corporate life together in the midst of tribulation functioned as a pattern for (presumably) the churches in Philippi and Corinth in shaping their own ecclesial life together. Paul’s declaration of this faithful witness effectively ascribes a supralocal honor to this audience in an alternative court of reputation—namely, God’s."), _c('a', {
    attrs: {
      "id": "fn90"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" Verse 8 functions as a virtual warrant for Paul’s assertion."), _c('a', {
    attrs: {
      "id": "fn91"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" He can speak so positively about their ecclesial life because "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ λόγος τοῦ κυρίου")]), _vm._v(" ("), _c('i', [_vm._v("ho logos tou kyriou,")]), _vm._v(" “the word [or oral proclamation] about the Lord”)"), _c('a', {
    attrs: {
      "id": "fn92"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" has rung forth from the audience and continued to reverberate,"), _c('a', {
    attrs: {
      "id": "fn93"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" not just in Macedonia and Achaia, but as the second half of the verse implies, in every place. Hence, in imitating Paul and his companions, the "), _c('i', [_vm._v("euangelion,")]), _vm._v(" the "), _c('i', [_vm._v("logos")]), _vm._v(" about the Lord’s faithfulness, has rung forth from the audience and continued to reverberate in some form of oral proclamation. Since it would have affirmed Jesus’ universal lordship, its reverberating effects would, at the very least, have included an implicit calling into question of their culture’s idolatry.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("There is a continuing debate over whether Paul expected his congregations to orally proclaim the gospel.")]), _c('a', {
    attrs: {
      "id": "fn94"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" Given the comments above that "), _c('i', [_vm._v("logos")]), _vm._v(" (word, speech, oral proclamation) and "), _c('i', [_vm._v("euangelion")]), _vm._v(" (gospel) are virtual synonyms in 1 Thessalonians, it is a false dichotomy to argue that Paul is depicting his audience here as embodying the good news "), _c('i', [_vm._v("rather than")]), _vm._v(" proclaiming it."), _c('a', {
    attrs: {
      "id": "fn95"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" They go hand in hand, and the most natural reading of the language here indicates that the audience was engaged in doing both, although such a conclusion need not mean that the audience was engaged in the same sort of public preaching as was Paul."), _c('a', {
    attrs: {
      "id": "fn96"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" Narrating the gospel orally might take other forms, such as discussing the reason for their change of public behavior with unbelievers in their household or with those visiting their household from other locales, or prophetically calling into question the idolatry of their culture in their daily routine and conversations with others. My suspicion is that, if one does not understand “gospel” in terms of a truncated propositional “sales pitch” relying solely on one atonement model (i.e., penal satisfaction), there is far less impetus to argue that Paul expects his communities only to embody rather than speak the gospel. In any case, in this context, it was God’s power at work in the Thessalonians’ words, giving those words the power to reverberate in all directions as they narrated the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The succeeding phrase in v. 8b, “but in every place,” may be taken with the preceding verb, implying that their proclamation about the Lord did indeed reverberate (hyperbolically) “in every place.” However, the phrase might also go with what follows it. That is, not only their proclamation has reverberated “in every place” but also their faithfulness to God."), _c('a', {
    attrs: {
      "id": "fn97"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" Given that Paul can say that they have no need to say anything about the latter, its going forth “in every place” seems also implied. Hence, Paul’s rhetoric moves seamlessly between the oral proclamation about the Lord reverberating outward from the Thessalonian "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("assembly and the audience’s own faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God in moving outward (with continuing results) in every place,")]), _c('a', {
    attrs: {
      "id": "fn98"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" so that he has no need to say anything about it (cf. Rom 1:8). The effect of this seamless rhetorical move is to sew together the proclamation about the Lord’s "), _c('i', [_vm._v("pistis")]), _vm._v(" with the audience’s own "), _c('i', [_vm._v("pistis,")]), _vm._v(" that is, to combine their verbal expression of the gospel with their embodiment of it."), _c('a', {
    attrs: {
      "id": "fn99"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" They are indeed exercising "), _c('i', [_vm._v("pistis")]), _vm._v(" to God and love toward others as they persevere in tribulation, awaiting with hope their own vindication and future salvation at the royal coming of the Lord (1:3). This life pattern is congruent with the audience’s being imitators of Paul and the Lord, and now their corporate life together is a further example to be imitated by other churches like those in Philippi and Corinth.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although Paul says he has no need to speak about their faithfulness, he does just that in what follows."), _c('a', {
    attrs: {
      "id": "fn100"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" The reason he says he does not need to mention it is that others outside their city are announcing it."), _c('a', {
    attrs: {
      "id": "fn101"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" They are apparently reporting the kind of initial visit Paul and his companions had with the Thessalonians, namely, one of impeccable integrity, in which they embodied the essence of what they proclaimed (see comments on v. 5) and the Thessalonians’ response to it (vv. 9–10). Paul goes on to describe that initial visit in more detail (2:1–12). The focus here, however, is on the report of the audience’s initial and ongoing "), _c('i', [_vm._v("pistis")]), _vm._v(" (faithfulness/fidelity), namely, “how you turned to God away from idols to be enslaved to the living and true God and to await his Son from heaven” (vv. 9b–10)."), _c('a', {
    attrs: {
      "id": "fn102"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" The totality of this phrase defines their "), _c('i', [_vm._v("pistis")]), _vm._v(" in this context in terms of three verbs: "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπεστρέψατε")]), _vm._v(" ("), _c('i', [_vm._v("epestrepsate,")]), _vm._v(" “you all turned”), "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δουλεύειν")]), _vm._v(" ("), _c('i', [_vm._v("douleuein,")]), _vm._v(" “to be enslaved”), and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀναμένειν")]), _vm._v(" ("), _c('i', [_vm._v("anamenein,")]), _vm._v(" “to await”)."), _c('a', {
    attrs: {
      "id": "fn103"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As noted above, since religion permeated every aspect of city life in this culture, a “turning to God away from idols” is not simply a reference to an inner change of disposition. Rather, it would, among other things, refer to publicly visible actions of refusing to join in the variety of ways the Roman gods were honored in society, which would constitute a complete change in their pattern "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("of life. This is clearly “conversion” language,")]), _c('a', {
    attrs: {
      "id": "fn104"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" with Paul depicting his audience as turning to God and thus turning away from their “normal” civic activities, “to be enslaved ["), _c('i', [_vm._v("douleuein")]), _vm._v("] to the living and true God.” With the present tense verb "), _c('i', [_vm._v("douleuein,")]), _vm._v(" Paul portrays others as describing the state of the Thessalonian assembly as one of "), _c('i', [_vm._v("ongoing enslavement to God,")]), _vm._v(" that is, as exhibiting unconditional obedience and loyalty toward God. It is not that their faith ("), _c('i', [_vm._v("pistis")]), _vm._v(") “"), _c('i', [_vm._v("results")]), _vm._v(" in turning from idols, etc., but that faith ["), _c('i', [_vm._v("pistis")]), _vm._v("] "), _c('i', [_vm._v("is")]), _vm._v(" the turning from idols to serve the living God of Israel. A ‘faith in God’ that is not precisely this act of turning and serving is empty.”"), _c('a', {
    attrs: {
      "id": "fn105"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" Hence, what those outside are announcing is the audience’s loyalty to the God of Israel, the concrete form of their “turning to the living and true God to be saved” (cf. Isa 45:22)."), _c('a', {
    attrs: {
      "id": "fn106"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It was common in Second Temple Judaism for Jews to contrast the true and living God of Israel with the dead images of the false gods of Gentiles, who had no power to save or give life (e.g., Jer 10; Wis 13–15)."), _c('a', {
    attrs: {
      "id": "fn107"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" This kind of contrast echoes emphatically monotheistic passages like Isa 44:9–20. As Joel Marcus points out, such polemic was a caricature, given that pagans did not typically worship the images per se but the invisible gods they represented. These images were characteristically thought to participate sacramentally in their power."), _c('a', {
    attrs: {
      "id": "fn108"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Paul himself is typically Jewish at this point. He agrees with the Corinthians that an idol has no real existence (1 Cor 8:4; 10:19) but then goes on in 1 Cor 10:20 to equate these same idols with demons ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δαιμόνια")]), _vm._v(", "), _c('i', [_vm._v("daimonia")]), _vm._v("), thus showing an awareness that these images do somehow participate sacramentally in the power of the invisible realities they represent. It is just that these realities are not the gods they purport to represent (nor are they simply benign intermediate members of a divine hierarchy, as the Corinthians may have imagined)."), _c('a', {
    attrs: {
      "id": "fn109"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Being concerned that some of the Corinthians will be dragged back into the slavery of the whole symbolic system generated by worship of false gods (i.e., into the realm of those perishing, 1 Cor 1:18), Paul admonishes that audience to “flee from idolatry” (1 Cor 10:14).")]), _c('a', {
    attrs: {
      "id": "fn110"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("No doubt Paul could have said that at one point the Corinthian audience had “turned from idols to serve the living and true God,” but clearly there were no guarantees that some of them might not turn back to these same idols. Given this constant reality in their social setting,"), _c('a', {
    attrs: {
      "id": "fn111"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" it is important to note that God’s gracious election of these Corinthians"), _c('a', {
    attrs: {
      "id": "fn112"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" itself was no guarantee that they would persevere in their faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to this God (cf. Gal 4:8–9). The same is clearly true of the Thessalonian audience."), _c('a', {
    attrs: {
      "id": "fn113"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Although they have been elected by God and are now enslaved to God, their fidelity in the face of serious pressure and tribulation is not automatic, any more than was Jesus’ own fidelity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That the Thessalonians’ "), _c('i', [_vm._v("pistis")]), _vm._v(" (faith/faithfulness) would take the form of enslavement ("), _c('i', [_vm._v("douleuein")]), _vm._v(") to God underscores its analogical relationship to that displayed by the Lord, who also took the form of a slave ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δοῦλος")]), _vm._v(", "), _c('i', [_vm._v("doulos")]), _vm._v(") in becoming human and then exhibited a loyalty to God that finally took him to his death on a cross (Phil 2:6–8). Hence, their assembly "), _c('i', [_vm._v("as a whole")]), _vm._v(" exhibits a similar pattern of faithfulness as that of Jesus in his rectifying display of covenant faithfulness to the God of Israel. As a nonidentical repetition of the "), _c('i', [_vm._v("pistis")]), _vm._v(" of Jesus, their "), _c('i', [_vm._v("pistis")]), _vm._v(" displays a life pattern of participation in the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" and may be characterized as an “initial and ongoing cruciformity, grounded in the faithfulness of Jesus the Messiah.”"), _c('a', {
    attrs: {
      "id": "fn114"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" As Douglas Harink maintains:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The point to emphasize here is that for Paul the Thessalonian believer’s participation in God’s gracious work through Christ and the Spirit is not focused upon or localized in a single form of human response, that is receptive faith (or “faith in Christ,” a phrase which appears nowhere in the letter); rather it is depicted as spread over the whole range of human life, active and passive, attitudinal and bodily, inner and outer, personal, social, and political."), _c('a', {
    attrs: {
      "id": "fn115"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Paul further characterizes their "), _c('i', [_vm._v("pistis")]), _vm._v(" as “awaiting his Son from the heavens” (cf. 4:16; 2 Thess 1:7).")]), _c('a', {
    attrs: {
      "id": "fn116"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" In their current tribulations, they, like Israel in Isaiah and much of the persecuted church today, await justice when there appears to be none and salvation, which seems far from them (Isa 59:11). Waiting in almost any context is not primarily a heightened or intense mental or psychological state but rather “the set of observable actions or behavior to which the expectation gives rise.”"), _c('a', {
    attrs: {
      "id": "fn117"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" In other words, the Thessalonians’ waiting—and by analogy, that of the persecuted people of God in any time or place—is not a heightened mental state but is constituted by their active public perseverance that is produced by the hope they have for the royal coming of the Lord Jesus Christ and the salvation it brings (v. 3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul then further depicts the awaited Son with two more clauses, one of which describes what God did for Jesus and the other what Jesus is doing and will do for the audience. The first of these describes the Son as the one “whom he [God] raised from the dead.” Paul mentions Jesus’ resurrection once more (1 Thess 4:14) in the Thessalonian correspondence. In both places he simply assumes his audience’s adherence to this belief, which is the pivot point of the gospel, the point at which God vindicates, or justifies, the Son because of his saving display of covenant faithfulness in life and death. Paul mentions one aspect of that resulting salvation in the next clause, which depicts the Son, using language from Isaiah’s description of the Divine Warrior, as “Jesus, the one who is going to rescue ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τὸν ῥυόμενον")]), _vm._v(", "), _c('i', [_vm._v("ton rhyomenon")]), _vm._v("] us from the coming wrath” (cf. Isa 59:19–20)."), _c('a', {
    attrs: {
      "id": "fn118"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" Neither here, in 2:16, nor in 5:9 is this wrath explicitly said to come from God (as, e.g., in Rom 1:18), yet it is clearly implied. In the Bible wrath is not an attribute of God but rather a response to human actions that harm oneself and others, destroying human relationships or God’s good created order. It is a response of “ferocious love”"), _c('a', {
    attrs: {
      "id": "fn119"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" that seeks restorative justice in and for God’s whole created order (see comments on 2 Thess 1:5–10). Baker’s and Green’s summary comments in this regard are helpful:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Although Paul does not here identify the coming wrath as God’s, we would be mistaken to read here an impersonal force. This is none other than God’s righteous response to persistent human disobedience (see 1 Thess 2:16); thus, the coming wrath is the final judgment of those who refuse to believe. There is no sense here of divine anger but rather of God’s bringing those who rebuff him and his people to eschatological justice. The coming wrath is the coming judgment, the climactic, endtime judgment scene when those who prefer to worship idols rather than the living God receive the fruits of their own misplaced hopes and commitments.")]), _c('a', {
    attrs: {
      "id": "fn120"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Here and in the rest of 1 Thessalonians (2:16, 5:9), then, it is this eschatological wrath that is primarily in view. In this case, God will act in ferocious love to bring restorative justice for the whole of the created order, but those who are intentional and unrepentant perpetrators of violence and evil will experience God’s wrath as destructive rather than restorative. Those currently in the church are not exempt from experiencing God’s vengeance if they engage in such actions, which flagrantly violate the cruciform character of their Lord (see comments on 4:6 and 5:9).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, if one takes into account Rom 1:18–19 in conjunction with Paul’s use of the present tense participle "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τὸν ῥυόμενον")]), _vm._v(" ("), _c('i', [_vm._v("ton rhyomenon,")]), _vm._v(" “the one who is rescuing us”), the wrath of God in this context may also have a current connotation."), _c('a', {
    attrs: {
      "id": "fn121"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" In Rom 1:18–19 Paul says that the wrath of God is being revealed from heaven against all "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀσέβεια")]), _vm._v(" ("), _c('i', [_vm._v("asebeia,")]), _vm._v(" “impiety”) and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀδικία")]), _vm._v(" ("), _c('i', [_vm._v("adikia,")]), _vm._v(" “injustice”), the manifestation of which is the actions and resulting slavery that Paul describes as "), _c('i', [_vm._v("currently")]), _vm._v(" infecting humanity in the following verses. Hence, while the focus here is primarily on the audience’s being rescued from God’s eschatological wrath, in their “turning to God to be enslaved to him in faith/faithfulness ["), _c('i', [_vm._v("pistis")]), _vm._v("],” they are also being spared from the present wrath of God, which is manifest in the slavery that results when "), _c('i', [_vm._v("asebeia")]), _vm._v(" (vertical covenant violations against God) and "), _c('i', [_vm._v("adikia")]), _vm._v(" (horizontal actions against others) spin out of control."), _c('a', {
    attrs: {
      "id": "fn122"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In vv. 5–10 Paul has given the two-part reason why he knows that this Gentile audience, like Israel in the biblical story, has been elected by God. The focus is not on specific individuals being elected for salvation and others elected for damnation by an inscrutable eternal decree of God. Rather, it is on the "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("election of this church as a whole, an election that is clear from two observable consequences of divine action that enabled their individual and corporate human response. First, by empowering its proclaimers to reembody its essence in the midst of the Thessalonians, the Holy Spirit gave the gospel a persuasive and liberating power that it might not have had on its own in such a culture. Second, the Spirit enabled the Thessalonians themselves to publicly reembody the essence of this gospel by exhibiting their own nonidentical repetition of the covenant faithfulness of Jesus expressed in fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and the self-giving actions (i.e., love, "), _c('i', [_vm._v("agapē")]), _vm._v(") toward others that they had seen exemplified in the actions of Paul and his companions. Hence, God’s electing activity is not limited to a precreation selection process but is played out in the actual reception of Paul’s gospel in active faith/faithfulness to God and love toward others. In short, Paul knows that God has elected them because he has observed their being rescued by, in order to participate in, the "), _c('i', [_vm._v("missio Dei.")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s05"
    }
  }, [_c('i', [_vm._v("2:1–12"), _c('span', {
    staticClass: "space"
  }, [_vm._v("“The Sort of People We Became among You”: An Explanation and a Model for Participation in the")])]), _vm._v(" Missio Dei")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("1")]), _vm._v("For you yourselves know, sisters and brothers, that our initial visit with you has not been devoid of power. "), _c('sup', [_vm._v("2")]), _vm._v("Yet, although we suffered beforehand and were shamefully mistreated in Philippi, just as you know, in the face of much opposition we had the courage—by means of our God—to speak the good news from God openly to you all. "), _c('sup', [_vm._v("3")]), _vm._v("For our exhortation did not spring from deception or from impure motives, nor was it with deceit. "), _c('sup', [_vm._v("4")]), _vm._v("But just as we have been and remain tested and approved by God to be entrusted with the gospel, this is how we speak, not as attempting to be pleasing to people but to God, the one who continues testing and approving our hearts. "), _c('sup', [_vm._v("5")]), _vm._v("For we never came with flattering speech, just as you all know, nor with a false motive, namely, greed—God is a witness—"), _c('sup', [_vm._v("6")]), _vm._v("nor did we come demanding public honor from people, neither from you or from others, "), _c('sup', [_vm._v("7")]), _vm._v("although we could have thrown our weight around as apostles of Christ. But we became infants"), _c('a', {
    attrs: {
      "id": "fn123"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" in your midst. Like a nurse taking care of her own children, "), _c('sup', [_vm._v("8")]), _vm._v("so we, because we cared so much for you, were pleased"), _c('a', {
    attrs: {
      "id": "fn124"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" to share with you not only the gospel from God, but also our very selves because we had come to love you so. "), _c('sup', [_vm._v("9")]), _vm._v("For you all remember, brothers and sisters, our labor and toil. We proclaimed to you the gospel from God "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("by working night and day in order not to burden any of you. "), _c('sup', [_vm._v("10")]), _vm._v("You yourselves are witnesses—as is God—how holily, justly, and blamelessly we behaved for the benefit of you all who are exercising believing allegiance. "), _c('sup', [_vm._v("11")]), _vm._v("Just as you know, as a father does for each one of his own children, "), _c('sup', [_vm._v("12")]), _vm._v("we exhorted, comforted, and witnessed to you all in order that you might continue walking worthily of the God who continues calling")]), _c('a', {
    attrs: {
      "id": "fn125"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" you into his own kingdom and honor/glory.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s06"
    }
  }, [_c('i', [_vm._v("The Rhetorical Function of 2:1–12")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In 2:1–12 Paul begins the body of the letter by enlarging on one of the focal points of the thanksgiving section: the way the gospel came to the audience—namely, persuasively embodied in the kind of people he and his coworkers proved themselves to be. Most interpreters have recognized that, in this section, Paul contrasts his behavior among the Thessalonians to that of wandering public orators known as Sophists (often Cynic philosophers), whose vices would have been all too familiar to his audience."), _c('a', {
    attrs: {
      "id": "fn126"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" Given this probable background, the primary interpretive question has been whether the function of 2:1–12 is primarily apologetic or primarily paraenetic."), _c('a', {
    attrs: {
      "id": "fn127"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" That is, is Paul defending himself from actual charges made against him by opponents who accuse him of being one of these charlatan orators out for money and public honor and who abandon their pupils when the going gets tough?"), _c('a', {
    attrs: {
      "id": "fn128"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" Or, rather than responding to specific charges, is he simply using the typical behavior of such orators as a negative backdrop to depict his own behavior as a model for his audience to follow?"), _c('a', {
    attrs: {
      "id": "fn129"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("Interpretive certainty is not possible on this issue.")]), _c('a', {
    attrs: {
      "id": "fn130"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" But while one cannot decisively rule out an apologetic function from a historical standpoint, one need not appeal to the unnecessary hypothesis that there are opponents against whom Paul is crafting an apology."), _c('a', {
    attrs: {
      "id": "fn131"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" In light of stock accusations against orators who “preach and run,” leaving their pupils in a lurch, one can understand that Paul might want to explain his continuing absence to a congregation going through persecutions."), _c('a', {
    attrs: {
      "id": "fn132"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" But in doing so, he also attempts to shape his audience’s character and behavior by enlarging on the ethos he and his companions displayed when they were in Thessalonica."), _c('a', {
    attrs: {
      "id": "fn133"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" Having been rescued by the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" in order to participate in it, this recently converted audience needs more than just precepts. Even more, it needs concrete models"), _c('a', {
    attrs: {
      "id": "fn134"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" to help it continue conducting its ecclesial life in ways that are worthy of God, who is calling them into a way of living at odds with societal expectations. An explanation of his continuing absence, therefore, functions at the same time as paraenesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, in what follows I assume that in 2:1–12 Paul is contrasting his motives and behavior with contemporary wandering orators and Sophists, widely perceived to be charlatans out for their own interests rather than those of their pupils."), _c('a', {
    attrs: {
      "id": "fn135"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" In so doing, he provides both an explanation for his continued absence "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("as well as a pattern for the vocation of Christian leadership, a pattern that his audience is to implement in ordering their own life together.")]), _c('a', {
    attrs: {
      "id": "fn136"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The passage divides into two sections. In 2:1–4 Paul connects what he has just said in chapter 1 to this paraenetic section by reminding his audience of the power at work in his initial visit in the midst of difficult circumstances, the character of his exhortation, and God’s approval of his motives. In 2:5–12 he recounts how his public practices were consistent with God’s continued testing and approval of him to be entrusted with good news, insofar as he concretely embodied its very essence.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s07"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s07"
    }
  }, [_c('i', [_vm._v("Paul’s Faithfulness to the Gospel in the Face of Opposition: 2:1–4")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In 2:1 Paul begins to enlarge upon the character of his initial visit, particularly on the sort of people he and his companions showed themselves to be in it (1:5, 9). He first appeals to his audience’s own knowledge that his visit “has not been devoid ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κενή")]), _vm._v(", "), _c('i', [_vm._v("kenē")]), _vm._v("] of power.” With this expression, he reminds the audience of the character and power of his visit evident in its continuing results, namely, their conversion and consistent faithfulness."), _c('a', {
    attrs: {
      "id": "fn137"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s visit to Thessalonica came after he had been treated shamefully in Philippi. Acts 16 describes the treatment Paul and Silas received there, one reserved for those of low status that would have been publicly shameful. They were stripped in public, beaten with Roman rods, and thrown into prison as uncondemned men (16:19–24, 37). Nevertheless, Paul says, God gave them courage to speak God’s own good news frankly and openly in public when they came to Thessalonica,"), _c('a', {
    attrs: {
      "id": "fn138"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" doing so in the face of great opposition ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγών")]), _vm._v(", "), _c('i', [_vm._v("agōn;")]), _vm._v(" on which see Acts 17:1–9; cf. Col 1:29)."), _c('a', {
    attrs: {
      "id": "fn139"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" In other words, the primary reason why "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("he, unlike the Sophists of his day, could speak so boldly in the midst of such violent opposition was God’s empowerment. Such costly actions in the service of the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" are not characteristic of those whose character and intentions are less than genuine.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("In v. 3 Paul gives the secondary reason why he spoke so boldly in the face of opposition. He did so because his exhortation ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παράκλησις")]), _vm._v(", "), _c('i', [_vm._v("paraklēsis")]), _vm._v("), unlike that of the popular orators, derived from a genuine concern for his audience.")]), _c('a', {
    attrs: {
      "id": "fn140"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" Here Paul uses the term "), _c('i', [_vm._v("paraklēsis")]), _vm._v(" to refer to the kind of frank, publicly open speaking of the gospel of God to which he has just referred in v. 2."), _c('a', {
    attrs: {
      "id": "fn141"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" Hence, the exhortation in question in this context is his Spirit-empowered proclamation and embodiment of the good news of God, which came to the audience as both gift and claim, enabling their "), _c('i', [_vm._v("pistis")]), _vm._v(" (faith/faithfulness) as described in 1:9–10. As such, it was a persuasive endeavor (cf. its use in 2:12) through which the Spirit worked to evoke both belief and a transformation that would be manifested in a particular pattern of life worthy of the God who called the audience, that is, "), _c('i', [_vm._v("pistis")]), _vm._v(" toward God and love toward others."), _c('a', {
    attrs: {
      "id": "fn142"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The series of antitheses in v. 3 describes Paul’s initial exhortation in negative terms, that is, it did"), _c('a', {
    attrs: {
      "id": "fn143"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" not “spring from "), _c('i', [_vm._v("planē")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πλάνη")]), _vm._v(", ‘deception’] or from "), _c('i', [_vm._v("akatharsia")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀκαθαρσία")]), _vm._v(", ‘impure motives/impurity’),”"), _c('a', {
    attrs: {
      "id": "fn144"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" and “neither was it with deceit.” The language of deception was used to describe the nongenuine motives of the charlatan orators whose behavior forms a negative backdrop to that of Paul."), _c('a', {
    attrs: {
      "id": "fn145"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("In v. 4 Paul turns to describe his exhortation in positive terms. In contrast to those whose public speech is characterized by the preceding antitheses, Paul reminds the audience that he speaks as one having been tested and approved by God in the past (and remaining so now)")]), _c('a', {
    attrs: {
      "id": "fn146"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" to be entrusted with the gospel (cf. Gal 2:7). His behavior is the antithesis of the vices in v. 3 in that his motives have been, and continue to be, tested by God. Although Paul elsewhere uses the verb "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δοκιμάζω")]), _vm._v(" ("), _c('i', [_vm._v("dokimazō,")]), _vm._v(" “I put to the test/approve”) to refer to “the fire’s” eschatological testing of the work of Christian ministers (1 Cor 3:13; cf. 1 Pet 1:7), only here in the NT does it refer directly to God’s testing/approval of human beings. The theme of God’s testing his people, or the hearts of his people, is prominent in Jeremiah (9:7; 11:20; 12:3; 17:10; 20:12), where, in bringing a case against God, the prophet affirms his own loyalty to God by saying: “And you, yourself, Lord, know me. You have tested/approved ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δεδοκίμακας")]), _vm._v(", "), _c('i', [_vm._v("dedokimakas")]), _vm._v("] my heart in your sight” (Jer 12:3a LXX; cf. Ps 138:23 LXX)."), _c('a', {
    attrs: {
      "id": "fn147"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" Paul’s allusion to Jer 1:5 in Gal 1:15 suggests that he is familiar with such claims by Jeremiah and also that he understands his vocation as prophetic.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As in the LXX, "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καρδία")]), _vm._v(" ("), _c('i', [_vm._v("kardia,")]), _vm._v(" “heart”) in the NT generally refers to “the "), _c('i', [_vm._v("inner person,")]), _vm._v(" the seat of understanding, knowledge and will, and takes on as well the meaning "), _c('i', [_vm._v("conscience.")]), _vm._v("”"), _c('a', {
    attrs: {
      "id": "fn148"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" Here "), _c('i', [_vm._v("kardia")]), _vm._v(" clearly has a volitional sense (cf. 1 Cor 4:5), but Paul can also use it with a cognitive nuance (e.g., Rom. 2:15; 16:17–18), demonstrating that he can use the term to refer to the inner aspect of one’s intentions, dispositions, and cognitive judgments. As should be obvious from the context here, he does not use “inner” anthropological terms like “heart” ("), _c('i', [_vm._v("kardia")]), _vm._v(") in precise ways to bracket these off from their embodiment in public practices. But Paul, like Jeremiah, affirms that God plumbs the very depths of human beings, testing the motives that lie behind their public practices, especially the practices of those who profess to be engaged in the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" Hence, unlike the charlatan orators, whose typical practice was to flatter their audience, Paul’s customary way of speaking is attempting to be pleasing not to human beings (cf. Gal 1:10) but rather to God. It is not that Paul does not attempt to identify with his audience (e.g., 1 Cor 9:19–23), but his typical way of speaking as he engages in God’s mission requires telling his audience the truth about their own situation in light of that mission. It is that way of speaking on which he elaborates in vv. 5–7a.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s08"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s08"
    }
  }, [_c('i', [_vm._v("Paul’s Concrete Embodiment of the Essence of the Gospel: 2:5–12")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Before commenting in more detail on these verses, two interpretive issues need to be addressed: (1) the textual variant in v. 7b and (2) the structure and punctuation of these verses in light of that text variant. (In the NA28 this variant reading comes in the second portion of v. 7; hence, I refer to the location of this variant as v. 7b throughout this discussion. However, in some English translations [e.g., NIV, ESV], the variant appears in the first portion of v. 7.)")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The well-known text-critical issue in v. 7b is whether to read “but we became "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἤπιοι")]), _vm._v(" ["), _c('i', [_vm._v("ēpioi,")]), _vm._v(" ‘gentle’]” or “but we became "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("νήπιοι")]), _vm._v(" ["), _c('i', [_vm._v("nēpioi,")]), _vm._v(" ‘infants’].”")]), _c('a', {
    attrs: {
      "id": "fn149"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" The external evidence is overwhelmingly in favor of the latter reading,"), _c('a', {
    attrs: {
      "id": "fn150"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" which is clearly the more difficult. Hence, the two major Greek editions of the NT (NA28 and "), _c('i', [_vm._v("GNT")]), _c('sup', [_vm._v("4")]), _vm._v(") adopt it, but the overwhelming majority of English translations have adopted the former,"), _c('a', {
    attrs: {
      "id": "fn151"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" as well as the majority of commentators."), _c('a', {
    attrs: {
      "id": "fn152"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" The primary reason for adopting “gentle” has to do with internal consistency of context; that is, it would be awkward for Paul to say, “We became infants among you, like a nurse.”"), _c('a', {
    attrs: {
      "id": "fn153"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" There is no doubt that Paul’s use of these two metaphors together does have a jarring rhetorical impact. But that is not necessarily a reason for overriding the considerable external evidence. It may in fact be part of the rhetorical point. Hence, with a growing number of interpreters,"), _c('a', {
    attrs: {
      "id": "fn154"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" I will assume that "), _c('i', [_vm._v("nēpioi")]), _vm._v(" is the preferred reading in v. 7b.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given this reading, we punctuate v. 7 with a full stop between 7b and 7c: “But we became infants in your midst. As a nurse taking care of her own children, so we. . . .”"), _c('a', {
    attrs: {
      "id": "fn155"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" Verse 3 contains three negative statements forming the first member of an antithesis indicating what Paul’s initial exhortation was not. "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("It is immediately followed by a contrasting "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀλλά")]), _vm._v(" ("), _c('i', [_vm._v("alla,")]), _vm._v(" “but”) at the beginning of v. 4, which goes on to indicate what Paul’s initial exhortation and customary way of speaking are. Similarly, vv. 5–7a contain three more negative statements (each with an aside) that indicate what Paul’s visit was not like. We then have another contrasting "), _c('i', [_vm._v("alla")]), _vm._v(" at the beginning of v. 7b. Verses 7b–8 then go on to indicate what Paul’s visit was like, using two different metaphors (infants, a nurse) that are related in some way. Based on these considerations, the best structuring and punctuation of vv. 5–8 are as follows:")]), _c('a', {
    attrs: {
      "id": "fn156"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "Hang1a"
  }, [_vm._v("For we never came with flattering speech ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν λόγῳ κολακείας")]), _vm._v(", "), _c('i', [_vm._v("en logō kolakeias")]), _vm._v("],")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("just as you all know,")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("nor with a false motive, namely, greed")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("—God is a witness—")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("nor did we come demanding public honor from people, neither from you or from others,")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("although we could have thrown our weight around"), _c('a', {
    attrs: {
      "id": "fn157"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" as apostles of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("But we became infants in your midst.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("Like a nurse taking care of her own children,")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("so we,")]), _vm._v(" "), _c('p', {
    staticClass: "Quote2"
  }, [_vm._v("because we cared so much for you,")]), _vm._v(" "), _c('p', {
    staticClass: "Quote3"
  }, [_vm._v("were pleased to share with you")]), _vm._v(" "), _c('p', {
    staticClass: "Quote4"
  }, [_vm._v("not only the good news from God,")]), _vm._v(" "), _c('p', {
    staticClass: "Quote4"
  }, [_vm._v("but also our very selves")]), _vm._v(" "), _c('p', {
    staticClass: "Quote2"
  }, [_vm._v("because we had come to love you so.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Paul begins v. 5 with another “for,” signaling that he is about to elaborate on his typical manner of speaking. Street-corner orators and philosophers were often accused of speaking with effusive flattery ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κολακεία")]), _vm._v(", "), _c('i', [_vm._v("kolakeia")]), _vm._v(") when trying to butter up their audience in pursuit of money and honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξα")]), _vm._v(", "), _c('i', [_vm._v("doxa")]), _vm._v(")."), _c('a', {
    attrs: {
      "id": "fn158"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("In fact, when an itinerant Sophist came into a city, the first speech he was expected to give was one praising the audience that was characterized by effusive flattery ("), _c('i', [_vm._v("kolakeia")]), _vm._v("). Hence, the following three negative statements are closely bound together, with the first describing an activity directed toward pursuing what Paul denies he was after in the next two, namely, financial gain and public honor or reputation.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Rather than trying to please his audience by flattering them (see v. 4), like a true friend, he spoke to them with "), _c('i', [_vm._v("parrēsia")]), _vm._v(" (i.e., boldness, frankness), as he had already reminded them in v. 2.")]), _c('a', {
    attrs: {
      "id": "fn159"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" He openly and publicly told them the truth about their situation of enslavement to idols rather than to the living and true God of Israel, who had declared Jesus as the world’s true Lord. This is something they know very well. By contrast, speech characterized by effusive flattery would have been out of sync with the very essence of the good news and would have signaled that they had indeed come to the audience “with a false motive, namely, greed.”"), _c('a', {
    attrs: {
      "id": "fn160"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" Unlike the charlatan orators, Paul was not out for financial gain. While his public actions indicate that his inner motive for coming to the audience was not greed, in a second aside he stresses that the God who continuously tests his heart is a witness to this fact as well. Rather than signaling that Paul is defending himself against charges made against him, Paul’s invocation of God as witness may simply be a part of the overall pattern of behavior he wishes to instill in an audience called to participate in the "), _c('i', [_vm._v("missio Dei.")]), _c('a', {
    attrs: {
      "id": "fn161"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" That is, for those so called, it is imperative, not only that their public practices testify to the purity of their motives, but that they are not hesitant to call upon God publicly as a witness to that purity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In a third negative statement, Paul asserts that he did not come demanding public honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξα")]), _vm._v(", "), _c('i', [_vm._v("doxa")]), _vm._v(") from them or from anyone. He follows up with the parenthetical comment “although we could have thrown our weight around as apostles of Christ.” This phrase could refer to (1) the right that Paul might have had to demand honor from the audience based on his apostolic authority, (2) the right that he may have had to burden them financially, or (3) both."), _c('a', {
    attrs: {
      "id": "fn162"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" On the one hand, the literary pattern of the passage (denial followed by an aside) suggests that option 1 is the primary referent of this clause."), _c('a', {
    attrs: {
      "id": "fn163"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" On the "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("other, since effusive flattery was often directed toward achieving both honor and money from others, and since Paul had just denied in 2:5 that his motive was financial greed, it is probable that money is at least a secondary connotation of this phrase. In any case, the first and only time Paul uses the word “apostle” in this letter (and the first time in his extant writings), it is in a clause indicating that apostles of the Lord of the cosmos have a right to make weighty demands on those to whom they speak, including the demand to be treated with public honor and probably to be financially supported by others. But the concessive nature of the clause matches the concessive nature of the first line in Paul’s master story of the Lord they represent, “who, although he was in the form of God, did not . . .” (Phil 2:6). Like the Lord he represents, Paul does not exercise his authority as an apostle in demanding honor that may rightfully be due him.")]), _c('a', {
    attrs: {
      "id": "fn164"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In contrast"), _c('a', {
    attrs: {
      "id": "fn165"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" to this sort of deceptive pattern of behavior that seeks to exploit others for financial gain and public honor and reputation, Paul says, “We became infants in your midst.” As in 1 Cor 14:20, where Paul counsels the audience to “be infants ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("νηπιάζετε")]), _vm._v(", "), _c('i', [_vm._v("nēpiazete")]), _vm._v("] with respect to evil,” the immediate context here constrains the sort of conventional characteristics associated with infants that come into play. Here, Paul’s point is that, "), _c('i', [_vm._v("with respect to")]), _vm._v(" the lack of exploitative behavior and motives related to money and seeking public honor and reputation, he and his companions “became infants.” To use language from Philippians (e.g., 2:5), the metaphor underscores "), _c('i', [_vm._v("the lack")]), _vm._v(" of a particular mind-set ("), _c('i', [_vm._v("phronēsis")]), _vm._v(") in one who goes by the designation of apostle. However, it does not function well to emphasize the positive content of the apostolic mind-set. Hence, in the next sentence, he swiftly changes metaphors to do just that, comparing their conduct among the audience to the way a nurse would care for her own children.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Paul’s social context, the nurse metaphor"), _c('a', {
    attrs: {
      "id": "fn166"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" would evoke images of a beloved, kind, and generous figure who was responsible for the daily care of infants and young children. But often, in what approximated a kinship relationship, she stayed on as an attendant for young women, and the young men she had helped raise continued to have warm affection for her."), _c('a', {
    attrs: {
      "id": "fn167"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" Whether or not “her own children” refers to the nurse’s own biological children or simply the children she is contractually responsible to care for, the effect of referring to the "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("nurse’s own children is to intensify the metaphor.")]), _c('a', {
    attrs: {
      "id": "fn168"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" What follows in v. 8 is a natural outflow of this image in which Paul describes their care for the audience as exhibited by their sharing, not only the good news of God with them, but indeed their very lives, once again underscoring the inseparability of speaking the good news and embodying it. Paul and his companions had come to love this Gentile audience because God had taken the initiative and made them God’s own beloved (1:4), Israel-like community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Verse 9 gives evidence for, or at least explicates, Paul’s claim in v. 8. In this connection, Paul appeals to the memory that his brothers and sisters in Thessalonica have of his and his associates’ labor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κόπος")]), _vm._v(", "), _c('i', [_vm._v("kopos")]), _vm._v(") and toil ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("μόχθος")]), _vm._v(", "), _c('i', [_vm._v("mochthos")]), _vm._v(") and of their working ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐργαζόμενοι")]), _vm._v(", "), _c('i', [_vm._v("ergazomenoi")]), _vm._v(") throughout the night and day (cf. 2 Thess 3:8; 2 Cor 11:27). There is little difference in the meaning of these three terms, all of which denoted manual labor (see comments on 1:3). As such, they would have carried the connotation of burdensome, low-status (at least from the standpoint of the elite) activity requiring exertion and hardship, the kind of activity carried on by slaves and artisans. While he does not explicitly describe this activity as “working with our own hands,” it is clearly to be assumed (cf. the explicit language of 1 Cor 4:12) and is the basis on which he can exhort the audience in 4:11 to “continue working with your own hands,” presumably as 1:3 depicts them as doing. Paul would have worked as a tentmaker (Acts 18:3), which would typically involve long hours. Although he could have insisted on his rights as an apostle,"), _c('a', {
    attrs: {
      "id": "fn169"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" he chose to engage in activity associated with low status (a practice that, from the standpoint of the elite, apparently reflects poorly on the status of those who are taught by such a person; note the implications of 1 Cor 9:1–18, esp. v. 6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Giving up such rights for the sake of others and engaging in such strenuous, low-status activity was intimately connected with their proclamation of the good news of God. It showed them to be “the sort of people” whose lives displayed the very pattern of the good news they proclaimed (1:5c). “We proclaimed to you the gospel from God by means of working night and day in order not to burden any of you.”"), _c('a', {
    attrs: {
      "id": "fn170"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" The actions in which they were engaged "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("exemplified the logic of the good news they proclaimed. Hence, the actions of Paul and his companions simultaneously exhibit both their faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to the God who called them to proclaim this good news and their cruciform actions of love ("), _c('i', [_vm._v("agapē")]), _vm._v(") toward others. While "), _c('i', [_vm._v("pistis")]), _vm._v(" and "), _c('i', [_vm._v("agapē")]), _vm._v(" can be distinguished, they cannot be separated.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Paul goes on in 2:10 to call on his audience and, once again, on God (see v. 5) as witnesses that his behavior, and also that of Silas and Timothy, was not only “holy ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁσίως")]), _vm._v(", "), _c('i', [_vm._v("hosiōs")]), _vm._v("] and righteous/just ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δικαίως")]), _vm._v(", "), _c('i', [_vm._v("dikaiōs")]), _vm._v("]” but also “blameless ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτως")]), _vm._v(", "), _c('i', [_vm._v("amemptōs")]), _vm._v("],” a word whose adjectival form occurs also in 3:13. This is the only time in 1 or 2 Thessalonians that a cognate of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δικαιοσύνη")]), _vm._v(" ("), _c('i', [_vm._v("dikaiosynē,")]), _vm._v(" “righteousness/justice”) appears, leading many to observe that justification as such is not an issue in the Thessalonian correspondence.")]), _c('a', {
    attrs: {
      "id": "fn171"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" In the LXX and the NT the cognate noun of "), _c('i', [_vm._v("hosiōs,")]), _vm._v(" "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁσιότης")]), _vm._v(" ("), _c('i', [_vm._v("hosiotēs,")]), _vm._v(" “holiness”), often appears in the same context as "), _c('i', [_vm._v("dikaiosynē")]), _vm._v(" or one of its cognates. The terms are used once metaphorically, together with “wrath,” to describe the Divine Warrior’s armor, which God dons to engage in salvific "), _c('i', [_vm._v("activity")]), _vm._v(" (Wis 5:17–20)."), _c('a', {
    attrs: {
      "id": "fn172"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" In Deut 32:4b they are used specifically to describe the covenant God’s character: “God is faithful . . . the Lord is righteous ["), _c('i', [_vm._v("dikaios")]), _vm._v("] and holy ["), _c('i', [_vm._v("hosios")]), _vm._v("].”"), _c('a', {
    attrs: {
      "id": "fn173"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" The character and activity of God as “righteous and holy” is what humans were created to reflect in the biblical tradition (e.g., cf. Wis 9:3 with Eph 4:24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, while the terms “holily” ("), _c('i', [_vm._v("hosiōs")]), _vm._v(") and “justly” ("), _c('i', [_vm._v("dikaiōs")]), _vm._v(") may simply refer to Paul’s and his companions’ keeping divine and human law respectively,"), _c('a', {
    attrs: {
      "id": "fn174"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" given the focus on the audience’s holiness in this letter, we may have warrant for taking Paul’s use of them together as going further. Whether or not Paul intends it, this description of his behavior correlates with the way the character and activity of God are described in other texts. It is no surprise that to act this way is part and parcel of acting “blamelessly,” a term that Paul uses in 3:13 and 5:23 when he prays for his audience to be blameless "), _c('i', [_vm._v("in reference to holiness.")]), _vm._v(" Conduct analogous to that of Paul is therefore the standard for what it means to be found “blameless” in holiness at the eschaton. It sums up the expanded description in this chapter of Paul’s reference in 1:5 to the “sort of "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("people we became among you all on your account” (1:5c). That is, Paul and his companions were the sort of people who not only proclaimed the gospel but embodied the character and image of the God who was its source, thereby reflecting God’s goal for humanity, that is, to be reshaped into God’s own image as displayed in his Son.")]), _c('a', {
    attrs: {
      "id": "fn175"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 11 again Paul uses the rhetorical “just as you all know,” now narrowing it to “each one of you.” What they know is that Paul engaged in three sorts of actions, just as a father would with each of his children: exhorting/encouraging, comforting, and testifying. Paul continues using familial language for his beloved “brothers and sisters” but now switches imagery to that of the relationship of children to their father. In 1 Cor 4:14–16 his claim to be a father to the Corinthians warrants (note the “therefore” in v. 16) his explicitly exhorting that audience to become imitators of him."), _c('a', {
    attrs: {
      "id": "fn176"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" The widespread assumption that a father serves as an example to his children"), _c('a', {
    attrs: {
      "id": "fn177"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" supports the contention that this whole section functions to provide a model for the behavior Paul wants the audience to (continue to) exhibit."), _c('a', {
    attrs: {
      "id": "fn178"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" He will, in fact, go on to speak about the audience exhorting/encouraging and comforting each other (4:18; 5:11; 14), as he describes himself as doing here in v. 11.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The explicit purpose for Paul’s fatherly actions is that “you might continue walking ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("περιπατεῖν")]), _vm._v(", "), _c('i', [_vm._v("peripatein")]), _vm._v("] worthily of the God who is calling ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καλοῦντος")]), _vm._v(", "), _c('i', [_vm._v("kalountos")]), _vm._v("] you all into his own kingdom and honor/glory.” The present tense of the participle, “calling” ("), _c('i', [_vm._v("kalountos")]), _vm._v("), indicates that there is something continuous about God’s calling. And since election and calling for Paul are functionally equivalent (see comments on 1:4), the audience’s calling/election is not a onetime event but rather an ongoing covenantal reality. In divine love, God sovereignly (and surprisingly) continues calling these Gentiles in Thessalonica into his own kingdom and honor/glory. And as the present tense of the infinitive, “walking ("), _c('i', [_vm._v("peripatein")]), _vm._v("),” indicates, Paul depicts the audience’s response to this calling as the appropriate ongoing covenantal response, that is, they are continuing to walk worthily of the God who is calling them (cf. Phil 1:27; Col "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("1:10).")]), _c('a', {
    attrs: {
      "id": "fn179"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" While the "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" is clearly dependent on the Spirit for this response, it is important to note that Paul depicts their ongoing appropriate response as also dependent on his actions. While it may be distinguishable from them, the Spirit’s enabling is not separate from the very human actions (v. 12a) through which enabling grace flows to the church.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("God is calling the church into his own kingdom/reign ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("βασιλείαν")]), _vm._v(", "), _c('i', [_vm._v("basileian")]), _vm._v(")"), _c('a', {
    attrs: {
      "id": "fn180"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" and honor/glory ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξαν")]), _vm._v(", "), _c('i', [_vm._v("doxan")]), _vm._v("). While the language of the kingdom ("), _c('i', [_vm._v("basileia")]), _vm._v(") of God is prevalent in the Synoptic Gospels, Paul does not use it often."), _c('a', {
    attrs: {
      "id": "fn181"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" He uses "), _c('i', [_vm._v("doxa")]), _vm._v(" (honor/glory) and its cognates more frequently."), _c('a', {
    attrs: {
      "id": "fn182"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" Often, as in ancient honor discourse, he uses it or its cognates to refer to ascribed honor based on social status in reference either to humans (e.g., 1 Thess 2:6) or to God (Rom 1:21; 4:20). When he uses it in eschatological contexts as here and 2 Thess 1:9, however, there is also an ontological aspect to the language of "), _c('i', [_vm._v("doxa")]), _vm._v(" (glory/honor). This audience is being called into God’s own glory ("), _c('i', [_vm._v("doxa")]), _vm._v("). In the LXX and other ancient Jewish writings, God’s glory ("), _c('i', [_vm._v("doxa")]), _vm._v(") refers to God’s radiant divine presence (Exod 16:7)."), _c('a', {
    attrs: {
      "id": "fn183"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" While visible radiance remains as an aspect of "), _c('i', [_vm._v("doxa")]), _vm._v(" in Paul’s letters, in eschatological contexts he constantly connects the term with incorruption and life, with the additional nuance of elevated status."), _c('a', {
    attrs: {
      "id": "fn184"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" For the audience to participate in God’s own "), _c('i', [_vm._v("doxa,")]), _vm._v(" then, would mean not only God’s granting public honor to them at the consummation of his kingdom but also fully sharing in the divine attributes of the "), _c('i', [_vm._v("living")]), _vm._v(" God to whom they had turned, that is, incorruption and life. Blackwell summarizes the point as follows: “In these ontological contexts glory denotes the honourable status of incorruption, and in its verbal form it denotes the divine action of granting incorruption with honour to believers in their physical resurrection.”"), _c('a', {
    attrs: {
      "id": "fn185"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul explicitly enlarges upon the language of 2:12 in 2 Thess 1:3–12. In that "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("context, immediately prior to vv. 11–12, he rehearses an eschatological scenario in which he describes the audience as currently suffering so that they “might be recognized as "), _c('i', [_vm._v("worthy")]), _vm._v(" of the kingdom of God” (v. 5). Then in v. 11 Paul says that he is praying constantly that the Thessalonians “might be "), _c('i', [_vm._v("worthy")]), _vm._v(" of the calling of our God,” almost assuredly a calling into his kingdom, as v. 5 implies. He also refers to the Lord’s coming to be honored ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐνδοξασθῆναι")]), _vm._v(", "), _c('i', [_vm._v("endoxasthēnai")]), _vm._v(") by his holy ones (1:10), including his audience, who will bring honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐνδοξασθῇ")]), _vm._v(", "), _c('i', [_vm._v("endoxasthē")]), _vm._v(") to his name as they themselves are honored in him (v. 12) at his coming. Hence, the eschatological scenario in 2 Thess 1:3–12 vividly portays the culmination of God’s call of this audience into his own kingdom and glory/honor.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("As we will see, while there are no explicit verbal connections between 2:12 and 4:13–18, Paul’s depiction of the Lord’s royal coming ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παρουσία")]), _vm._v(", "), _c('i', [_vm._v("parousia")]), _vm._v(") in that context is also a dramatic portrayal of this culmination of God’s calling of this audience into his own kingdom and glory/honor. While neither here nor there does Paul give an explicit, lengthy description of the nature of the kingdom of God, what he does say does not lead to the impression that he understood it in terms of “celestial existence,” as a “going to heaven” (see the comments on 4:13–18). In fact, as we have seen, the political setting of Paul’s activities in Thessalonica suggests that such “kingdom” language would have at least initially been heard by the audience as politically loaded language standing in at least some tension with (if not opposition to) the Roman imperial order. Given that Paul is addressing an alternative assembly ("), _c('i', [_vm._v("ekklēsia")]), _vm._v(") as they await the "), _c('i', [_vm._v("descent")]), _vm._v(" from heaven of the true Lord ("), _c('i', [_vm._v("kyrios")]), _vm._v(") as in 4:13–17, it could hardly have been heard otherwise, particularly since he will fully and finally place all enemies under Christ’s feet (1 Cor 15:25), including any imperial enemies who refuse to recognize his lordship. But the present tense nature of God’s calling, the fact that it is ongoing, should not be forgotten. Being continuously called into this God’s kingdom points to the primary mission of the church, namely, to put God’s empire or reality on display in their daily flesh and blood life, together modeling his final salvific intent for humanity (and the entire creation)")]), _c('a', {
    attrs: {
      "id": "fn186"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v("—to share in divine glory (Rom 8:21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Before leaving this context, we should also note the connection between glory/honor ("), _c('i', [_vm._v("doxa")]), _vm._v(") and holiness. This is an audience whom Paul has described as being “in God” at the beginning of the letter (1 Thess 1:1). Hence, sharing in his divine glory characterized by incorruption and life is precisely the outcome of inhabiting this cruciform, living God (see comments on 1:1), who continuously provides his life-giving "), _c('i', [_vm._v("Holy")]), _vm._v(" Spirit “into” this congregation (4:8). In the OT the glory that is the visible presence of Israel’s holy God is also, in essence, "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('i', [_vm._v("holiness made visible.")])]), _c('a', {
    attrs: {
      "id": "fn187"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])]), _vm._v(" Note, for example, the clear parallels between holiness and glory/honor in the following passages:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Among/by those drawing near to me [says the Lord], I will be "), _c('b', [_c('i', [_vm._v("shown holy/sanctified")])]), _vm._v(", that is, among/by the whole congregation I will be "), _c('b', [_c('i', [_vm._v("glorified/honored")])]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δοξασθήσομαι")]), _vm._v(", "), _c('i', [_vm._v("doxasthēsomai")]), _vm._v("]. (Lev 10:3 LXX)")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('b', [_c('i', [_vm._v("Holy, holy, holy")])]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἅγιος")]), _vm._v(", "), _c('i', [_vm._v("hagios,")]), _vm._v(" 3x) is the Lord Sabaoth; the whole earth is full of his "), _c('b', [_c('i', [_vm._v("glory")])]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξης")]), _vm._v(", "), _c('i', [_vm._v("doxēs")]), _vm._v("]. (Isa 6:3 LXX)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Hence, as this audience shares in the "), _c('i', [_vm._v("doxa")]), _vm._v(" of God in participating in the Lord’s royal coming (parousia), they will reflect what their Spirit-empowered life together has been in the process of becoming, that is, a visible, public display of the very character and holiness of the Lord they meet. They will be shown to be what they will have become by grace, “blameless in holiness” (3:13), and by the culminating “making-alive” actions of the Spirit,"), _c('a', {
    attrs: {
      "id": "fn188"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" their sanctification will be complete. As a redeemed people, they will, “in the eschaton, fully reflect the glory, or reality, of God.”"), _c('a', {
    attrs: {
      "id": "fn189"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s09"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s09"
    }
  }, [_c('i', [_vm._v("2:13–16"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Thanksgiving for God’s Word at Work: Imitating Faithful, Persecuted Jewish Churches in Judea")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Now we ourselves are also thanking God over and over because of this:"), _c('a', {
    attrs: {
      "id": "fn190"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])]), _vm._v(" when you all received the message from God by hearing it from us,"), _c('a', {
    attrs: {
      "id": "fn191"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" you welcomed it for what it truly is, God’s own word, not some mere human word. And it is continuing to work among/by means of you all who are exercising believing allegiance. "), _c('sup', [_vm._v("14")]), _vm._v("This is evident, brothers and sisters, in the way that you yourselves became imitators of "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("the churches of God who are in Judea in Christ Jesus, because you yourselves also suffered the same things by your own compatriots, just as they themselves also [suffered] by the Judeans "), _c('sup', [_vm._v("15")]), _vm._v("who killed both the Lord Jesus and the prophets and persecuted us. They are not pleasing to God and oppose all people "), _c('sup', [_vm._v("16")]), _vm._v("by hindering us from speaking to the Gentiles in order that they might be saved. The result of this is that they are constantly filling up the cup of their sins to the brim. But [God’s] wrath has come upon them to the end.")]), _c('a', {
    attrs: {
      "id": "fn192"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In v. 13 Paul renews his thanksgiving for the audience."), _c('a', {
    attrs: {
      "id": "fn193"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" The first thanksgiving in 1:2–10 emphasized the Spirit-empowered way the gospel came to them (v. 5) and what the audience themselves became as a result of their reception of this good news (vv. 6–10), namely, a faithful public witness elected to be a channel of the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" As we noted earlier, in 1 Thessalonians Paul uses “message/word” ("), _c('i', [_vm._v("logos")]), _vm._v(") synonymously with “gospel.” Although here in 2:13 the primary emphasis seems to be on their initial reception of that message, a pattern similar to that of the first thanksgiving is nonetheless discernable. Here Paul emphasizes that it was God’s own message that they received in the apostolic message. As noted in the comments on 1:5–8, God’s message, or gospel, was (at least partially) a message about "), _c('i', [_vm._v("pistis")]), _vm._v(" (i.e., the "), _c('i', [_vm._v("fidelity")]), _vm._v("/"), _c('i', [_vm._v("trust")]), _vm._v(" of Jesus Christ; cf. Gal 3:2, 5)."), _c('a', {
    attrs: {
      "id": "fn194"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" This message is also the instrument through which God evokes an analogous "), _c('i', [_vm._v("pistis")]), _vm._v(" (fidelity/trust/believing allegiance) in its hearers (Rom 10:16–17)."), _c('a', {
    attrs: {
      "id": "fn195"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" Hence, the audience’s reception of the divine "), _c('i', [_vm._v("logos")]), _vm._v(" (message) in the apostolic message as truly God’s own message has resulted in a divine power at work as they are exercising believing allegiance. The sentence structure in Greek makes it slightly ambiguous whether God himself or God’s message ("), _c('i', [_vm._v("logos")]), _vm._v(") is the referent of this divine power."), _c('a', {
    attrs: {
      "id": "fn196"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" In reality, the "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("two cannot be easily separated, but the syntax of the sentence and the context favor the latter.")]), _c('a', {
    attrs: {
      "id": "fn197"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])]), _vm._v(" In the first thanksgiving section it was the Spirit shaping the audience in ways that paralleled the content of the gospel that came to them in the apostles’ message (1:5). In this renewed thanksgiving, the pattern is similar, but here it is God’s own message ("), _c('i', [_vm._v("logos")]), _vm._v(") that Paul describes as the active power at work in ways that enable those who receive it to embody its very shape, that is, the shape of the good news it announces. Not surprisingly, God’s message ("), _c('i', [_vm._v("logos")]), _vm._v("), like God’s Spirit, is a dynamic force accomplishing that for which God sends it forth (Isa 55:11).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul says that this divine message is at work in/among/by means of ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν ὑμῖν")]), _vm._v(", "), _c('i', [_vm._v("en hymin")]), _vm._v(") those exercising believing allegiance. There can be no doubt that this divine message/power is currently operative, reshaping the identity of each person in the congregation and that of the assembly as a whole. Since persons become who they are within webs of relationships, God’s shaping power must be conceived as being at work both within persons and among them in their life together if there is to be a reshaping of their individual and corporate identity."), _c('a', {
    attrs: {
      "id": "fn198"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" However, since in the very next verse, the emphasis is on their becoming imitators of corporate assemblies in Judea (v. 14), the primary point here is that this divine power is at work in their "), _c('i', [_vm._v("corporate life together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given the suffering their public witness is apparently invoking (v. 14), it is quite possible that the phrase "), _c('i', [_vm._v("en hymin")]), _vm._v(" might be taken instrumentally. That is, this gospel-shaped divine power is now at work "), _c('i', [_vm._v("by means of")]), _vm._v(" their life together as they are engaged in God’s mission to their surrounding culture. At the very least, the way that Paul weaves a connection between God’s "), _c('i', [_vm._v("logos")]), _vm._v(" continuing to work among/by means of them (v. 13c) and their faithful suffering at the hands of their fellow Thessalonians (v. 14a) implies that the result of God’s "), _c('i', [_vm._v("logos")]), _vm._v(" working among them, enabling them to exercise believing allegiance, has generated opposition to such fidelity. The translation of v. 14a as “this is evident ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("γάρ")]), _vm._v(", "), _c('i', [_vm._v("gar")]), _vm._v("] . . . in the way that” is an attempt to make this rhetorical connection clear. Hence, the effects of God’s "), _c('i', [_vm._v("logos")]), _vm._v(" at work among them have spilled over into the public square, provoking opposition to their witness to the “"), _c('i', [_vm._v("logos")]), _vm._v(" about the Lord” that has rung forth from them and continued its reverberations into their surrounding locale (i.e., Macedonia and Achaia, 1:8). Although vv. 14–16 are undeniably difficult and caustic in tone, they are anchored in their context by the rhetorical connection Paul makes between them and the flow of thought in this renewed thanksgiving in v. 13.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But two broader issues complicate matters as we approach vv. 14–16. "), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("First, the way some Christians have used these verses for anti-Jewish")]), _c('a', {
    attrs: {
      "id": "fn199"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" or anti-Semitic purposes calls for caution in their interpretation. Second, most interpreters sense that there is a tension, if not an outright conflict, between what Paul says about “the Jews” in this context and what he says about Israel later in Rom 9–11. Interpreters generally attempt to deal with these two issues in one of two ways: either by arguing that, for stylistic, historical, and mostly theological reasons, all or usually some portion of vv. 13–16 is a post-Pauline interpolation,"), _c('a', {
    attrs: {
      "id": "fn200"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" or by taking the verses as Pauline and attempting to harmonize them with Rom 9–11 (particularly 9:1–5; 11:1–2, 11, 25–32)."), _c('a', {
    attrs: {
      "id": "fn201"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With regard to the interpolation hypothesis, along with almost all other English commentaries,"), _c('a', {
    attrs: {
      "id": "fn202"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])]), _vm._v(" my position is that these verses are authentically Pauline. As noted immediately above, the rhetorical connection between vv. 13 and 14 makes it clear that these verses are not “out of place.” In addition, there is no manuscript evidence either for the absence of these verses or for their being located in any other place in the letter besides where they presently are. In other words, we know of no other version of 1 Thessalonians that ever had a shaping influence on a Christian community. But having said that, I will not attempt to harmonize these verses with Paul’s more positive statements about his fellow Jews in Rom 9–11"), _c('a', {
    attrs: {
      "id": "fn203"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203")])]), _vm._v(" but will argue that the tension between these passages might generate fruitful theologcal reflection. I will return to this latter issue after commenting further on vv. 14–16.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As we just noted, vv. 13–14 are connected by the initial “for” in v. 14, linking the public suffering that Paul refers to in v. 14 with the audience’s participation in the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" that is, with the message ("), _c('i', [_vm._v("logos")]), _vm._v(") of God continuing to work among/by means of them. Believing allegiance lived out in a context hostile to the claim that Israel’s God was definitively revealed in and as a crucified Lord/messiah can result only in some form of suffering (3:4), whether that context is Thessalonica or Judea. Having already described the audience as being “imitators of us and of the Lord” (1:6), Paul now says that this Gentile "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("audience became “imitators of the churches of God in Judea in Messiah Jesus.” These assemblies in Judea are clearly composed "), _c('i', [_vm._v("of Jews")]), _vm._v(" who now assemble “in the sphere of Messiah Jesus” (cf. Gal 1:22). Hence, Paul connects the corporate life of this Gentile assembly closely with the corporate life of Jewish assemblies, both of whom, out of fidelity to God, have “suffered the same things”—the Thessalonians at the hands of their own compatriots ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συμφυλετῶν")]), _vm._v(", "), _c('i', [_vm._v("symphyletōn")]), _vm._v(")")]), _c('a', {
    attrs: {
      "id": "fn204"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])]), _vm._v(" and the Jewish assemblies in Messiah at the hands of Jews/Judeans ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Ἰουδαίων")]), _vm._v(", "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(")."), _c('a', {
    attrs: {
      "id": "fn205"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two points should be stressed here. First, the rhetorical effect of making this connection is to strengthen the audience’s resolve toward continued fidelity in their public life together. "), _c('i', [_vm._v("This is the primary purpose for Paul’s introducing the whole topic.")]), _vm._v(" Second, whether he intends it or not, this language in Paul’s very first letter sews together Jews and Gentiles “in the sphere of Messiah Jesus” by making the point that the corporate life of these Gentiles in Christ bears analogy to the corporate life of Jews in Christ in another geographic location. While they are separated by distance and located in very different social contexts, they both are publicly faithful to the same God and thus are already moving toward Paul’s vision of Jews and Gentiles together in Christ—distinguishable, yet one people of God—giving honor “with one mouth” to “the God and Father of our Lord Jesus Christ” (Rom 15:6). In light of the caustic language that follows in vv. 15–16, it is essential to keep both these points in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s polemical description in the verses that follow is clearly hyperbolic"), _c('a', {
    attrs: {
      "id": "fn206"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206")])]), _vm._v(" and, as such, not out of place in intra-Jewish polemic of the first century. Verses 15–16b constitute one long descriptive dependent clause modifying the word Jews/Judeans ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Ἰουδαίων")]), _vm._v(", "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(") at the end of v. 14. Both the "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("NA"), _c('sup', [_vm._v("28")]), _vm._v(" and the "), _c('i', [_vm._v("GNT")]), _c('sup', [_vm._v("4")]), _vm._v(" have a comma between "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(" and the long dependent clause that follows. By grammatical convention, this encourages a nonrestrictive reading of what follows the comma, that is, making everything that follows somehow applicable to all Jews in general. Contemporary English translations are mixed in terms of whether (and how) they encourage nonrestrictive or restrictive readings of vv. 15–16b.")]), _c('a', {
    attrs: {
      "id": "fn207"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207")])]), _vm._v(" There were, of course, no punctuation marks in early Greek manuscripts, and the choice of whether to place a punctuation mark between vv. 14 and 15 is an "), _c('i', [_vm._v("interpretive")]), _vm._v(" decision—even at times, as perhaps in this case with the insertion of a comma, one unconsciously reflecting a "), _c('i', [_vm._v("theological")]), _vm._v(" point of view. There is, however, no particular necessity to place a comma in the text at this point and some compelling reasons not to do so (on which, see below)."), _c('a', {
    attrs: {
      "id": "fn208"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The absence of a comma after "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(" encourages a restrictive reading of what comes after it. That is, what follows in vv. 15–16b is in reference to one "), _c('i', [_vm._v("specific")]), _vm._v(" group of Jews, namely, certain Judean Jews who violently opposed Jesus and his early (Jewish) followers."), _c('a', {
    attrs: {
      "id": "fn209"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209")])]), _vm._v(" Paul describes these particular Jews with four descriptive phrases, the third and fourth of which are best taken together."), _c('a', {
    attrs: {
      "id": "fn210"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210")])]), _vm._v(" In the first of these, Paul says that they “killed both the Lord Jesus and the prophets.”"), _c('a', {
    attrs: {
      "id": "fn211"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])]), _vm._v(" While he clearly knows that the Roman political powers carried out Jesus’ crucifixion (i.e., “the rulers of this age,” 1 Cor 2:8), in line with and probably relying on early Christian tradition (Acts 2:36; 3:15; 4:10; 7:52; 13:26–28; Mark 12:1–9), Paul accuses these Judean Jews (most likely the Jerusalem leadership) of killing Jesus. While the latter did not kill Jesus themselves, the gospel accounts do suggest that they set the judicial process in motion that led to his death at the hands of the Romans (see Acts 13:26–28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not clear whether the second descriptive phrase ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἡμᾶς ἐκδιωξάντων")]), _vm._v(", "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('i', [_vm._v("hēmas ekdiōxantōn")]), _vm._v(") ought to be translated “who persecuted us” or “who drove us out.” Either is possible, and either might well have happened to Paul at the hands of Judean Jews in the past.")]), _c('a', {
    attrs: {
      "id": "fn212"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])]), _vm._v(" The nature of Paul’s language in the third and fourth phrases, combined with his switch to a present tense participle, heightens the caustic flavor of his rhetoric in that he describes these Judean Jews hyperbolically as those “who are not pleasing to God and who oppose all people” (2:15c)."), _c('a', {
    attrs: {
      "id": "fn213"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213")])]), _vm._v(" As is often pointed out, the language of “opposing all people” sounds like anti-Jewish rhetoric from the Greco-Roman world,"), _c('a', {
    attrs: {
      "id": "fn214"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])]), _vm._v(" and one can only hope that the Gentile audience of the letter did not take it that way. However, the language of displeasing God and opposing all people is immediately qualified with the first clause of v. 16. They are displeasing God and opposing all people, "), _c('i', [_vm._v("not because they are Jews,")]), _vm._v(" but “by hindering” Paul and other Jews “from speaking to the Gentiles in order that they might be saved.”"), _c('a', {
    attrs: {
      "id": "fn215"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For Paul, everything hinged on a new age having now begun with the death and resurrection of the Messiah and with God’s commissioning him to proclaim the faithfulness of this Messiah among the Gentiles, leading to their inclusion in the people of God "), _c('i', [_vm._v("as Gentiles.")]), _vm._v(" Paul’s later thinking on the fate of that part of Israel not currently believing in Jesus connects Israel’s own final salvation with the success of his mission to the Gentiles, that is, with the full number of Gentiles coming in (Rom 11:25–32). It is not clear whether Paul already had such an understanding when he writes this letter. However, on this reasoning, any particular group of Jews currently opposing his efforts to bring Gentiles to salvation might indeed be characterized as being “opposed to all people,” "), _c('i', [_vm._v("both other Jews and Gentiles.")]), _c('a', {
    attrs: {
      "id": "fn216"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216")])]), _vm._v(" Therefore, Paul’s language here, while clearly hyperbolic (and even unnecessarily caustic), makes sense canonically, since the salvation of both Jews and Gentiles hangs in the balance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whether purposed by God or not,"), _c('a', {
    attrs: {
      "id": "fn217"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])]), _vm._v(" the effect of their attempts to hinder "), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Paul’s mission to the Gentiles is their continuing to “fill up the cup of their sins to the brim.” When added to their “killing of the Lord Jesus and the prophets,” such ongoing actions constitute “the final straw,” that is, they represent the bringing of their sins to a fulfilled state.")]), _c('a', {
    attrs: {
      "id": "fn218"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("218")])]), _vm._v(" While there are biblical precedents for such language (e.g., Gen 15:16; Dan 8:23; 2 Macc 6:14, and esp. Matt 23:31–36), how one understands its implications in this context is tightly connected with the way v. 16c is to be understood. This part of the verse reads, somewhat woodenly, “But has come upon ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἔφθασεν")]), _vm._v(", "), _c('i', [_vm._v("ephthasen")]), _vm._v("] them the wrath "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς τέλος")]), _vm._v(" ["), _c('i', [_vm._v("eis telos")]), _vm._v("].” The two primary difficulties here are the awkward aorist (past) tense of "), _c('i', [_vm._v("ephthasen")]), _vm._v(" and the tension it creates when read together with the final prepositional phrase, "), _c('i', [_vm._v("eis telos")]), _vm._v(" (“completely, totally” or “finally, forever, to the end”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In general, interpreters take "), _c('i', [_vm._v("ephthasen")]), _vm._v(" as either a “prophetic aorist” (a future event so certain that it can be spoken of as having already happened)"), _c('a', {
    attrs: {
      "id": "fn219"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")])]), _vm._v(" or as a reference to a concrete past event or events (usually in Judea) in which God’s eschatological wrath has already begun to overtake those to whom Paul is referring."), _c('a', {
    attrs: {
      "id": "fn220"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220")])]), _vm._v(" While neither of these interpretations can be decisively ruled out, there is another possibility for those who are consciously interpreting this letter within a canonical framework, more specifically within the Pauline corpus. There is little doubt that the primary referent of wrath in 1 Thessalonians is the eschatological wrath awaiting those whose actions are in opposition to the living and true God (1:10; 5:9). But as we noted in our comments on 1:10, Rom 1:18–32 shows that God’s eschatological wrath can be anticipated and a foretaste of it experienced in the present when God “gives up” human beings to the consequences of their own choices, namely, more and more destructive actions that enslave them and distort their humanity. Thus, for Paul, one might presently experience God’s judgment-day wrath by participating in actions manifesting impiety and injustice, actions that “suppress the truth by means of injustice ["), _c('i', [_vm._v("adikia")]), _vm._v("]” (Rom 1:18). One might debate the extent to which Rom 1:18–32 is in any way representative of Israel’s experience, but the point here is "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("that Paul’s own language elsewhere shows that present participation in actions that “suppress the truth by means of injustice” can be said to evoke, manifest, and anticipate God’s eschatological wrath in the present (see the related comments on 2 Thess 2:10–12).")]), _c('a', {
    attrs: {
      "id": "fn221"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])]), _vm._v(" One might then say that the current actions of these specific Jews in v. 16c are tantamount to “suppressing the truth by means of injustice.” As a result, these actions have evoked (in the past) and now manifest (in the present) a foretaste of God’s wrath that awaits its consummation in the future judgment because God has now given them up to the consequences of their own destructive choices."), _c('a', {
    attrs: {
      "id": "fn222"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With this understanding in view, "), _c('i', [_vm._v("eis telos")]), _vm._v(" is best understood temporally and translated “to the end.”"), _c('a', {
    attrs: {
      "id": "fn223"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])]), _vm._v(" The sharpness of Paul’s language in this context makes it likely that he expects these Judean Jews to suffer the eschatological consummation of the wrath they are currently experiencing. In this case, Paul writes as a victim of injustice, expecting God to bring about final justice on particular Jews who have opposed both himself and God. The issue in Rom 9–11 is somewhat different in that there Paul is reflecting on the fate of the portion of Israel who are not Christ-believers, which should probably be understood to include many who were not actively persecuting Christ-believing Jews. Even so, there remains a tension between this passage and what Paul writes there (particularly Rom 9:1–5; 11:1–2, 11, 25–32)."), _c('a', {
    attrs: {
      "id": "fn224"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])]), _vm._v(" Reasonable harmonizations of the two passages "), _c('i', [_vm._v("at the historical level of Paul’s intended meaning")]), _vm._v(" have been offered."), _c('a', {
    attrs: {
      "id": "fn225"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("225")])]), _vm._v(" However, in view of the harshness of Paul’s language in this passage, we will move in a different direction that attempts to allow the tension between them to generate fruitful theological reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, we reiterate three important points: (1) the whole purpose of this section is to strengthen the audience’s resolve toward continued fidelity in their public life together. (2) Paul’s inflammatory rhetoric is intra-Jewish polemic directed only at a very specific group of Judean Jews, whose actions negatively impact "), _c('i', [_vm._v("other Jews")]), _vm._v(" as well as Gentiles. To call it “anti-Jewish” would be anachronistic; "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("to use it for anti-Jewish purposes would be reprehensible. (3) While harsh, such language continues a biblical commonplace whereby those who understand themselves to be faithfully adhering to Israel’s God in the midst of their persecution use harsh language to speak about their persecutors in what is essentially a cry for justice (or is it vengeance?) in the midst of pain and suffering (e.g., Ps 137:9).")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("With these points in mind, we may reflect theologically on this language by considering it in light of the larger canonical context, particularly that of the Pauline corpus. Even if Paul, reflecting on the experience of being victimized and rightly desiring God’s justice, does not hold out hope for his particular Jewish oppressors, his argument in Romans ought to give us pause for asserting without qualification that they will suffer the eschatological consummation of God’s wrath, of which they have had a foretaste. The same holds true for those currently persecuting the church in various places around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As in Rom 1, a current foretaste of God’s eschatological wrath does not indicate that experiencing its eschatological consummation is inevitable. Rom 1–3 is a "), _c('i', [_vm._v("retrospective")]), _vm._v(" analysis of the human condition from the standpoint of one who is “in Christ,” written to an audience who is “in Christ.” Hence, albeit perhaps in different ways, both Paul and his Romans audience (including us!) are now able to understand themselves as having at one time also received a foretaste of God’s eschatological wrath. They were indeed “enemies” of God (5:10), but now they stand delivered from experiencing the eschatological consummation of the wrath to which they were formerly subject. Hence, even if a portion of unbelieving Israel is currently participating in oppressive actions that evoke, manifest, and anticipate God’s eschatological wrath in the present, Paul’s own logic in Romans (even apart from chapters 9–11) does not make it inevitable that they will experience its consummation. They may, like Saul the persecutor (and Phinehas his precursor, Num 25:1–15; Ps 106:28–31), be “seeking to establish their own covenant faithfulness ["), _c('i', [_vm._v("dikaiosynē")]), _vm._v("]” (Rom 10:3) by demonstrating their loyalty in opposing those they believe to be God’s enemies. While such actions may even reveal that they are currently “hardened” by God and are “enemies of [God’s] good news” (Rom 11:25, 28), the very grace of God extended to Saul the persecutor shows that one cannot preclude their being included in “all Israel” who will be saved (11:26). God has indeed “imprisoned all to disobedience so that he might show mercy to all” (Rom 11:32). Thus, even though Paul’s rhetoric shows no explicit desire for God’s mercy toward his persecutors in 1 Thess 2:16c, elsewhere Scripture coming from Paul’s own hand plays a different tune, one that allows us to hear the particular note in 1 Thess 2:16c as a part of a larger melody.")])]), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s10"
    }
  }, [_c('i', [_vm._v("2:17–3:10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Paul and the Thessalonians: “Bringing Things Up-to-Date”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("To this point in the letter, Paul has focused on matters in the recent past: (1) the coming of himself and his colleagues to the Thessalonians and the audience’s ensuing conversion and faithful witness; (2) the nature of their “entry” into Thessalonica; (3) faithful suffering on behalf of the gospel by both Paul and the Thessalonians. In 2:17–3:10 he focuses on bringing matters up to date, so to speak, focusing on the circumstances that led him to write the letter. The section divides easily into three parts: (1) Paul’s explanation of why he and Silas had not been able to revisit the audience personally, although they had longed to do so (2:17–20); (2) their decision to send Timothy to learn about the audience’s fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") under pressure and to strengthen and encourage them (3:1–5); (3) Timothy’s good report that they are “standing firm in the Lord” and Paul’s continuing desire to see them face-to-face to further shape their life together in ways that manifest informed fidelity to the living and true God (3:6–10).")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s11"
    }
  }, [_c('i', [_vm._v("2:17–20"), _c('span', {
    staticClass: "space"
  }, [_vm._v("An Explanation of Absence")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("17")]), _vm._v("Now as for us, brothers and sisters, although we were orphaned for a little while [by our separation] from you (in person but not in heart), we made a very intense effort to see you again face-to-face. "), _c('sup', [_vm._v("18")]), _vm._v("For we wanted to come to you—especially I, Paul, wanted to come time and again—but Satan stopped us. "), _c('sup', [_vm._v("19")]), _vm._v("For who will be our hope or joy or crowning boast in the presence of our Lord Jesus at his royal coming? Surely it is you all, right? "), _c('sup', [_vm._v("20")]), _vm._v("For you yourselves are our honor and joy!")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In vv. 17–20 Paul explains why he and Silas had not revisited the audience prior to sending Timothy, even though they had longed to do so. Presumably, Timothy would have already given this information to the Thessalonians, and so what follows in these verses is more formational than informational. With emotionally charged language expressing Paul’s extreme affection for them, these verses continue to form their audience by depicting the relationship between Paul and his recipients as characterized by a mutual mediation of grace.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 3:1–10 it is clear that Paul and Silas had sent Timothy because they were concerned about the Thessalonians’ vulnerability in the face of suffering and testing. But in 2:17–20 Paul begins by stressing his own vulnerability. As if likening himself and his companions to infants (2:7) was not striking enough, here he takes the remarkable step of likening himself and his companions to "), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("children in their most vulnerable state.")]), _c('a', {
    attrs: {
      "id": "fn226"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])]), _vm._v(" In their temporary separation from the Thessalonians, they are like bereaved children deprived of their parents."), _c('a', {
    attrs: {
      "id": "fn227"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])]), _vm._v(" The orphan metaphor resonates well with an audience who, in turning from the idols of their pagan past, may have experienced a similar separation from their households with its subsequent confusion and sadness."), _c('a', {
    attrs: {
      "id": "fn228"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228")])]), _vm._v(" Together with the rest of the language in v. 17, the metaphor underscores not only Paul’s intense longing, his “truly fervent love,”"), _c('a', {
    attrs: {
      "id": "fn229"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")])]), _vm._v(" for the audience, but also the mutual interdependence that exists between himself and his converts."), _c('a', {
    attrs: {
      "id": "fn230"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While the audience is clearly dependent on Paul for their Christian formation (3:10), in vv. 19–20 Paul portrays the eschatological standing of himself and his colleagues as dependent on this community’s sustained fidelity to God (note 3:8, where Paul’s “continuing to live” is dependent on this). More specifically, Paul connects his eschatological hope, joy, crowning boast (cf. 1 Cor 9:24–27), and glory/honor to the integrity and shape of the Thessalonian church at the royal coming of the Lord (vv. 19–20)."), _c('a', {
    attrs: {
      "id": "fn231"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])]), _vm._v(" He uses similar ideas (1 Cor 3:10–15) and language (Phil 2:16; 4:1) elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Since Paul proclaims a gospel that has God’s formation of a faithful, holy people in Christ as a central component, it is not surprising that his own eschatological vindication depends, at least to some extent,"), _c('a', {
    attrs: {
      "id": "fn232"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("232")])]), _vm._v(" on whether there turn out to be flesh and blood communities whose cruciform life together testifies to the truth of what he proclaimed, namely, that a Jewish messiah, stamped forever with the legacy of crucifixion (see 1 Cor 1:23; 2:2), is Lord of the cosmos. His part in the formation of such communities who reflect that Lord’s character at his royal coming will indeed be a “crowning boast” for Paul, albeit ultimately an eschatological opportunity to “boast in the (cruciform) Lord” (1 Cor 1:31 citing Jer 9:23–24 LXX) or to boast in the grace of God at work in "), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("him (1 Cor 15:10).")]), _c('a', {
    attrs: {
      "id": "fn233"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233")])]), _vm._v(" Hence, the outcome of Paul’s prayer in 3:13 (that their hearts will be “blameless in holiness in the presence of our God and Father at the royal coming of our Lord Jesus”) not only has a bearing on his audience’s eschatological vindication, but his own as well.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The vulnerability implied in the orphan metaphor, along with the language of vv. 19–20, stresses the reciprocal nature of the relationship between Paul and his converts. That is, these Gentiles being formed as a faithful community after the pattern of Jesus are dependent on Paul’s formative actions, whereas Paul’s own eschatological standing is dependent on this community’s sustained fidelity to God. But the reciprocal nature of the relationship is evident also in that the community’s continuing faithfulness has encouraged Paul and his companions in their own distress and tribulation to remain faithful to God’s redemptive project in the present (3:7–8). So the audience’s continued fidelity to God provides formative encouragement in the present that solidifies Paul’s own fidelity. In other words, seeing the pattern of Jesus formed and faithfully lived out in a Gentile community testifies to the truth of the gospel, which in turn, sustains and solidifies the continued fidelity of its proclaimers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul and his colleagues are therefore in a relationship with the Thessalonians that is mutually formative. While it is important for Paul as a “true friend” to assure the audience that he is not absent from them in heart (v. 17),"), _c('a', {
    attrs: {
      "id": "fn234"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])]), _vm._v(" he underscores the importance of being physically present with them, of “seeing their face” in v. 17 and again in 3:10. In such mutually formative relationships, there is no substitute for face-to-face, physical interaction for effective modeling, encouragement, and exhortation. As contemporary research in psychology and neuroscience shows, we are reciprocally formed in the prolonged presence of others because we unconsciously mimic their mannerisms, facial expressions, behavior, and even ways of thinking and dispositions."), _c('a', {
    attrs: {
      "id": "fn235"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So it is no wonder that Paul has so much at stake in seeing his audience again face-to-face. And with so much at stake, it is no wonder that Paul can attribute his and his companions’ inability to return to the audience to Satan’s preventing it on more than one occasion (v. 18). Little is to be gained by speculating on what Paul understands as the concrete referent(s) of Satan’s actions. Whatever they are, claiming Satan as the cause was Paul’s retrospective interpretation of whatever happened."), _c('a', {
    attrs: {
      "id": "fn236"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")])]), _vm._v(" However, this is not to imply that Paul’s interpretation was wrong. He is not hesitant to speak about the presence of "), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("evil in the world, which actively opposes the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" (see further on 3:5 and 2 Thess 2:9; 3:3; cf. 2 Cor 4:4), a presence he refers to as “Satan.”")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Verse 19 contains the first usage of the term "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παρουσία")]), _vm._v(" ("), _c('i', [_vm._v("parousia,")]), _vm._v(" “royal coming”) in 1 Thessalonians, and here it is clearly a reference to the eschatological coming of “our Lord, Jesus.” His coming from heaven has already been mentioned in 1:10, and it is important to note that neither there nor here does Paul attempt to persuade his audience "), _c('i', [_vm._v("that")]), _vm._v(" the Lord Jesus will come. Nor does he attempt to persuade them here that this coming is appropriately described by the word “parousia,” which in its technical sense could refer to the coming of a (hidden) divinity or to official visits of high-ranking persons, especially provincial visits of kings and emperors.")]), _c('a', {
    attrs: {
      "id": "fn237"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])]), _vm._v(" As we will see in the comments on 4:13–18, Paul draws on this technical sense of the word later in addressing some of the audience’s eschatological concerns. Hence, there is no reason to hear the word “parousia” in this context any differently than as a reference to the Lord’s royal coming. In the letter as a whole, then, Paul simply assumes that the audience will take for granted that (1) the true Lord of the cosmos will come, (2) the direction is from heaven to earth (1:10; cf. Phil 3:20), and (3) his coming will have the character of a royal/imperial entrance, with both Paul and the audience present in the King’s presence. What Paul says to this point in his letter about the Lord’s coming begins to prepare the way for him to address the eschatological concerns in 4:13–5:11.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s12"
    }
  }, [_c('i', [_vm._v("3:1–5"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Sending of Timothy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("1")]), _vm._v("So, because we could no longer stand it, we gladly chose to be left alone in Athens "), _c('sup', [_vm._v("2")]), _vm._v("and sent Timothy, our brother and God’s coworker"), _c('a', {
    attrs: {
      "id": "fn238"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("238")])]), _vm._v(" in the gospel about Christ, in order to strengthen you all and encourage you for the sake of your faithfulness "), _c('sup', [_vm._v("3")]), _vm._v("so that no one would be shaken by these persecutions."), _c('a', {
    attrs: {
      "id": "fn239"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")])]), _vm._v(" "), _c('sup', [_vm._v("4")]), _vm._v("For you yourselves know that we are destined for this because, indeed, when we were with you, we kept telling you beforehand that we were going to be persecuted—just as it has happened, "), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("as you well know. "), _c('sup', [_vm._v("5")]), _vm._v("Because of this, I myself, because I could no longer stand it, sent to find out about your faithfulness in case the Tester had tested you all and our labor had been for nothing.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('p', {
    staticClass: "BodyFlush1"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("The chapter division here is arbitrary. Paul continues the thought from 2:20 with a “so” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διό")]), _vm._v(", "), _c('i', [_vm._v("dio")]), _vm._v("), indicating that 2:17–20 is the basis for what he is about to say here. Because of his intense feelings for his audience and his desire that they be properly formed in Christ, and because his own honor at the eschatological Day of the Lord is wrapped up with their personal and corporate life—and because he could no longer stand not knowing about them—Paul says, “We chose to be left alone in Athens and sent Timothy.”")]), _c('a', {
    attrs: {
      "id": "fn240"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")])]), _vm._v(" The language of being “left alone” conveys a feeling of loneliness and recalls the earlier language of “being orphaned” from his audience (2:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul goes on to describe Timothy as “our brother and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνεργὸν τοῦ θεοῦ")]), _vm._v(" ["), _c('i', [_vm._v("synergon tou theou,")]), _vm._v(" ‘coworker of God’] in the good news about Christ.” The phrase "), _c('i', [_vm._v("synergon tou theou")]), _vm._v(" can be translated “[our] coworker for God” (NRSV, similarly the NIV “[our] coworker in God’s service”). In that case, Timothy would be understood as belonging to God as "), _c('i', [_vm._v("Paul’s")]), _vm._v(" coworker, but not as a coworker with God."), _c('a', {
    attrs: {
      "id": "fn241"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("241")])]), _vm._v(" However, the discomfort in the textual tradition indicates that the phrase is most naturally understood as characterizing Timothy as a coworker "), _c('i', [_vm._v("with")]), _vm._v(" God (see note on translation above). In addition, Paul’s language elsewhere indicates that, while God remains the primary actor, God works together with and through Paul and his colleagues. For example, the phrase "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("θεοῦ")]), _vm._v(" . . . "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνεργοί")]), _vm._v(" ("), _c('i', [_vm._v("theou synergoi")]), _vm._v(") in 1 Cor 3:9 may be taken as characterizing Paul and Apollos as coworkers with God,"), _c('a', {
    attrs: {
      "id": "fn242"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("242")])]), _vm._v(" but even if that passage remains ambiguous, the language of 2 Cor 5:20–6:2 certainly moves in this direction. The phrase “God’s coworker” in this context implies at least a couple of things. First, God is actively at work in the speaking and exhibiting of the good news about Jesus the Messiah. In other words, the good news "), _c('i', [_vm._v("does")]), _vm._v(" something because God is at work when it is spoken and embodied (see comments on 1 Thess 2:13). Second, it implies that Timothy, who is actively working in speaking and embodying the good news, is working together with God."), _c('a', {
    attrs: {
      "id": "fn243"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("243")])]), _vm._v(" God, in other words, chooses to be active together with and through those who announce and embody the good news about Jesus the Messiah (1:5, 8; 2:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("Paul’s cruciform action in sending Timothy was for the purpose of strengthening and encouraging the audience to persevere in their faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v("), essentially continuing Paul’s own work among the audience (as described, e.g., in 2:12).")]), _c('a', {
    attrs: {
      "id": "fn244"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("244")])]), _vm._v(" As has been the case throughout the letter, "), _c('i', [_vm._v("pistis")]), _vm._v(" in this section (vv. 2, 5, 6, 7, 10) is not limited to the Thessalonians’ inner belief/trust but is better understood as faithfulness or fidelity,"), _c('a', {
    attrs: {
      "id": "fn245"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("245")])]), _vm._v(" particularly since the following phrase expresses the ultimate purpose of sending Timothy, that is, “so that no one would be shaken by these pressures/persecutions.” Paul says “these”"), _c('a', {
    attrs: {
      "id": "fn246"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")])]), _vm._v(" rather than “those” and uses a present tense verb to insist that “we are destined for this,” which implies that the “pressures/persecutions” afflicting the audience are continuing, as they are for him."), _c('a', {
    attrs: {
      "id": "fn247"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("247")])]), _vm._v(" His present tense assertion in 3:8, “We’re now truly alive, since you all "), _c('i', [_vm._v("are standing firm")]), _vm._v(" in the Lord,” also implies that the tribulations are continuing as he writes, as they clearly are at the time he writes 2 Thessalonians (see 2 Thess 1:4). For the nature of these “pressures/persecutions,” see the comments on 1:6.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul continues in v. 3b with “For you yourselves know that we are destined for this.” Paul and his cosenders kept nothing from the audience, being familiar themselves with what devotion to a crucified Lord might entail. Hence, they told them repeatedly"), _c('a', {
    attrs: {
      "id": "fn248"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("248")])]), _vm._v(" that all of them (i.e., the Thessalonians, Paul, Silas, and Timothy) were going to be pressured/persecuted, and thus, Paul says, it has happened. It is widely attested in the NT (e.g., 2 Thess 1:4–5; Phil 1:28–30; Mark 4:17; 13:9–13; Acts 14:22; Rev 1:9) that Christians were expected to suffer persecution as a result of their participation in God’s mission. Indeed, for Paul the opportunity to “suffer on behalf of Christ” was actually a gift, an expression of grace (Phil 1:29), because cosuffering was to lead to coglorification/cohonor at Christ’s royal appearance (4:13–18; 2 Thess 1:11–12) in the resurrection of the dead (Rom 8:17; Phil 3:10–11)."), _c('a', {
    attrs: {
      "id": "fn249"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("249")])]), _vm._v(" Suffering is not to be sought out but is an inevitable by-product of participating in the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" a consequence of being “God’s coworker,” wherein one’s body becomes a weapon of God’s own justice "), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("and saving covenant faithfulness in a world bent toward injustice ("), _c('i', [_vm._v("adikia;")]), _vm._v(" see the comments on 5:8; cf. Rom 6:13; 2 Cor 5:21).")]), _c('a', {
    attrs: {
      "id": "fn250"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("250")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So because Paul himself knew that the Thessalonians had encountered such pressures, he sent Timothy in order to find out about their faithfulness/fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") in the midst of it. Paul’s fear is that their “labor had been for nothing” (cf. Phil 2:16; Gal 2:2) as a result of the Thessalonians being tested by “the Tester,” that is, Satan (named in 2:18). Such language rhetorically casts the "), _c('i', [_vm._v("thlipsis")]), _vm._v(" (pressures/persecutions) they are experiencing as more than simply local social pressures but as part of a larger cosmic battle. In an apocalyptic view of the world, the actions of unseen powers lie back of, and are embodied in, human actions, such as the audience’s suffering at the hands of their fellow countrymen (2:14). Hence, Paul scripts their experience of "), _c('i', [_vm._v("thlipsis")]), _vm._v(" into a larger cosmic drama, in which the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" is being enacted and in which they are currently participating, but from which they would bow out if they succumbed to the temptation to return to what their society would have understood as normalcy. Paul’s expressed concern about whether they had done so indicates that he had no doubts that such a thing "), _c('i', [_vm._v("could")]), _vm._v(" happen. It had certainly happened previously to Israel itself when, rather than confronting the idolatry of the surrounding nations in faithfulness to God’s mission, they had been absorbed into it. Paul’s expressed confidence in God (e.g., 5:24), however, indicates that it "), _c('i', [_vm._v("would")]), _vm._v(" happen only if the Thessalonians eschewed God’s faithfulness to them in the midst of the pressure to be absorbed back into the “common sense” of their culture’s idolatrous practices.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is the only place where Paul explicitly refers to “the Tester/Tempter” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ πειράζων")]), _vm._v(", "), _c('i', [_vm._v("ho peirazōn")]), _vm._v("); there is no question that he is referring to Satan. The theme of testing/temptation is not that common in Paul’s letters, and Satan’s role in it is explicitly stated only in 1 Cor 7:5, but he is the implied agent or ultimate cause of testing/temptation elsewhere in the Pauline corpus (1 Cor 10:13; Gal 6:1; 1 Tim 6:9). Hence, it is clear that Paul conceives Satan as actively opposing God’s mission, one manifestation of which is his involvement in testing the fidelity of those participating in it. In the canonical context of Matthew’s portrayal of the testing of Jesus (Matt 4:1–11 // Luke 4:1–13), we have the same language as Paul uses here ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ πειράζων")]), _vm._v(", "), _c('i', [_vm._v("ho peirazōn,")]), _vm._v(" Matt 4:3), with Matthew naming that one “the devil” (4:5; cf. Mark 1:13; Luke 4:2). In Matthew’s and Luke’s depictions of this testing, what is tested is not Jesus’ belief but rather his fidelity/faithfulness to God’s way of his living out his sonship in carrying out God’s redemptive project."), _c('a', {
    attrs: {
      "id": "fn251"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("251")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("What is tested, one might say, is his fidelity or loyalty to the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" Given that the audience has already been portrayed as imitators of the Lord, this comparison with the Synoptic portrayal of the Son suggests that what is at stake here is the audience’s faithfulness/fidelity to God’s ongoing redemptive project, that is, to the "), _c('i', [_vm._v("missio Dei.")])])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s13"
    }
  }, [_c('i', [_vm._v("3:6–10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Timothy’s Good Report and Paul’s Desire to See the Thessalonians")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("6")]), _vm._v("But Timothy has just come back to us from you and brought good news (“gospel”) regarding your faithfulness and love and [telling us] that you always have a good memory of us, longing to see us, just as we also long to see you. "), _c('sup', [_vm._v("7")]), _vm._v("On account of this, sisters and brothers, we were encouraged because of you in all our distress and persecution through your faithfulness, "), _c('sup', [_vm._v("8")]), _vm._v("so that"), _c('a', {
    attrs: {
      "id": "fn252"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")])]), _vm._v(" we’re now truly alive, since you all are standing firm in the Lord. "), _c('sup', [_vm._v("9")]), _vm._v("For what thanksgiving are we able to repay to God for you all for the joy with which we are rejoicing because of you in the presence of our God "), _c('sup', [_vm._v("10")]), _vm._v("as we, night and day, more than you can imagine, beg to see your face and make complete the things lacking in your faithfulness?")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In vv. 6–10 Paul describes the results of Timothy’s return, in view of which he has written the entire letter. Because Paul said earlier that his separation from the audience had been for only a short time (2:17), it seems likely that he wrote the letter shortly after Timothy’s return."), _c('a', {
    attrs: {
      "id": "fn253"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])]), _vm._v(" Timothy’s report bringing good news had two parts, the first having to do with the audience’s Christian identity, the second, with their relationship with Paul. First, the news is good with regard to the audience’s fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and their love ("), _c('i', [_vm._v("agapē")]), _vm._v(") for each other, for Paul and Timothy, and perhaps for others outside the community as well."), _c('a', {
    attrs: {
      "id": "fn254"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")])]), _vm._v(" For Paul, fidelity toward God and love for others go hand in hand; they are distinguishable "), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("but inseparable and together constitute the quintessential marker of Christian identity (see comments on 1:3; 5:8; cf. Gal 5:6; Col 1:4).")]), _c('a', {
    attrs: {
      "id": "fn255"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("255")])]), _vm._v(" Timothy’s report is the basis for what Paul writes not only here, but also in 1:6, namely, that the audience is continuing to embody an overall life pattern that is analogous to that of the cruciform Lord, whose life of suffering and death was characterized by fidelity to God’s redemptive mission expressed in self-giving love for others. This Spirit-enabled life pattern of fidelity and love constitutes a participation in Christ’s quintessential act of covenant fulfillment, that is, his unified act of fidelity and love that culminated on the cross. As such, they bear the mark of a justified people and, in the present, anticipate sharing in Christ’s vindicating, future resurrection, resulting in the culmination of their transformation and in public honor (see further comments on 4:14 and 2 Thess 1:12)."), _c('a', {
    attrs: {
      "id": "fn256"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("256")])]), _vm._v(" In this context, such is the concrete meaning of (the participatory language of) “standing firm "), _c('i', [_vm._v("in")]), _vm._v(" the [cruciform] Lord” and is the basis for Paul’s confidence that they did not succumb to the “Tester/Tempter.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While the audience could have had reason for harboring bad memories of Paul,"), _c('a', {
    attrs: {
      "id": "fn257"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("257")])]), _vm._v(" the second part of Timothy’s good news is that they instead have a good memory of him. The “good memory” Timothy reports may indeed imply fond and pleasant memories of Paul, but its primary referent is probably the absence of doubts and suspicions and the presence of a clear recollection of the sort of person Paul proved to be when he was with them (1:5),"), _c('a', {
    attrs: {
      "id": "fn258"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("258")])]), _vm._v(" a memory that might continue to help form their own character along similar lines. In any case, that “good memory” results in their longing to see Paul, just as he longs to see them (cf. Rom 1:11; Phil 2:26), as indeed “true friends” do in their physical (but not emotional) separation from each other.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This good report of their fidelity and love and their continued good memory and strong feelings for Paul encouraged him in his own distress and persecution to remain faithful to God’s mission. While such mutuality and reciprocity were at the core of the concept of friendship in the Greco-Roman world and no doubt influenced Paul’s language here,"), _c('a', {
    attrs: {
      "id": "fn259"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("259")])]), _vm._v(" this is not just an example of mutual dependence on one another. It is a mutual mediation of God’s grace, "), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("a reciprocity of grace that comes initially through Paul to the audience and then returns through the audience as sustaining grace to Paul (see comments on 2:19–20). This sustaining grace impacts Paul to such an extent that he can describe his state as being “truly alive, since ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐάν")]), _vm._v(", "), _c('i', [_vm._v("ean")]), _vm._v("] you all are standing firm ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("στήκετε")]), _vm._v(", "), _c('i', [_vm._v("stēkete")]), _vm._v("] in the Lord.”")]), _c('a', {
    attrs: {
      "id": "fn260"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("260")])]), _vm._v(" As Gaventa puts it, “Now that the crisis has passed, [Paul] breathes again.”"), _c('a', {
    attrs: {
      "id": "fn261"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("261")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In vv. 9–10 Paul returns to the theme of thanksgiving, only now in the form of a long rhetorical question that is filled with vivid emotion and underscores the fact that Paul’s joy is ultimately because God has been at work among the Thessalonians, enabling them to stand firm in the Lord by exhibiting fidelity to God and cruciform acts of love for others. When Paul asks what thanksgiving is adequate to repay God for all the joy they have brought to him, his language echoes conventional language of reciprocity when one receives a great gift from a benefactor."), _c('a', {
    attrs: {
      "id": "fn262"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("262")])]), _vm._v(" The implied answer to his question is: There is simply no thanksgiving that is adequate to the task, which makes it all the more important to publicly announce that he can find no adequate way to thank God for what God has done for the Thessalonians!")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 10 we learn—not surprisingly, given our comments on 2:17—that Paul makes “seeing their face” a matter of fervent, intense, repeated prayer. As we noted earlier, there is simply no substitute for face-to-face, physical interaction for effective modeling, encouragement, and exhortation whose ultimate goal is transformation. And it is precisely the need for this transformation that Paul connects with seeing their face in 3:10b. He has so unequivocally affirmed this audience’s fidelity to God until this point that it is a bit surprising to hear him express his desire to “make complete ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καταρτίσαι")]), _vm._v(", "), _c('i', [_vm._v("katartisai")]), _vm._v("] the things lacking in your faithfulness ["), _c('i', [_vm._v("pistis")]), _vm._v("].” The key to understanding what is at stake here lies in recognizing that the verb "), _c('i', [_vm._v("katartizō")]), _vm._v(" occurs often in educational contexts to refer to the teacher completing the student’s instruction so that he or she could live fully as an adult (cf. Luke 6:40)."), _c('a', {
    attrs: {
      "id": "fn263"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("263")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("This language, in conjunction with the completely positive portrayal of the audience’s fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") throughout the epistle until this verse, points away from any "), _c('i', [_vm._v("intentional")]), _vm._v(" disloyalty to God. Rather, given their relatively recent conversion and its accompanying new value system, it points toward "), _c('i', [_vm._v("a lack in their ability to discern")]), _vm._v(" how their fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") should be embodied in each circumstance that might confront them in their ancient Mediterranean society, especially how to face the continuing social pressure and persecution.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("It is difficult to overemphasize the radical change that had recently taken place in their lives. As Wayne Meeks observes, “Being or becoming religious in the Greco-Roman world did not entail either moral transformation or sectarian resocialization.”")]), _c('a', {
    attrs: {
      "id": "fn264"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("264")])]), _vm._v(" For Gentiles in the Roman Empire to worship a crucified and risen Jewish peasant as the one Lord would have been surprising enough, but to undergo a radical resocialization in which they became a part of a community whose moral life was to be characterized by a cruciform pattern would have required no less than a “conversion of the imagination.”"), _c('a', {
    attrs: {
      "id": "fn265"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("265")])]), _vm._v(" One’s “imagination” (or “life world”) often operates invisibly at an unacknowledged level, giving shape to one’s intentions and dispositions, as well as to the practices that flow out of them."), _c('a', {
    attrs: {
      "id": "fn266"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("266")])]), _vm._v(" Hence, this audience’s whole epistemological and volitional apparatus (i.e., their imaginations), through which they made cognitive/volitional judgments and construals about their world, had to be reshaped by the Holy Spirit."), _c('a', {
    attrs: {
      "id": "fn267"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("267")])]), _vm._v(" By the power of the Spirit working in and among them, one “life world” had to be unlearned and another learned."), _c('a', {
    attrs: {
      "id": "fn268"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("268")])]), _vm._v(" Otherwise they could not begin discerning what faithfulness and loyalty to the one God of Israel actually entailed, much less decide to enact such faithfulness. In short, their whole embodied life (inner and outer) had to be initially and continuously transformed. In NT terms, this transformation roughly corresponds to saying that one’s heart ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καρδία")]), _vm._v(", "), _c('i', [_vm._v("kardia")]), _vm._v(") must be changed and continuously “strengthened” in the ability to live faithfully (see comments on 3:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, after Paul left, and even after Timothy had brought back a totally positive report about their fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v("), Paul could anticipate (1) that numerous "), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("issues might arise in their social context about which he had not given them specific instruction")]), _c('a', {
    attrs: {
      "id": "fn269"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("269")])]), _vm._v(" and (2) that certain “life world” assumptions had been so engrained in their consciousness that acting on the basis of them might continue to seem natural, nothing but common sense. In other words, it would not be surprising that such an audience might not readily recognize possible threats to their loyalty to God, particularly in certain commonsense assumptions about sexual activity and in the way public life was organized, namely, in terms of patron-client relationships dependent on a system of social stratification. Paul goes on to address issues related to both these concerns in the very next section of the letter (4:1–12). In more basic terms, it is worth repeating that their imaginations were constantly bombarded with conceptions of “normal divinity” at odds with the cruciform pattern etched in the face of Jesus (see comments on 2:17). It would be easy for such conceptions to creep back into the community’s understanding of God, unintentionally underwriting a pattern of life running counter to the character of this cruciform God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Therefore, when Paul says he wants to “make complete the things lacking in your faithfulness/fidelity,” such lacks are "), _c('i', [_vm._v("not")]), _vm._v(" likely activities (or even lack of trust) in which the audience is currently engaged that manifest intentional disloyalty to God."), _c('a', {
    attrs: {
      "id": "fn270"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("270")])]), _vm._v(" Rather, they most probably have to do with an imperfectly developed ability to discern which practices might lead to, or actually constitute, disloyalty toward the particular God revealed in Jesus. Rom 12:2 expresses the gist of what Paul is concerned with here, namely, that this audience’s mind and imagination will be in the process of continual transformation into a progressively more cruciform shape so that they will be increasingly adept at being able to discern what God’s will for them might be in a variety of situations in their particular social setting. Hence, what remains incomplete and ongoing in their "), _c('i', [_vm._v("pistis")]), _vm._v(" is what I have called elsewhere “the sanctification of their imagination,”"), _c('a', {
    attrs: {
      "id": "fn271"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("271")])]), _vm._v(" which only God can do (as 5:23 affirms). However, Paul’s language here implies that one of the means by which God brings it about is a face-to-face encounter with other graced persons, whether Paul himself or, in the meantime, the graced person who reads this epistle to its audience. Paul therefore says that he prays constantly that God will allow him to see them again, presumably for a more extended time of face-to-face instruction to continue their Christian formation. "), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("In the meantime, he uses the rest of the epistle to initiate that completion, suggesting that at least some of what follows in 4:1–5:22 constitutes some of the areas where Paul is attempting to complete his audience’s ability to discern how their "), _c('i', [_vm._v("pistis")]), _vm._v(" should be embodied in their particular context.")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s14"
    }
  }, [_c('i', [_vm._v("3:11–13"), _c('span', {
    staticClass: "space"
  }, [_vm._v("First Petitionary Prayer for the Holiness of the Thessalonians")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("11")]), _vm._v("Now may our God and Father himself and our Lord Jesus clear our way to you. "), _c('sup', [_vm._v("12")]), _vm._v("And may the Lord enable you to increase and flourish in love for one another and for all, just as we [were enabled by the Lord to increase and flourish in love] for you all "), _c('sup', [_vm._v("13")]), _vm._v("in order that he might strengthen"), _c('a', {
    attrs: {
      "id": "fn272"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("272")])]), _vm._v(" your hearts to be blameless in holiness in the presence of our God and Father in the royal coming of our Lord Jesus with all his holy ones."), _c('a', {
    attrs: {
      "id": "fn273"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("273")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("With the issue of “making complete” what is lacking in their fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") ringing in the ears of his audience, Paul moves directly into a petitionary prayer in 3:11–13. This prayer functions as a rhetorical hinge to connect the first major section of the letter (1:2–3:13) with the second major section (4:1–5:24), which itself concludes with another petitionary prayer with similar concerns as this one."), _c('a', {
    attrs: {
      "id": "fn274"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("274")])]), _vm._v(" Hence, all the material in between, in which Paul exhorts his audience with regard to their practices, is framed both rhetorically and theologically with prayers invoking God’s enabling grace on their behalf. The material sandwiched between these prayers does, however, clearly indicate that this divine enabling grace does not operate apart from the volition and action of those in Christ, by whom it must be appropriated for it to become effective in their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Not surprisingly, this prayer reflects some issues in 1:2–3:10 and also anticipates some concerns of 4:1–5:22. Sounding a similar note as 3:10, it implores God the Father and the Lord Jesus to make it possible for Paul’s ministry to continue among them by clearing his way to his audience (3:11), thereby overcoming Satan’s attempts to block Paul’s visit to them (2:18). Paul also prays that the audience will be enabled to increase and abound in the love that already "), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("characterizes them (1:3; 3:6; 4:9), the faithful embodiment of which is explicitly an issue in 4:9–12 and implicitly an issue in 4:1–8 and 5:12–13, 15. The ultimate purpose of this first petitionary prayer is that the hearts of the Thessalonians will be established “blameless in holiness” before God at the royal coming of the Lord Jesus. Paul’s own cruciform example has exemplified a way of life that is holy and blameless (2:6–12), and holiness will immediately be an explicit issue in 4:1–8 and implicitly so in 4:9–12 and 5:12–22. The eschatological setting in which the audience is to become blameless in holiness has already been alluded to (1:10; 2:19–20; probably 1:3) and is the subject of 4:13–5:11.")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This first prayer thus looks both backward and forward and is connected with the prayer in 5:23–24, which ends the next major section of the letter. These prayers frame what comes between them with the orienting concern of Paul’s desire for the audience’s holiness/sanctification. The same concerns appear in both, that is, the audience’s holiness/sanctification and their being kept blameless at the parousia. The Lord’s establishment of their hearts blameless ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτους")]), _vm._v(", "), _c('i', [_vm._v("amemptous")]), _vm._v(") in holiness ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιωσύνη")]), _vm._v(", "), _c('i', [_vm._v("hagiōsynē")]), _vm._v(") in the parousia (3:13) is hardly different from God’s entire sanctification ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιάσαι")]), _vm._v(", "), _c('i', [_vm._v("hagiasai")]), _vm._v(") of them, in which their whole spirit, soul, and body will be kept blameless ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτως")]), _vm._v(", "), _c('i', [_vm._v("amemptōs")]), _vm._v(") in this same parousia (5:23). Paul thus does more than simply connect the completion of the things lacking in the faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") of his audience (3:10) to his prayer for a face-to-face interaction with the audience. He also connects it with the petition that the Lord (Jesus) would establish their “hearts blameless in holiness” at the parousia, which he further explicates in 5:23 as God (the Father) himself completely sanctifying the community as a whole, and the whole of every person in it.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("Paul has both God the Father and the Lord Jesus engaging in the sanctification of God’s people in these prayers, which implicitly raises again the question as to the relationship between the two. The way Paul opens the prayer in v. 11 presses the question. His petition is that “our God and Father "), _c('i', [_vm._v("himself")]), _vm._v(" and our Lord Jesus” would clear his way to visit the Thessalonians, using a singular verb with this plural subject. Compound subjects in the NT in fact sometimes take singular verbs (e.g., Matt 5:18; Mark 4:41), and the emphasis in 3:11 is certainly on the Father.")]), _c('a', {
    attrs: {
      "id": "fn275"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("275")])]), _vm._v(" By itself, then, one might argue that the verb does not necessarily have theological significance. But our earlier comments on 1:1 suggest otherwise, as do the following factors in 1 and 2 Thessalonians: (1) "), _c('i', [_vm._v("As a monotheistic Jew,")]), _vm._v(" Paul is addressing a public prayer to "), _c('i', [_vm._v("both")]), _vm._v(" God the Father and Jesus as “Lord” (cf. Acts 1:24);"), _c('a', {
    attrs: {
      "id": "fn276"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("276")])]), _vm._v(" (2) he does the same thing "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("in 2 Thess 2:16–17, only there reversing the order, mentioning the Lord Jesus "), _c('i', [_vm._v("himself")]), _vm._v(" (emphatically) first and then God the Father; (3) he can address either in prayers separately (the Father in 1 Thess 1:2–3; 5:23; the Lord Jesus in 2 Thess 3:5, 16) and single one out for a particular petition when addressing them both (1 Thess 3:12);")]), _c('a', {
    attrs: {
      "id": "fn277"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("277")])]), _vm._v(" and (4) in this very context (3:13) Paul appears to be alluding to Zech 14:5 LXX, thereby identifying an OT reference to the future coming of “the Lord my God” with the future coming of “our Lord Jesus.”"), _c('a', {
    attrs: {
      "id": "fn278"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("278")])]), _vm._v(" Paul offers no explanation or warrant for these prayer practices or this sort of interpretation of an OT reference, indicating that he could already assume his audience’s familiarity with both his prayer practice and his practice of using OT allusions with christological referents."), _c('a', {
    attrs: {
      "id": "fn279"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("279")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is obvious that Paul is not explicating the relationship between the Father and the Son in the explicit language of the Nicene tradition, either here or elsewhere, but the singular verb has more significance than just indicating that they are somehow closely related. The implicit assumption in this and other prayers in 1 and 2 Thessalonians is that the Father and the Son share divine power and prerogative but remain distinguishable as addressable persons. Referring to this usage as simply a functional Christology that attributes divine activity to Jesus misses the point both historically and theologically. Historically, there is little parallel for a first-century Jew actually engaging in the practice of addressing in prayer any figure other than the unique God of Israel."), _c('a', {
    attrs: {
      "id": "fn280"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("280")])]), _vm._v(" Theologically, the pattern of judgments present in the texture of scriptural discourse concerning the God of Israel ought to provide us with an ontology."), _c('a', {
    attrs: {
      "id": "fn281"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("281")])]), _vm._v(" That is, we should not assume some understanding of God outside the text and then bring that to the table to see what functions of this God Jesus takes over. Rather, as interpreters of Christian Scripture, we should consider the pattern of judgments that emerge in Paul’s epistles as part of Scripture’s witness as a whole that forges an identity for Israel’s God, YHWH."), _c('a', {
    attrs: {
      "id": "fn282"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("282")])]), _vm._v(" Such an endeavor has the potential of overcoming the dualism between ontological and functional categories. Like "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("much of the NT, then, 1 and 2 Thessalonians include Jesus as Lord ("), _c('i', [_vm._v("kyrios")]), _vm._v(") in the unique identity of the one God of Israel in a way that makes the relationship between the Father and the Son constitutive of that God’s identity (see comments on 1:1). By including Jesus within the unique divine identity of Yahweh, the NT affirms that Jesus reveals the character of Israel’s God and is thus the ultimate exemplar of what it means to be holy.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("With the remainder of his public prayer in 3:12–13, Paul explicitly makes this holiness/sanctification a matter of public concern for the church. The prayer connects the language of holiness both with the heart ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καρδία")]), _vm._v(", "), _c('i', [_vm._v("kardia")]), _vm._v(") and with public, communal practices. Using the language of “sanctification of the imagination” with reference to Paul’s concerns here corresponds roughly to the language of one’s heart being initially and continuously changed. The correspondence is rough partially because Paul’s usage of anthropological terms in reference to inner aspects of persons is often imprecise. As in the LXX, “heart” ("), _c('i', [_vm._v("kardia")]), _vm._v(") in the NT generally refers to “the "), _c('i', [_vm._v("inner person,")]), _vm._v(" the seat of understanding, knowledge and will, and takes on as well the meaning "), _c('i', [_vm._v("conscience.")]), _vm._v("”")]), _c('a', {
    attrs: {
      "id": "fn283"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("283")])]), _vm._v(" Paul uses "), _c('i', [_vm._v("kardia")]), _vm._v(" with both volitional (e.g., 1 Thess 2:4; 1 Cor 4:5) and cognitive (e.g., Rom 10:8–9) nuances, demonstrating that he can use the term to refer to the inner aspect of one’s intentions, dispositions, and cognitive judgments. However, he does not use “inner” anthropological terms (e.g., heart, soul, spirit, mind) in precise ways, nor does he bracket off the inner activities associated with these from their embodiment in public practices.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given Paul’s concern about it in 3:1–10, being found blameless in holiness would certainly entail the audience’s divinely enabled (cf. 5:24) continued faithfulness to God in the midst of their tribulation. But here Paul specifically focuses on the Lord’s enabling the audience’s love ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγάπη")]), _vm._v(", "), _c('i', [_vm._v("agapē,")]), _vm._v(" i.e., concrete self-giving actions) to increase as the context within, or the means by which,"), _c('a', {
    attrs: {
      "id": "fn284"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("284")])]), _vm._v(" their hearts will be strengthened to be blameless in holiness. Fittingly, Paul’s petition that the Thessalonians will be enabled to increase and abound in self-giving practices is addressed specifically to the Lord (Jesus), whose cruciform life pattern defines love toward others (Gal 2:20; 2 Thess 2:13)."), _c('a', {
    attrs: {
      "id": "fn285"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("285")])]), _vm._v(" The audience has already seen this pattern modeled in Paul’s actions for their sake (2:6–12),"), _c('a', {
    attrs: {
      "id": "fn286"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("286")])]), _vm._v(" a pattern of life that Paul describes in 2:10 as "), _c('i', [_vm._v("holy")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁσίως")]), _vm._v(", "), _c('i', [_vm._v("hosiōs")]), _vm._v("), righteous ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δικαίως")]), _vm._v(", "), _c('i', [_vm._v("dikaiōs")]), _vm._v("), and blameless ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτως")]), _vm._v(", "), _c('i', [_vm._v("amemptōs")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here, then, Paul is imploring the "), _c('i', [_vm._v("crucified")]), _vm._v(" and risen Lord to enable the "), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("church to increase in "), _c('i', [_vm._v("cruciform")]), _vm._v(" practices (cf. Phil 1:9), practices in which Paul depicts them as "), _c('i', [_vm._v("already engaged")]), _vm._v(" (1:3; 3:6; 4:9–10). These are self-giving actions done by persons within the church for the sake of others within it and for the sake of “all,” including those outside the community (cf. 5:15; Gal 6:10).")]), _c('a', {
    attrs: {
      "id": "fn287"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("287")])]), _vm._v(" Since some of the latter may even be persecuting them, such expressions of love may indeed be costly. But as such, they reflect the words of this same Lord Jesus, who commands his disciples to love their enemies and to pray for those who persecute them, with the result that they show themselves as true sons and daughters of the Father, reflecting his own perfect (holy) character (Matt 5:43–48). Such loving actions in the midst of their own testing would, like the actions of Jesus in his wilderness testing, exhibit their fidelity/faithfulness to God’s way of living out their own sonship as they carry out God’s redemptive project in their particular social context. After all, in Pauline terms, this God reconciles his enemies with a very costly, loving act indeed—the death of his Son (Rom 5:8–10), the same Son who prays that the Father would forgive those (enemies) crucifying him (Luke 23:34)."), _c('a', {
    attrs: {
      "id": "fn288"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("288")])]), _vm._v(" Such practices are part and parcel of participating in the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" and thus constitutive of their role as a "), _c('i', [_vm._v("holy")]), _vm._v(" people. Not surprisingly, then, the purpose for the Lord’s enabling them to increase in love is to establish their hearts “blameless in "), _c('i', [_vm._v("holiness")]), _vm._v("” at the Lord’s royal coming.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this prayer, there is an initiating divine action (enabling the increase in love), followed by a responsive human action (engaging in cruciform practices)."), _c('a', {
    attrs: {
      "id": "fn289"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("289")])]), _vm._v(" In 4:10 Paul exhorts the audience to engage in the very action (i.e., to “continue abounding” in the loving practices of 4:9) that he implores the Lord to enable in 3:12. Hence, Paul depicts God as working among and in the Thessalonians, “not apart from, but in and through their own volition and action.”"), _c('a', {
    attrs: {
      "id": "fn290"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("290")])]), _vm._v(" This pattern is further evident from the prayer’s reciprocal movement "), _c('i', [_vm._v("from")]), _vm._v(" their being engaged in grace-enabled, self-giving practices "), _c('i', [_vm._v("to")]), _vm._v(" (or for the goal of)"), _c('a', {
    attrs: {
      "id": "fn291"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("291")])]), _vm._v(" their hearts/"), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("imaginations being strengthened to be blameless in holiness at the parousia. That is, Paul is depicting the Lord as sanctifying the hearts/imaginations of those in the church, not only in the encounter with graced persons like himself, but also "), _c('i', [_vm._v("in the context of,")]), _vm._v(" or even "), _c('i', [_vm._v("by means of,")]), _vm._v(" their own grace-enabled practices in a way that continues their initial transformation. The Lord’s enabling them to increase in love would therefore continue God’s transformation of them into a holy community whose conduct, like that of Paul’s among them (2:10), would be characterized by complete integrity (i.e., by being “blameless”) in the royal coming of the Lord. Prior to that time, Paul hopes for their communal life to exemplify increasing faithfulness toward God and to overflow with self-giving actions toward others—a “blameless” pattern of life analogous to that which Paul lived out among them (2:1–10).")]), _c('a', {
    attrs: {
      "id": "fn292"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("292")])]), _vm._v(" As such, they would be an instrument of the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" permeated with God’s own character/holiness as definitively revealed in the faithfulness and love of Jesus."), _c('a', {
    attrs: {
      "id": "fn293"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("293")])]), _vm._v(" It would be a “colony of cruciformity,”"), _c('a', {
    attrs: {
      "id": "fn294"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("294")])]), _vm._v(" an instantiation of the holiness of God in Thessalonica. Paul’s thanksgiving for this audience in 2 Thessalonians affirms that his prayer for them here is being at least partially answered before the Lord’s royal coming: “Brothers and sisters, as is only right, we’re bound to be thanking God always for you because your faithfulness is growing by leaps and bounds, and the love of every one of you for each other is increasing” (2 Thess 1:3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Since Paul clearly depicts the parousia as a theophany (see comments on 4:13–18), it is not surprising that the parousia of the Lord also brings this community into the “presence of our God and Father” (a phrase that is very similar to the “presence of our Lord Jesus in his royal coming” in 2:19). The term “blameless” also implies judgment connected with the parousia, most probably of the sort that is referred to in 1:10 (“the coming wrath”), 5:2–3, and 2 Thess 1:5–9. The phrase “with his holy ones” is repeated in the context of the latter (2 Thess 1:10); in both places it could refer to angels,"), _c('a', {
    attrs: {
      "id": "fn295"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("295")])]), _vm._v(" Christians,"), _c('a', {
    attrs: {
      "id": "fn296"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("296")])]), _vm._v(" or both."), _c('a', {
    attrs: {
      "id": "fn297"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("297")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Although Paul never explicitly uses the adjective “holy” to describe angels, it does seem possible that “holy ones” should be understood as including angels in this context for the following reasons. First, in 2 Thess 1:7, when Jesus is revealed from heaven, he is accompanied by his “powerful angels.” Although Paul does not explicitly mention angels in 1 Thess 4:13–18, the archangel’s voice in 4:16 probably implies their presence. Second, in both the OT and NT there is a tradition of angels (sometimes called “holy”) being present at the final judgment (e.g., Dan 7:18; Mark 8:38; Matt 16:27; 25:31; Jude 14 [citing Zech 14:5]). Third, Paul appears to be alluding here to Zech 14:5 LXX, where Yahweh comes with his heavenly court/angels (“And the Lord, my God, will come and all his holy ones with him”).")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("However, to limit the referent of “holy ones” to angels, either here or in 2 Thess 1:10, is unwarranted for several reasons.")])]), _c('ol', [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('li', [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Elsewhere, Paul almost always uses the language of “holy ones/saints” as a general designation for members of early Christian communities who stand in some continuity with Israel as God’s holy/missional people (e.g., Rom 1:7, 15:25; 1 Cor 1:2; Col 1:26).")]), _c('a', {
    attrs: {
      "id": "fn298"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("298")])])]), _vm._v(" "), _c('li', [_vm._v("The whole context of 3:13 and the following section ending in 5:24 is that of the expected current and eschatological holiness of the Thessalonians.")]), _vm._v(" "), _c('li', [_vm._v("Given that Paul, in alluding to Zech 14:5, simply identifies the referent of “the Lord my God” as “our Lord Jesus,” it would not be unlikely if the referent of “all his holy ones” was also not exactly identical with its referent in Zechariah’s original context.")]), _vm._v(" "), _c('li', [_vm._v("In 2 Thess 1:10 the “holy ones” who honor the Lord at his revelation need not be a different group from those who have come to faith and “marvel at him”—that is, Christians. But even if those who honor him in 1:10 include angels, Paul’s prayer in 1:12 is that "), _c('i', [_vm._v("his audience")]), _vm._v(" will be among those who honor him."), _c('a', {
    attrs: {
      "id": "fn299"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("299")])])]), _vm._v(" "), _c('li', [_vm._v("It is worth noting that, early on, “all his holy ones” was interpreted as referring to those raised from the dead who will come with the Lord ("), _c('i', [_vm._v("Did.")]), _vm._v(" 16:6–7), not to members of a heavenly court.")])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Based on these observations, it seems best to understand “all his holy ones” in 3:13 (and possibly in 2 Thess 1:10) as including members of Christian communities whose hearts are “blameless in holiness” in the parousia, as well as God’s heavenly court/angels. As we will see, this understanding "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("is confirmed by the way Paul depicts the parousia in 4:13–18.")]), _c('a', {
    attrs: {
      "id": "fn300"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("300")])]), _vm._v(" There he does not explicitly say that Christ comes from heaven with his (powerful) angels as he does in 2 Thess 1:7, although the archangel’s voice in 4:16 probably implies it. But he does explicitly depict the parousia as something "), _c('i', [_vm._v("into which Christ-followers may go")]), _vm._v(" by meeting the Lord in the clouds/air (not in heaven!) and "), _c('i', [_vm._v("only then coming with the Lord")]), _vm._v(" to take up his reign. None of these Christians, however, is depicted as accompanying Jesus "), _c('i', [_vm._v("all the way from heaven,")]), _vm._v(" but they do meet him in the clouds/air to join in his parousia. Such a scenario gives no support to the idea of secretly raptured saints returning from heaven with Christ or, for that matter, to the idea that Christians who have died and are currently “with the Lord” return with him from heaven to earth (see comments on 4:13–16)."), _c('a', {
    attrs: {
      "id": "fn301"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("301")])]), _vm._v(" In any case, “becoming [entirely] holy as God is holy” (Lev 11:44–45; 19:2; 1 Pet 1:16) is a necessary prerequisite of being in the direct presence of the Triune God, whether in heaven (in the case of angels) or on earth (in the case of those in Christian communities).")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s15"
    }
  }, [_vm._v("4:1–5:24"), _c('span', {
    staticClass: "space"
  }, [_vm._v("God’s Sanctifying Work in the Life of the Community in Anticipation of the Parousia on the Day of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In the second major section of the letter Paul encourages his audience to avoid certain practices and engage in others (4:1–12; 5:12–22) and clarifies issues relating to the parousia (4:13–5:11). His primary purpose in doing so is to encourage and bolster his audience’s perseverance in faithfulness in connection with God’s sanctifying work and their blamelessness at the parousia (5:23–24). Much in this section is simply reinforcing reminders of what the audience already knows or is already apparently doing (4:1–2, 6, 9–10; 5:1–2, 11). In 4:13–18, however, Paul is communicating new information regarding the participation in the parousia of those who have died, and in 5:12–22 he offers general admonitions regarding the audience’s communal life, with no indication as to whether the audience is already engaged in the practices that he encourages or those he prohibits.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul has already used the language of holiness/sanctification immediately before this new section (3:13), and it becomes particularly important for this section as a whole, explicitly so in 4:3–8 and 5:23–24 and implicitly so in the rest of the section. Hence, before offering detailed comments on this section "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("of 1 Thessalonians, some more general comments on holiness/sanctification are in order.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "line1"
  })]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s16"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s16"
    }
  }, [_vm._v("Excursus on Holiness/Sanctification")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("The primary terminology to refer to holiness in the Second Temple period (including the NT) is from "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἅγιος")]), _vm._v(" ("), _c('i', [_vm._v("hagios")]), _vm._v(") and its cognates, although other terms such as "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὅσιος")]), _vm._v(" ("), _c('i', [_vm._v("hosios")]), _vm._v(") might also be used."), _c('a', {
    attrs: {
      "id": "fn302"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("302")])]), _vm._v(" "), _c('i', [_vm._v("Hagios")]), _vm._v(" and its verbal forms were seldom used in the Greco-Roman world, where the concept of holiness itself had little importance. The "), _c('i', [_vm._v("hosios")]), _vm._v(" word group was most often used to describe things and people associated with cultic activities, but gods and goddesses were rarely described as holy. In contrast, the concept of holiness was so important to Second Temple Judaism and the NT that it provides the implicit background of numerous texts, even where explicit holiness language does not appear.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although not strictly opposites, holiness and impurity were both understood as dynamic forces, with holiness associated with (sources of) life, and impurity ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀκαθαρσία")]), _vm._v(", "), _c('i', [_vm._v("akatharsia")]), _vm._v(") with (sources of) death. As in the OT, in Second Temple Judaism there were dangerous consequences for contaminating God’s holy presence by bringing the holy into contact with the dynamic, contagious force of impurity. Hence, Second Temple conceptions of holiness had primarily to do with separation from the impure. This idea remained a concern for early Christians but was not configured along exactly the same lines as other forms of Second Temple Judaism. For example, although Paul continues to affirm the importance of purity or difference from pagan Gentiles—that is, avoiding sexual immorality (e.g., 1 Thess 4:5) and idolatry (e.g., 1 Thess 1:9; 1 Cor 10:1–22)—he rejects other traditional Jewish marks of holiness (e.g., circumcision, separate table fellowship) for his Gentile converts.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For Paul, although the messianic age had indeed been inaugurated, it had happened in a most unexpected way, namely, via a Spirit-inhabited, crucified messiah. When Paul and the earliest church claimed that God was in Jesus, "), _c('i', [_vm._v("a crucified messiah")]), _vm._v(" (2 Cor 5:19), it was scandalous and foolish (1 Cor 1:23). But this cruciform messiah was vindicated by the Spirit"), _c('a', {
    attrs: {
      "id": "fn303"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("303")])]), _vm._v(" and is the exalted Lord, "), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("who, then and now, remains marked by a cruciform character; he is “messiah having been "), _c('i', [_vm._v("and remaining")]), _vm._v(" [marked as] crucified” (1 Cor 1:23).")]), _c('a', {
    attrs: {
      "id": "fn304"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("304")])]), _vm._v(" Paul says that he “has become for us,” among other things, “holiness/sanctification ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιασμός")]), _vm._v(", "), _c('i', [_vm._v("hagiasmos")]), _vm._v("] from God” (1 Cor 1:30). He reveals the very character of the God of Israel, and thereby the nature of God’s holiness. This Jew from Nazareth hanging on the cross therefore does so as a public display of God’s holiness, revealing the very character of YHWH to be cruciform."), _c('a', {
    attrs: {
      "id": "fn305"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("305")])]), _vm._v(" In Stephen Barton’s terms, holiness has been dislocated and relocated in the "), _c('i', [_vm._v("crucified Lord.")]), _c('a', {
    attrs: {
      "id": "fn306"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("306")])]), _vm._v(" Hence, the character of the sanctity/holiness that derives from this God—none other than the Triune God—may best be described as “cruciformity.”"), _c('a', {
    attrs: {
      "id": "fn307"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("307")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this regard, as in other OT and Second Temple conceptions, holiness remains a dynamic force generating life—a dynamic salvific force that is (paradoxically) channeled through a death-dealing, shameful Roman cross. In this way, the Christ-event reconfigures OT and Second Temple conceptions of holiness primarily along the lines of a "), _c('i', [_vm._v("cruciform pattern of redemptive activity")]), _vm._v(" that reclaims persons for God’s reign and restores their relationship with the holy God, with others, and finally with creation itself. Hence, holiness retains its character as a dynamic force associated with life for Paul (e.g., holiness in Rom 6:22, whose goal ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τέλος")]), _vm._v(", "), _c('i', [_vm._v("telos")]), _vm._v("] is the life of the age to come), albeit life that comes ironically through death in all its impurity, particularly death on a shameful and bloody cross (Phil 2:8c).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When Paul uses language associated with holiness/sanctification (as in all of Second Temple Judaism), it is always derivative, that is, people, places, or things are holy only insofar as they are in relation to the Holy One, whose character defines holiness. There is a dynamic quality to this holiness in that it implies divine activity (which one might characterize as the "), _c('i', [_vm._v("missio Dei")]), _vm._v(") most focused in the Spirit-empowered faithfulness of the crucified and risen Christ, which itself calls forth and enables human participation in Christ’s faithfulness (i.e., active participation in the "), _c('i', [_vm._v("missio Dei")]), _vm._v("). This process whereby God calls forth and enables human participation in Christ’s faithfulness/mission constitutes God’s sanctifying activity for Paul, that is, God’s electing and setting apart a people to undergo Christoformity and thereby theoformity as God continues “giving his [life-giving] Spirit into them.”"), _c('a', {
    attrs: {
      "id": "fn308"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("308")])]), _vm._v(" If this phenomenon is a state, it is "), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("not a static, passive state; it is a state "), _c('i', [_vm._v("of activity,")])]), _c('a', {
    attrs: {
      "id": "fn309"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("309")])]), _vm._v(" a process whereby the Holy Spirit shapes a people to become Christlike, individually and corporately, in the midst of, and at least at times by means of, the actions in which they engage, not least actions through which the Spirit continues God’s mission.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Such a process is certainly morally transformative for those involved, but it is more than that. When Paul has the end goal of this process in view in 1 Thessalonians, he uses the language of the audience participating eschatologically in divine glory ("), _c('i', [_vm._v("doxa")]), _vm._v("), God’s holiness made visible. As we have seen, such "), _c('i', [_vm._v("doxa")]), _vm._v(" granted to humans has both sociological and ontological aspects (see comments on 2:12), that is, public honor and fully sharing in the divine attributes of the "), _c('i', [_vm._v("living")]), _vm._v(" God, namely, incorruption and life. This culminating act of sanctification is God’s vindicating, transforming resurrection (or vindicating transformation of the living). It constitutes their glorification, their full and final justification, and their complete sanctification, in that they now fully share in God’s own glory, his self-vindication as true Lord of the cosmos, and his holiness. This whole process—from initial election to God’s bringing redeemed humanity to its intended destiny—can properly be called sanctification ("), _c('i', [_vm._v("hagiasmos")]), _vm._v("), theosis, or for that matter, salvation itself."), _c('a', {
    attrs: {
      "id": "fn310"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("310")])]), _vm._v(" From beginning to end it is a gift from the God who continues to give his Spirit into his elect people and will be faithful to complete it.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s17"
    }
  }, [_c('i', [_vm._v("4:1–8"), _c('span', {
    staticClass: "space"
  }, [_vm._v("God’s Will: The Sanctification of the Community")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("1")]), _vm._v("Therefore, brothers and sisters, to move on to what remains to be said, we’re asking and encouraging you all in the sphere of the Lord Jesus that, just as you received from us [instructions on] how you should live and be pleasing to God—just as, in fact, you are living"), _c('a', {
    attrs: {
      "id": "fn311"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("311")])]), _vm._v("—you continue flourishing in living this way even more. "), _c('sup', [_vm._v("2")]), _vm._v("For you all know what instructions we gave to you through the Lord Jesus. "), _c('sup', [_vm._v("3")]), _vm._v("For this is the will of God, the sanctification of you all [which requires] that you all avoid sexual "), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("immorality. "), _c('sup', [_vm._v("4")]), _vm._v("More specifically, each of you [men] should learn to exercise control over your own male organ")]), _c('a', {
    attrs: {
      "id": "fn312"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("312")])]), _vm._v(" in holiness and with honor, "), _c('sup', [_vm._v("5")]), _vm._v("not “exercising control” with lustful passion like the Gentiles who do not acknowledge God. "), _c('sup', [_vm._v("6")]), _vm._v("In this matter, you are not to wrong or exploit your brother or sister, because the Lord is an avenger regarding these things, just as we also told you beforehand and solemnly testified. "), _c('sup', [_vm._v("7")]), _vm._v("For God did not call us to impurity but [to live] in the sphere of sanctification. "), _c('sup', [_vm._v("8")]), _vm._v("Therefore, the one who rejects [these instructions] is not rejecting a human but the God who is giving his Holy Spirit into you all.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("With the word “therefore,” Paul connects his prayer for the sanctification of the audience’s imagination in 3:12–13 with “what remains to be said,”"), _c('a', {
    attrs: {
      "id": "fn313"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("313")])]), _vm._v(" that is, the exhortation he is about to give in 4:1–8, as well as the broader paraenetic context through 5:22. Using a complimentary paraenetic style appropriate for exhorting friends, Paul portrays his audience in this section as "), _c('i', [_vm._v("currently")]), _vm._v(" conducting themselves in a way that is “pleasing to God” (vv. 1–2)."), _c('a', {
    attrs: {
      "id": "fn314"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("314")])]), _vm._v(" This characterization reinforces the point that they are indeed “imitators” of Paul and his cosenders (1:6), whose cruciform pattern of life in 2:1–12 has the characteristic of “not attempting to please humans but God” (2:4).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As we saw in the comments on 3:12–13, Paul has just prayed that "), _c('i', [_vm._v("the Lord will enable")]), _vm._v(" the Thessalonians to increase and flourish ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("περισσεύσαι")]), _vm._v(", "), _c('i', [_vm._v("perisseusai")]), _vm._v(") in the very self-giving actions in which he depicts them as already being engaged (1:3; 3:6; 4:9–10). Now, "), _c('i', [_vm._v("on the basis of")]), _vm._v(" that prayer just voiced publicly for them, in 4:1 Paul encourages them as one who lives in the same sphere of the reigning Lord Jesus as they do to “continue flourishing ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("περισσεύητε")]), _vm._v(", "), _c('i', [_vm._v("perisseuēte")]), _vm._v("] in living this way even more.” This exhortation is therefore cast in the same language as that of the enabling action he attributes to the Lord in the immediately preceding prayer in 3:12. The theo-logic of this wording is that, while the Lord’s enabling action is clearly prior, such enabling action generates and requires an "), _c('i', [_vm._v("ecclesial")]), _vm._v(" response, which consists of a continued pattern of life in which cruciform and therefore theo-form actions are on the increase. The "), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Lord Jesus embodied this cruciform pattern of activity in a way that effected the saving, reconciling purposes of the Triune God. God’s own activity in their grace-enabled response will result in their being “blameless in holiness at the Lord’s royal coming,” since it is this cruciform pattern of activity, the dynamic force of holiness, that is being embodied in their community. Throughout the Bible divine activity expresses divine essence/character, and the same is true of human communities and communal persons. Ecclesial activity expresses ecclesial essence/character.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("While Paul and his companions modeled positive exemplary practices of self-giving love, their modeling also included abstaining from certain other practices and calling attention to their doing so with the language of prohibitions. Hence, it is likely that the instructions mentioned in v. 2 at least included (but were probably not exhausted by)")]), _c('a', {
    attrs: {
      "id": "fn315"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("315")])]), _vm._v(" the kinds of prohibitions that follow in vv. 3b–6a.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With the “for” in v. 3, Paul connects these instructions with the will of God and places the audience’s sanctification in apposition to the latter. “For this is the will of God,” he says, “the sanctification ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιασμός")]), _vm._v(", "), _c('i', [_vm._v("hagiasmos")]), _vm._v("] of you all.” English translations treat the noun "), _c('i', [_vm._v("hagiasmos")]), _vm._v(" in various ways."), _c('a', {
    attrs: {
      "id": "fn316"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("316")])]), _vm._v(" Given that the strengthening of the audience’s hearts to be blameless in holiness ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιωσύνῃ")]), _vm._v(", "), _c('i', [_vm._v("hagiōsynē")]), _vm._v(") is to be accomplished by the Lord’s enabling them to increase and flourish in practices of self-giving love, it is hard to imagine that “your sanctification ["), _c('i', [_vm._v("hagiasmos")]), _vm._v("]” in this verse refers simply to a passive state granted by God, that is, a static condition to be expressed. Holiness/sanctification is indeed a state characteristic of those “in Christ,” but like salvation itself (see comments on 1 Thess 5:9), not a completely static or passive state. As the Lord enables the church to increase and flourish in cruciform (holy) practices and in and through them sanctifies their imaginations, the active state of those “in Christ” might best be described in the language of 2 Cor 7:1 as an ongoing state of “perfecting holiness ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιωσύνην")]), _vm._v(", "), _c('i', [_vm._v("hagiōsynēn")]), _vm._v("].” Flourishing in such Spirit-enabled practices, in addition to continuing to abstain from certain other practices, would result in their hearts (imagination) being “blameless” in holiness at the parousia.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, the term "), _c('i', [_vm._v("hagiasmos")]), _vm._v(" (sanctification) here is best understood as a process,"), _c('a', {
    attrs: {
      "id": "fn317"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("317")])]), _vm._v(" one initiated and completed by God, but not apart from the volition "), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("and participative activity of the church. The Thessalonians’ sanctification began when God elected and set them apart for participation in the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" and continued by God’s shaping their imagination and bodies by means of their participation in this mission as they flourished in practices of self-giving love. For the process to continue, however, they must also avoid some practices that might compromise their capacity to reflect God’s own character. Adhering to the prohibitions that follow is depicted as a "), _c('i', [_vm._v("necessary condition")])]), _c('a', {
    attrs: {
      "id": "fn318"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("318")])]), _vm._v(" for God to continue and complete his sanctifying work and for the audience to reflect his holy character.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The syntactic structure and exact meaning of the clauses (particularly that of v. 4) containing these prohibitions are much debated. Verses 3b–6a have three clauses, all of which are closely related and have to do with sexual matters."), _c('a', {
    attrs: {
      "id": "fn319"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("319")])]), _vm._v(" The first admonition (i.e., to abstain from sexual immorality in 3b) is made more specific by the second admonition in vv. 4–5 (on the meaning of which, see below). The last clause (not to wrong or exploit your brother or sister in this matter in 6b) explicates the effect of failing to follow Paul’s admonition in vv. 4–5."), _c('a', {
    attrs: {
      "id": "fn320"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("320")])]), _vm._v(" If this summary is correct, the fact that Paul equates engaging in the specific sexual activity prohibited in vv. 4–5 as wronging or exploiting one’s “brother/sister” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀδελφόν")]), _vm._v(", "), _c('i', [_vm._v("adelphon")]), _vm._v(") makes it likely that these particular admonitions are directed primarily toward intracommunal sexual practices. Even so, the typically (although not universally) tolerant attitude toward male sexual activity outside of marriage in non-Jewish society at large would be reason enough for Paul to remind this Gentile audience that any such activity would compromise their identity as God’s holy people. Apart from some moral philosophers (e.g., Musonius Rufus), the idea that free males should not have sexual relations outside of marriage would have been countercultural indeed. On the contrary, it was “common sense”—even their right—and not categorized as immoral.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, Paul’s first admonition in v. 3 to abstain ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀπέχεσθαι")]), _vm._v(", "), _c('i', [_vm._v("apechesthai")]), _vm._v(") from sexual immorality ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πορνεία")]), _vm._v(", "), _c('i', [_vm._v("porneia")]), _vm._v(") would have a decidedly Jewish ring and content, namely, to avoid any form of sexual relations outside marriage."), _c('a', {
    attrs: {
      "id": "fn321"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("321")])]), _vm._v(" This is the same verb used to admonish the “Gentiles who are turning to God” in "), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("Acts 15:19 in the so-called apostolic decree to abstain ("), _c('i', [_vm._v("apechesthai")]), _vm._v(") from things polluted by idols and from sexual immorality ("), _c('i', [_vm._v("porneia")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn322"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("322")])]), _vm._v(" Paul is reminding this Gentile audience, who turned to God from idols (1:9–10), that their continuing sanctification is contingent upon their abstaining from sexual immorality. Like other Jews of the time influenced by their Scripture (e.g., Wis 14:12), Paul readily made a connection between idolatry and sexual immorality."), _c('a', {
    attrs: {
      "id": "fn323"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("323")])]), _vm._v(" Not only was Israel’s idolatry/covenant unfaithfulness rhetorically cast in terms of sexual immorality/adultery (e.g., Ezek 23; Hos 1:2), it was typical for Jews to see idolatry and sexual immorality as connected and as the paradigmatic sins of the Gentile world (note the progression of thought in Rom 1:23–27). In a sense, "), _c('i', [_vm._v("porneia")]), _vm._v(" was a form or expression of idolatry. In a city like Thessalonica, the two were also concretely connected at the social level in a variety of ways (e.g., public festivals and banquets in the temples or private homes involving gluttony, drunkenness, and sex with prostitutes)."), _c('a', {
    attrs: {
      "id": "fn324"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("324")])]), _vm._v(" Engaging in "), _c('i', [_vm._v("porneia,")]), _vm._v(" even (or especially!) at the intracommunal level, would make the Thessalonians’ life together indistinguishable from much of the society around them, threatening their character as a community set apart from its culture as an instrument in the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" Such activity might even reflect the character and activities of the gods in the Greco-Roman pantheon, but certainly not the faithful character of Israel’s God, to whom the audience had turned. It would therefore ultimately be a move toward idolatry and thus could simply not coexist with God’s sanctifying activity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not entirely clear what Paul means in v. 4, in particular how to translate "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("σκεῦος κτᾶσθαι")]), _vm._v(" ("), _c('i', [_vm._v("skeuos ktasthai")]), _vm._v("). The referent of the noun "), _c('i', [_vm._v("skeuos")]), _vm._v(" and the meaning of the infinitive "), _c('i', [_vm._v("ktasthai")]), _vm._v(" have been the source of disagreement among translators and interpreters of these letters from antiquity to the present."), _c('a', {
    attrs: {
      "id": "fn325"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("325")])]), _vm._v(" The main options include the following:"), _c('a', {
    attrs: {
      "id": "fn326"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("326")])])]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("Paul is counseling "), _c('i', [_vm._v("the unmarried men")]), _vm._v(" in his audience “to understand/learn how to acquire ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] a wife ["), _c('i', [_vm._v("skeuos")]), _vm._v("]” for themselves as a guard against sexual immorality (cf. 1 Cor 7:9, 36).")]), _c('a', {
    attrs: {
      "id": "fn327"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("327")])])]), _vm._v(" "), _c('li', [_vm._v("Paul is exhorting "), _c('i', [_vm._v("any married man")]), _vm._v(" in the audience “to understand/learn how to live with ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] his wife ["), _c('i', [_vm._v("skeuos")]), _vm._v("] in holiness and honor,”"), _c('a', {
    attrs: {
      "id": "fn328"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("328")])]), _vm._v(" especially with regard to avoiding any “lustful passion” as they are having sex."), _c('a', {
    attrs: {
      "id": "fn329"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("329")])])]), _vm._v(" "), _c('li', [_vm._v("Paul is counseling "), _c('i', [_vm._v("the men")]), _vm._v(" in the audience “to understand/learn how to exercise control over ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] their own penis ["), _c('i', [_vm._v("skeuos")]), _vm._v("].”"), _c('a', {
    attrs: {
      "id": "fn330"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("330")])])]), _vm._v(" "), _c('li', [_vm._v("Paul is encouraging the whole audience, "), _c('i', [_vm._v("both males and females,")]), _vm._v(" “to understand/learn how to exercise control over ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] their own body ["), _c('i', [_vm._v("skeuos")]), _vm._v("].”"), _c('a', {
    attrs: {
      "id": "fn331"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("331")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("None of these options is free of difficulties. Option 1 does not adequately explain why Paul would use such ambiguous language to counsel acquiring a wife."), _c('a', {
    attrs: {
      "id": "fn332"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("332")])]), _vm._v(" He is perfectly capable of using typical words for husband and wife in 1 Cor 7:1–7, where he speaks of them providing each other with sexual satisfaction as a guard against "), _c('i', [_vm._v("porneia.")]), _vm._v(" This option also seems to make the verb “understand/learn how” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδέναι")]), _vm._v(", "), _c('i', [_vm._v("eidenai")]), _vm._v(") unnecessary. It also leaves no good explanation for why Paul would warn (Gentile) males in the audience "), _c('i', [_vm._v("not")]), _vm._v(" to “acquire a wife in lustful passion like the Gentiles who do not acknowledge God,” as though he was unaware that those unbelieving Gentiles would not have considered the purpose of marital sex to be satisfying a man’s sexual desires. While some ancient Greek romantic novels may have viewed sexual relations within marriage as a way of controlling sexual passions,"), _c('a', {
    attrs: {
      "id": "fn333"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("333")])]), _vm._v(" it was more typical to portray marital sex as being for the purpose of having children, not for satisfying one’s sexual desires."), _c('a', {
    attrs: {
      "id": "fn334"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("334")])]), _vm._v(" Mistresses and prostitutes were more typical outlets for satisfying a man’s “lustful passions.” With regard to option 2,"), _c('a', {
    attrs: {
      "id": "fn335"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("335")])]), _vm._v(" to say that "), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("Paul is counseling “passionless sex” within marriage is in some tension with what he says in 1 Cor 7:1–7 about the role of marriage partners satisfying each other sexually as a prophylactic against "), _c('i', [_vm._v("porneia.")])]), _c('a', {
    attrs: {
      "id": "fn336"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("336")])]), _vm._v(" Also, unless v. 6 is dealing with something else altogether, it is difficult to see what failure to have stoic-like “passionless sex” within marriage could have to do with “wronging or exploiting one’s brother/sister ["), _c('i', [_vm._v("adelphos")]), _vm._v("].” As regards option 4, while Paul certainly can use "), _c('i', [_vm._v("skeuos")]), _vm._v(" to refer to the human body in general (2 Cor 4:7), it is difficult to understand why he would do so in a context where a simple reference to the word “body” ("), _c('i', [_vm._v("sōma")]), _vm._v(") would have sufficed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With these difficulties in mind, I see option 3 as the simplest and most likely alternative."), _c('a', {
    attrs: {
      "id": "fn337"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("337")])]), _vm._v(" It best explains why Paul would use such indirect language here, that is, he wants to refer to the penis euphemistically in a public setting, for this letter is being read aloud “to all the brothers and sisters” (5:27). In a culture in which phallic symbols were widespread and the sexual practices of many male Gentiles were roundly criticized by many Jews, it is not surprising that Paul might counsel the Gentile males in this audience to gain mastery over ("), _c('i', [_vm._v("ktasthai")]), _vm._v(") their penises, unlike those Gentiles in their culture who do not acknowledge God and who use them “in passionate lust.” What follows in v. 6 would also make good sense in that failure to respond to Paul’s counsel “in this particular matter” would indeed have the potential"), _c('a', {
    attrs: {
      "id": "fn338"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("338")])]), _vm._v(" of wronging or exploiting a brother or sister (see below). The primary objection to this view is that "), _c('i', [_vm._v("ktasthai")]), _vm._v(" (gain mastery over) does not normally have a durative sense (i.e., possess/control) in the present tense. However, although this sense may have been confined to the perfect and pluperfect tenses in classical Greek, there is evidence in the papyri and other texts of this meaning appearing in other tenses, including the present."), _c('a', {
    attrs: {
      "id": "fn339"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("339")])]), _vm._v(" Hence, it does not seem unreasonable to think that Paul may be using it in a durative sense here to mean something like “exercise control over.”"), _c('a', {
    attrs: {
      "id": "fn340"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("340")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While certainty thus remains impossible, it is probable that vv. 4–5 describe more explicitly what abstaining from "), _c('i', [_vm._v("porneia")]), _vm._v(" entails in the particular "), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("situation Paul addresses here; namely, males in the audience are to learn to exercise control over their own penis in holiness and with honor, not “exercising control” with lustful passion “like the Gentiles who do not acknowledge God” might claim they are doing by engaging in various sexual encounters. Although terminological connections are absent here, this was basically what some male elites in society claimed about their bodies and their senses (by twisting Plato), that is, that unbridled pleasurable sexual actions demonstrated their ownership/control over their own bodies to use them as “nature” intended.")]), _c('a', {
    attrs: {
      "id": "fn341"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("341")])]), _vm._v(" Hence, a commonsense way of demonstrating that a free male was exercising proper ownership/control of his own penis would have been to engage in what Jews would have called "), _c('i', [_vm._v("porneia.")]), _vm._v(" In this countercultural community, however, Paul says that the reverse is true. Males in the holy sphere of the lordship of Christ demonstrate that they exercise control over their own penis in holiness and with the honor consistent with that sphere of lordship. That is, they engage in sexual relations only with their wife in a way that displays sexual fidelity and love to her, thereby analogically reflecting the faithful character of the one in whose sphere of lordship they now reside.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A possible objection to this interpretation is that the audience would have to recognize that “each of you all” in v. 4 specifically addresses the males in the audience, whereas the language of “you all” ("), _c('i', [_vm._v("hymeis")]), _vm._v(") in the surrounding verses (4:1–3, 6, 8) seems to apply to the whole audience, both male and female. Although, on the basis of the verbal and conceptual parallels between this passage and Rom 1:24–28, it is tempting to address this possible objection by taking "), _c('i', [_vm._v("skeuos")]), _vm._v(" as a euphemism for both male and female sex organs, there is little precedent for its being used as a euphemism for the female sex organ."), _c('a', {
    attrs: {
      "id": "fn342"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("342")])]), _vm._v(" Hence, it seems better to assume that Paul is tailoring his general example of the "), _c('i', [_vm._v("porneia")]), _vm._v(" to be avoided in vv. 4–6 to what he imagines is more likely in the circumstances of this newly converted audience, namely, a possible illicit sexual relationship initiated by a free male in the audience who, in general, would have more power and opportunity to do so than would females. The euphemistic metaphor itself would have been the signal to the whole audience that Paul was momentarily addressing these free males. But it would not necessarily have signaled that the rest of Paul’s rhetoric in the context did not apply to the women also, who were part of a corporate body whose holiness would be threatened if a male member of that body failed to exercise sexual control."), _c('a', {
    attrs: {
      "id": "fn343"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("343")])]), _vm._v(" Hence, whereas in this specific "), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("context Paul momentarily singles out the free males in his audience with his euphemistic metaphor, it remains God’s will that "), _c('i', [_vm._v("all")]), _vm._v(" in the audience be holy, abstain from "), _c('i', [_vm._v("porneia,")]), _vm._v(" and thus not hinder the work of the Holy Spirit, whom God was continuing to “give into [them] all.”")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("In this context, failing to exercise such control and instead acting with the sort of lustful passion characteristic of Gentiles who do not acknowledge God would result in wronging or exploiting an "), _c('i', [_vm._v("adelphos")]), _vm._v(" (brother or sister) in God’s household. There is no reason that the word "), _c('i', [_vm._v("adelphos")]), _vm._v(" should not be heard in a gender-inclusive sense in this context. Paul would probably consider that a male church member had been wronged or exploited if another male member of the church engaged in sex with the former’s wife, daughter, or possibly their female slave. He would probably also consider that a female member of the church, whether married or unmarried, had been wronged or exploited if a male member who was not her husband had sex with her, treating her as simply an object for his “lustful passion.” If there were members of this church who owned slaves who were also a part of the church, Paul’s language here would also function as a warning against the commonsense view that a free male had the right to use that slave (whether male or female) as a means of satisfying his sexual urges.")]), _c('a', {
    attrs: {
      "id": "fn344"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("344")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In any case, all such intracommunal sexual practices would reflect the opposite of cruciform behavior and therefore would fail to reflect the character of God. Instead, they would reflect the (Gentile) pattern of life outside the church, life among “the Gentiles who do not acknowledge God” (4:5), life among those who have not “turned to God from idols to be enslaved to the living and true God” (1:9). In this case, “sexual immorality . . . and cruciform love cannot coexist, for "), _c('i', [_vm._v("porneia")]), _vm._v(" is a form of self-love, of self-indulgence that harms others and diminishes the holiness of both the individual and the community.”"), _c('a', {
    attrs: {
      "id": "fn345"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("345")])]), _vm._v(" Here, then, it is precisely sexual behavior that expresses the opposite of cruciformity (and therefore, holiness) that is being prohibited."), _c('a', {
    attrs: {
      "id": "fn346"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("346")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Before moving on to comment on the reasons Paul gives for avoiding these sexually immoral practices in vv. 6b–8, we should note a number of verbal and conceptual connections between this section of Paul’s letter and Ezek 36:16–37:14. Acknowledging the failure of Israel as a whole to reflect God’s holiness, which brings down his wrath upon them (Ezek 36:16–21), Ezekiel announces to the exiled nation that God would restore them by (1) cleansing them from their impurities (e.g., Ezek 36:25b, 29a; cf. 1 Thess 4:7), namely, the polluting effects of "), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("idolatry; (2) taking them “out of the nations/Gentiles” (36:24),")]), _c('a', {
    attrs: {
      "id": "fn347"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("347")])]), _vm._v(" giving them “a new heart” (36:26; cf. 1 Thess 3:13); and (3) giving his “Spirit/breath in/among you all” (36:26–27; cf. Jer 31:34; Joel 2:28–29; cf. 1 Thess 4:8). This restoration and renewal of exiled Israel is then depicted in Ezek 37 with the well-known imagery of the Spirit’s actions in the valley of (Israel’s) dry bones. No fewer than four times, Ezekiel emphasizes that the Spirit enters "), _c('i', [_vm._v("into")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς")]), _vm._v(", "), _c('i', [_vm._v("eis")]), _vm._v(") these dry bones (37:5, 6, 10, 14). Two of these times he uses the language of God’s "), _c('i', [_vm._v("giving")]), _vm._v(" his Spirit “into ["), _c('i', [_vm._v("eis")]), _vm._v("] you all” (37:6, 14), language almost identical to that used in 1 Thess 4:8. But Israel is not renewed simply for its own sake (Ezek 36:21–23). Rather, it is for the sake of Yahweh’s holy name or reputation. As Yahweh says in 36:23b, it is so that “the nations will know that I, myself, am the Lord "), _c('i', [_vm._v("when I manifest my holiness by means of you all")]), _vm._v(" before their eyes.” Hence, there is a missional impetus, namely, to put Yahweh’s character/holiness on public display before the eyes of the nations by means of Israel’s life together. Israel is, in essence, depicted as a new creation brought into existence by the life-giving breath/Spirit in order to reflect the image of the holy God to the nations, who do not currently acknowledge him. This language and imagery from Ezekiel provide a scriptural matrix within which to hear the reasons Paul gives for avoiding the sexually immoral practices in vv. 6b–8."), _c('a', {
    attrs: {
      "id": "fn348"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("348")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, utilizing a familiar biblical pattern when the (lack of) holiness of God’s people is in view (cf. Ezek 36:16–21),"), _c('a', {
    attrs: {
      "id": "fn349"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("349")])]), _vm._v(" Paul reminds his audience of what he had told them before, namely, that “the Lord is an avenger ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἔκδικος")]), _vm._v(", "), _c('i', [_vm._v("ekdikos")]), _vm._v("] in all these things” (v. 6b). That is to say, the "), _c('i', [_vm._v("cruciform")]), _vm._v(" Lord, to whom this audience owes its very existence as a people, will avenge activity "), _c('i', [_vm._v("within the corporate life of this people")]), _vm._v(" that violates his own character. He does so because, as Yahweh’s name was publicly linked with Israel in Ezekiel, so the Lord’s name is publicly linked with the life of this Thessalonian assembly. This is an ominous note, a warning that even those who were called to live “in the sphere of sanctification” (v. 7), as Israel had been, might choose to live in a way that betrays their identity as the holy ones of God (as Israel had, Ezek 36:16–21). If they do so, according to 2 Thess 1:7–9, the Lord Jesus at his revelation from heaven will give just punishment ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐκδίκησις")]), _vm._v(", "), _c('i', [_vm._v("ekdikēsis")]), _vm._v("), not only to those who do not acknowledge God (like the Gentiles of 1 Thess 4:5), but also to those whose pattern of life indicates that they are “not "), _c('i', [_vm._v("obeying")]), _vm._v(" the gospel about our Lord Jesus Christ.” The related terminology here in 1 Thessalonians (cf. "), _c('i', [_vm._v("ekdikos")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("and "), _c('i', [_vm._v("ekdikēsis")]), _vm._v("), especially given its rarity in Paul as an eschatological referent,")]), _c('a', {
    attrs: {
      "id": "fn350"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("350")])]), _vm._v(" suggests that these passages are mutually interpreting. Hence, the pattern of life that Paul warns the audience about here in vv. 3b–6a is one form of behavior that illustrates what he means in 2 Thess 1:8 by “not obeying the gospel of our Lord Jesus Christ.” Conversely, since the avoidance of this sort of activity is constitutive of “your sanctification ["), _c('i', [_vm._v("hagiasmos")]), _vm._v("],” actually obeying the good news by displaying self-controlled, cruciform behavior is constitutive of sanctification ("), _c('i', [_vm._v("hagiasmos")]), _vm._v(") itself.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second reason for avoiding these practices comes in v. 7, where Paul reminds his audience that God did not call us to impurity ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπὶ ἀκαθαρσίᾳ")]), _vm._v(", "), _c('i', [_vm._v("epi akatharsia")]), _vm._v(") but to live in the sphere of sanctification ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν ἁγιασμῷ")]), _vm._v(", "), _c('i', [_vm._v("en hagiasmō")]), _vm._v("). While Paul can use "), _c('i', [_vm._v("akatharsia")]), _vm._v(" (impurity) with nonsexual nuances (e.g., 1 Thess 2:3), he most often uses it, as he does here, in contexts where sexual immorality is in view."), _c('a', {
    attrs: {
      "id": "fn351"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("351")])]), _vm._v(" Holiness and impurity were not strictly opposites in Second Temple Judaism."), _c('a', {
    attrs: {
      "id": "fn352"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("352")])]), _vm._v(" As we noted in the excursus above, however, both were understood as dynamic forces: holiness a force associated with (sources of) life, and impurity a polluting force associated with (sources of) death.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Already in the OT, the meaning of "), _c('i', [_vm._v("akatharsia")]), _vm._v(" (impurity) moved beyond simply ritual impurity and included the polluting effects of idolatry (e.g., Ezek 36:25b, 29a) and other objectionable behaviors, including sexual immorality (e.g., Ezek 22:10–16). In this context, it is clear that the “impurity” with which Paul was concerned is not ritual in nature. Paul’s later use of the word in Rom 1:24 informs its usage here. In the context of Rom 1, Paul connects "), _c('i', [_vm._v("akatharsia")]), _vm._v(" (Rom 1:24) with sexual immorality "), _c('i', [_vm._v("resulting from idolatry.")]), _vm._v(" There, God “gives up” those whose choices amount to a vote for idolatry to the powerful, “polluting” effects of "), _c('i', [_vm._v("akatharsia,")]), _vm._v(" with the result that they dishonor their own bodies with inappropriate sexual actions. Hence, for Paul, "), _c('i', [_vm._v("akatharsia")]), _vm._v(" seems to retain some of its OT character as a dynamic, contagious—even enslaving—force, one that for him may be expressed by, and result from, sinful sexual activity. It is obvious from 1 Cor 5 and 6:12–20 that Paul thinks that sinful sexual activity can infiltrate, pollute, and damage entire relational networks. Anyone who has seen the rippling effects of the damage done to relationships when improper sexual behavior is discovered in a tight-knit, local church will share a sense of Paul’s concern.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("Given these observations, it is clear why Paul would say that one reason to avoid the practices in 3b–5a is that God did not call us to impurity ("), _c('i', [_vm._v("akatharsia")]), _vm._v("). It is one way that their entire network of relations would become polluted with a powerful, contagious force whose end result would be death. The result would be that neither the corporate body as a whole nor the persons within it could continue to experience in beneficial ways the dynamic, life-giving (now personal) force of holiness, namely, God’s Holy Spirit.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("This reason to avoid such sexual practices is directly connected with the final and most important reason for avoiding them, namely, that rejecting these prohibitions amounts to a rejection of the God who, in Ezekiel-like language, “is giving his Holy Spirit into you all” (4:8; cf. Ezek 37:6, 14). Paul’s language in reference to the Spirit here is unusual in two ways. First, he speaks of God’s gifting of the Spirit with a present tense verb, signaling an ongoing supplying of the Spirit (cf. Gal 3:5), not simply a onetime gift, whose presence is continuing to give life to this community. Second, apparently under the influence of Ezek 37, he speaks of God’s giving this Spirit who brings dry bones to life "), _c('i', [_vm._v("into")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς")]), _vm._v(", "), _c('i', [_vm._v("eis")]), _vm._v(") you all.")]), _c('a', {
    attrs: {
      "id": "fn353"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("353")])]), _vm._v(" In Ezekiel, this life-giving Spirit moves among the whole community of exiled Israel, as well as "), _c('i', [_vm._v("into")]), _vm._v(" each set of bones, bringing them all to life together. Here, then, Paul’s language refers to the continual empowering activity of this life-giving, now cruciform, Holy Spirit being breathed "), _c('i', [_vm._v("into")]), _vm._v(" both the community as a whole body and into the individual bodies of its members. With God’s "), _c('i', [_vm._v("Holy")]), _vm._v(" Spirit now continuously energizing every part of their bodies (even their "), _c('i', [_vm._v("skeuos")]), _vm._v("!),"), _c('a', {
    attrs: {
      "id": "fn354"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("354")])]), _vm._v(" they need not be enslaved to the cultural patterns of "), _c('i', [_vm._v("porneia,")]), _vm._v(" with their bodies vehicles for the contagious effects of impurity ("), _c('i', [_vm._v("akatharsia")]), _vm._v("). Hence, to engage in such patterns of behavior would be tantamount to rejecting the gift of the Holy Spirit, whose purpose was to sanctify them, that is, to enable their life together in the sphere ruled by the cruciform Lord to publicly display "), _c('i', [_vm._v("this Lord’s")]), _vm._v(" character/holiness before the eyes of the Gentiles who did not acknowledge their God "), _c('i', [_vm._v("so that they would come to acknowledge him as Lord.")]), _vm._v(" Like Ezek 36–37, then, this text also has a missional direction. The "), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("ultimate purpose for the Thessalonians to avoid sexual immorality is so that others will see the image of the holy God instantiated in a communal body of flesh-and-blood human bodies animated by the Spirit of the new age and thereby be drawn to acknowledge the Cruciform One they see reflected there as Lord indeed (cf. Phil 2:6–11).")]), _c('a', {
    attrs: {
      "id": "fn355"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("355")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s18"
    }
  }, [_c('i', [_vm._v("4:9–12"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Flourishing in Love and Working to Avoid Dependence on Patrons")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Now about loving your sisters and brothers, you all have no need [for us]"), _c('a', {
    attrs: {
      "id": "fn356"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("356")])]), _vm._v(" to write to you. For you yourselves are taught by God so that you all love one another. "), _c('sup', [_vm._v("10")]), _vm._v("For you’re also doing (loving deeds) for all the brothers and sisters in the whole of Macedonia. Now we encourage you, brothers and sisters, to continue flourishing even more [in your loving deeds] "), _c('sup', [_vm._v("11")]), _vm._v("and to aspire to live quietly, tend to your own affairs, and work with your [own] hands, just as we instructed you all "), _c('sup', [_vm._v("12")]), _vm._v("so that you may live properly with regard to those outside, that is, that you all will not be dependent on anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Most commentators contend that 4:9–12 is related to Paul’s admonition in 5:14. There he counsels his audience to warn “those who are disorderly idlers,” which seems connected to the intracommunal situation he confronts in 2 Thess 3:6–13, with some who are refusing to work “living in disorderly idleness” (2 Thess 3:6, 11). Through what lens are we to view that intracommunal situation? Given the ubiquity of the patronage system in the audience’s social milieu, explicitly interpreting these three passages in light of it (1 Thess 4:9–12, esp. vv. 11–12; 5:12–14; 2 Thess 3:6–13) seems reasonable"), _c('a', {
    attrs: {
      "id": "fn357"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("357")])]), _vm._v(" and is less speculative than some of the alternatives."), _c('a', {
    attrs: {
      "id": "fn358"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("358")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("In the honor/shame–based Greco-Roman society, public life (as opposed to family life) was structured with a network of patron/client relationships. Economic and social life was characterized by the dependency of clients upon their patrons for financial assistance (at times including necessities like food and clothing) or influence the patron might exercise on their behalf because of his higher social status. In return, the client might come to the patron’s house in the morning to publicly honor him, would publicly speak out in support of his economic and social interests, and might be used by the patron on errands that would further those interests in the city’s public square. The more clients a patron had, the more honor and power accrued to him. Patrons themselves were clients of higher-status patrons in a kind of pyramid scheme of relationships that topped out at the emperor. It was engrained in the imagination of most in Greco-Roman culture that public life should be structured in this way. Acting on the basis of the assumptions it engendered would have seemed natural, nothing but common sense.")]), _c('a', {
    attrs: {
      "id": "fn359"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("359")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It would not have been surprising, then, that at least some in the Thessalonian congregation might not have discerned that attempting to pattern their life both within and outside the church on the basis of “business as usual” patronage assumptions might threaten their loyalty to God. This threat could show up in two related ways. First, for members of this community to indebt themselves to a patron outside the church could result in extreme pressure to display loyalty to that patron in ways that might compromise their loyalty to the God to whom they had turned. What might they do, for example, if their patron invited them to his daughter’s birthday party in a local temple where sacrificial meat would be served? They would have an obligation to their patron to attend; to refuse to do so would be an offense to him. However, to go and participate might, from Paul’s perspective, not only be an offense to God, but also be perilously close to turning back to their former life of idolatry and its demonic enslavement (1 Cor 10:14–22).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, for an able-bodied church member to attempt to cultivate a client relationship with another member of the church as their patron in lieu of engaging in some form of labor would lessen the ability of the church to take care of its genuinely “weak” members (5:14). It would also impede its ability to continue being a channel of grace (esp. in the form of economic aid) to other "), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("Christians outside Thessalonica “in the whole of Macedonia” (v. 10). Such a life pattern would stand in tension with that of the cruciform Lord. For those involved, attempting to cultivate relationships with patrons inside or outside of the church may have seemed very natural and certainly not like intentional disloyalty to God. As such, it could indeed be one of the things lacking in the "), _c('i', [_vm._v("pistis")]), _vm._v(" (faithfulness/loyalty) of some in the audience, one of the things Paul continues using this section of his letter to address.")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("With this in mind, we are not surprised to encounter a topic in v. 9 related to Paul’s cautions in 4:6a, that is, “love for brothers and sisters ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("φιλαδελφίας")]), _vm._v(", "), _c('i', [_vm._v("philadelphias")]), _vm._v("].” The word "), _c('i', [_vm._v("philadelphia")]), _vm._v(" was used for love between members of the same family/household, where life was not (at least overtly) structured in terms of the patronage system. Throughout the letter Paul has depicted the audience in familial terms as a community characterized by love (1:3; 3:6, 12). Here he tells them he has no need to write to them about it, effectively complimenting them by pretending to pass over the topic while nevertheless reinforcing what they already know about it and clarifying what it entails in their life together.")]), _c('a', {
    attrs: {
      "id": "fn360"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("360")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As we saw in the last section, Paul has already described the Thessalonians in terms reminiscent of Ezekiel’s description of Israel restored from exile, that is, as animated by Ezekiel’s life-giving Spirit. Apparently drawing from another prophetic context referring to God’s restoration of Israel from exile (Isa 54), Paul now describes them with what appears to be a neologism, that is, “God taught” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("θεοδίδακτοι")]), _vm._v(", "), _c('i', [_vm._v("theodidaktoi;")]), _vm._v(" cf. John 6:45)"), _c('a', {
    attrs: {
      "id": "fn361"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("361")])]), _vm._v(" to love one another. They are indeed a community restored from (figurative) exile by Ezekiel’s life-giving Spirit, “whose sons and daughters are taught by God ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διδακτοὺς θεοῦ")]), _vm._v(", "), _c('i', [_vm._v("didaktous theou,")]), _vm._v(" Isa 54:13 LXX],” experiencing God’s own “covenant of peace” (v. 10 LXX), essentially bearing the marks of Jeremiah’s “new covenant” community, where God “gives his laws into their mind and writes them upon their hearts” (Jer 31:33 LXX; 38:33). Given Paul’s emphasis so far on the way his own example (explicitly in 1:6, implicitly in 2:1–12) and teachings (4:1–2) have provided the content of the audience’s instruction, “God taught” probably does not mean unmediated instruction from God. It may, however, include the audience’s knowledge of Scripture related to loving your neighbor (e.g., Lev 19:18) in a way that reflects the holy character of God."), _c('a', {
    attrs: {
      "id": "fn362"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("362")])]), _vm._v(" In any case, their “doing” "), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("of loving deeds")]), _c('a', {
    attrs: {
      "id": "fn363"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("363")])]), _vm._v(" is on display, extending to brothers and sisters throughout the whole of Macedonia.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul then encourages the community as a whole to continue flourishing in these practices toward sisters and brothers both within and without the immediate "), _c('i', [_vm._v("ekklēsia,")]), _vm._v(" thereby partially"), _c('a', {
    attrs: {
      "id": "fn364"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("364")])]), _vm._v(" fulfilling Paul’s prayer in 3:12, that is, that the Lord would enable them “to increase and to flourish in love for one another and for all.” Verse 11 describes the sort of life pattern that will enable this growth to happen. They are to aspire to live quietly and tend to their own affairs. Such advice, if followed, would at least have the effect of not intentionally provoking more persecution."), _c('a', {
    attrs: {
      "id": "fn365"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("365")])]), _vm._v(" In addition, whether or not the two phrases together had a more technical sense of withdrawing altogether from public political life,"), _c('a', {
    attrs: {
      "id": "fn366"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("366")])]), _vm._v(" following this advice would make it very difficult for any audience member to cultivate a client relationship with a patron outside the church, given that in doing so, they would have to be tending to their patron’s affairs, not their own—and doing so in the public arena."), _c('a', {
    attrs: {
      "id": "fn367"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("367")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From Paul’s point of view, his counsel to “work with your [own] hands” would have been a clear alternative to seeking to cultivate relationships with a patron, whether outside or inside the church (cf. 1 Cor 9:12–18). Paul had already exemplified this pattern of life when he brought the gospel to them (2:9). His very life pattern embodied that gospel in that, even though he could have thrown his weight around, he refused to do so, working long and hard hours "), _c('i', [_vm._v("in order to avoid burdening them")]), _vm._v(" (see comments on 2:7–9). He did so with only their benefit in mind, demanding no reciprocal response from them, as the logic of the patronage system might have dictated. Hence, while cultivating relationships with patrons might have seemed entirely natural to some, Paul has already embodied, and now encourages, a different pattern of life for a community whose purpose is to embody the character of the cruciform Christ. But as we noted above, engaging in manual labor in this social context is not simply a way to avoid becoming a burden to others in the local church. It would also be a way to become a means of grace to others (cf. Eph "), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("4:28),")]), _c('a', {
    attrs: {
      "id": "fn368"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("368")])]), _vm._v(" an activity through which God continues to work to sanctify the imagination of those participating in it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This whole pattern of life (aspiring to live quietly, tending to one’s own affairs, engaging in manual labor) will enable the community to continue to flourish in doing loving deeds for each other and for Christians outside of their local fellowship. The result"), _c('a', {
    attrs: {
      "id": "fn369"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("369")])]), _vm._v(" of this way of living will be that they will be living with propriety or properly ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐσχημόνως")]), _vm._v(", "), _c('i', [_vm._v("euschēmonōs")]), _vm._v(") with regard to those outside the community. Paul’s language here is ambiguous and could mean that either (1) from the perspective of those outside the community, the community is living “properly” if its embodies the pattern of life Paul is recommending, or (2) from the perspective of those inside the church, this pattern of life is the “proper” way to live toward those outside the community. Paul’s use of the word elsewhere is not determinative in this case,"), _c('a', {
    attrs: {
      "id": "fn370"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("370")])]), _vm._v(" but other factors favor the latter."), _c('a', {
    attrs: {
      "id": "fn371"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("371")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Verse 12b is best understood as further explaining what “living properly with regard to those outside” means."), _c('a', {
    attrs: {
      "id": "fn372"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("372")])]), _vm._v(" In this case, then, this clause entails that those in the community are not dependent on anyone, the very antithesis to structuring life in terms of normal patron/client relationships. It seems unlikely that those outside the community—especially possible former patrons, for whom the patronage system was simply a matter of common sense—would think it was proper behavior for those in this community to seek not to be engaged in any client relationships with those outside it."), _c('a', {
    attrs: {
      "id": "fn373"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("373")])]), _vm._v(" It is more likely that the calculus for determining what constitutes proper behavior is one that is internal to the community. They are acting properly with regard to those outside the church when they are not dependent on any one of them. Mutual interdependence is indeed proper for those in the body of Christ, as Paul’s body imagery in 1 Cor 12 affirms, but not the sort of interdependence characteristic of patron/client relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this section, then, Paul is counseling a pattern of behavior whose purpose is to enable the whole church to flourish in loving deeds toward each other and toward Christians outside the local assembly. If all able-bodied church "), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("members work with their hands rather than seeking to cultivate business-as-usual patron/client relationships, the first result would be an enhanced ability of the whole community to be an effective economic means of grace to those in need within it, as well as to Christians in need outside it. The second result would be that church members would also avoid becoming clients of those outside, avoiding the possible pressure of displaying loyalty to their patron in ways that might compromise, albeit unintentionally, their loyalty to the God to whom they had turned.")])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("Some would characterize the language in 4:9–12 as Paul’s counsel to the Thessalonians who are refusing to work to stay out of public/political life.")]), _c('a', {
    attrs: {
      "id": "fn374"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("374")])]), _vm._v(" While this description is true to the extent that engaging in public/political life in this social context would have meant engaging it on its own terms (i.e., as structured by the patronage system), such a characterization can be misleading. Paul’s counsel, if followed in this social context, would have resulted in a community who publicly embodied the "), _c('i', [_vm._v("logos")]), _vm._v(" of the cross, that is, the way of thinking produced by the cross (1 Cor 1:18) rather than the common-sense assumptions of the patronage system. "), _c('i', [_vm._v("It would have been a reconfiguration of public life in cruciform, and therefore, holy, terms, not a withdrawal into the sphere of the private.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is certainly possible that some in such a community (even if all “work with their hands”) will continue to have relatively higher status and wealth at their disposal than others and, as such, will be better able than some to “care for” others in the congregation by rendering them aid in some form (see comments on 5:12–13). Such people might typically be categorized as patrons and emerge as de facto leaders of the community. But even if this is the case in this church, Paul’s language does not depict such relationships in business-as-usual patron/client terms. As we will note in the comments on 5:13, those who could be categorized as patrons of this congregation deserve the acknowledgment and love of other community members because of their cruciform work within the congregation, not because of their inherent social status in Greco-Roman society.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s19"
    }
  }, [_c('i', [_vm._v("4:13–18"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Resurrection of Those “Sleeping” at the Royal Coming of the Lord")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Now we do not want you all to be uninformed, brothers and sisters, about those who are sleeping, so that you will not grieve like the rest, who have no hope."), _c('a', {
    attrs: {
      "id": "fn375"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("375")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_c('sup', [_vm._v("14")]), _vm._v("For since we believe that Jesus died and rose, so also God, through Jesus, will bring those who have fallen asleep so that they might be with him. "), _c('sup', [_vm._v("15")]), _vm._v("For we are saying this to you all in accordance with this message about the Lord, that we who are living and remaining will surely not precede the ones who have fallen asleep into the royal coming of the Lord. "), _c('sup', [_vm._v("16")]), _vm._v("[This is] because the Lord himself will descend from heaven with a commanding shout, accompanied by a sound the archangel makes—that is, accompanied by the trumpet of God—and the dead will rise first through Christ’s actions. "), _c('sup', [_vm._v("17")]), _vm._v("Then we ourselves who are living and remaining will be caught up together with")]), _c('a', {
    attrs: {
      "id": "fn376"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("376")])]), _vm._v(" them by the clouds into a meeting with the Lord in the air. And thus we will always be with the Lord. 18So then, comfort each other with these words.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s20"
    }
  }, [_c('i', [_vm._v("The Main Issue in the Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("The community situation Paul is addressing in 4:13–18 has been reconstructed in a variety of ways."), _c('a', {
    attrs: {
      "id": "fn377"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("377")])]), _vm._v(" The issue involves some sort of knowledge about “the ones who are sleeping,” with the lack of such knowledge causing grief in the community (4:13). But what sort of knowledge? General historical and rhetorical considerations make it unlikely that the audience lacked knowledge of a future resurrection of the dead,"), _c('a', {
    attrs: {
      "id": "fn378"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("378")])]), _vm._v(" and Paul’s rhetoric clearly assumes his audience’s belief in the Lord’s royal coming, or parousia (2:19; 3:13). The primary issue, then, is not total lack of knowledge about the future resurrection or lack of belief in the parousia but how the two are connected. Given the clear emphasis on issues of timing (the language of “first,” “then”), the focus of the section seems to be the "), _c('i', [_vm._v("timing")]), _vm._v(" of the resurrection of the dead in relationship to the parousia. To be more specific, the source of grief in the audience seems to be uncertainty over whether those in the church who die before the parousia "), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("will be raised and united with the living church members in time to meet the Lord in his parousia.")]), _c('a', {
    attrs: {
      "id": "fn379"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("379")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Portraying the issue in this way is solidly anchored in textual indicators. An explanation as to "), _c('i', [_vm._v("why")]), _vm._v(" such timing is important for the church depends on what sort of historical information one brings to bear on the text. While there are other historically plausible alternatives for explaining the audience’s concern with timing,"), _c('a', {
    attrs: {
      "id": "fn380"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("380")])]), _vm._v(" the following explanation seems the most historically probable and seems to open the door to a fruitful theological engagement with the text (both in the comments that immediately follow and in the Theological Horizons portion of the commentary).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul refers to the coming of the/our Lord as a parousia six times in 1 and 2 Thessalonians (1 Thess 2:19; 3:13; 4:15; 5:23; 2 Thess 2:1, 8) and only once outside these letters—and that in a context in which political overtones are unmistakable, as the Lord comes to publicly consummate his reign over the cosmos (1 Cor 15:23). When used in connection with the imperial honorific language of Lord ("), _c('i', [_vm._v("kyrios")]), _vm._v("), as well as other language with political connotations,"), _c('a', {
    attrs: {
      "id": "fn381"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("381")])]), _vm._v(" “parousia” carries with it a loose pattern of cultural expectations associated with the arrival of a king, an important official, or even the emperor himself."), _c('a', {
    attrs: {
      "id": "fn382"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("382")])]), _vm._v(" Hence, the description of Christ’s coming as a parousia carries with it the cultural images of a royal parade, a victorious king coming in great honor into a city.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 15 Paul assures the audience that those who are living will not precede those who have died into the Lord’s parousia, depicting it as something "), _c('i', [_vm._v("into")]), _vm._v(" which people can go, that is, something in which one might participate."), _c('a', {
    attrs: {
      "id": "fn383"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("383")])]), _vm._v(" To participate in the royal parade welcoming and honoring one crucified by the empire whom you had acclaimed as Lord would bring not only honor to that Lord but vindication and honor to you as well (see the comments on 2:12 and 2 Thess 1:12). Paul had already admonished the Thessalonians to continue walking worthy of the God who even now is calling them “into his own kingdom "), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_vm._v("and honor/glory” (2:12). In such a social context, even though Paul does not say it explicitly, the import of the resurrection of the dead would have been not only about the assurance of individual salvation but also about issues of "), _c('i', [_vm._v("public honor—")]), _vm._v("albeit an honor whose basis has been recalibrated in God’s alternative court of reputation as sharing in the cruciform character of the coming Lord.")]), _c('a', {
    attrs: {
      "id": "fn384"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("384")])]), _vm._v(" If the dead whose lives had a cruciform shape because of their suffering faithfulness are not raised "), _c('i', [_vm._v("in time")]), _vm._v(" to share in the public vindication of their cruciform Lord, might they miss out on their own "), _c('i', [_vm._v("public")]), _vm._v(" vindication and sharing in the very honor/glory ("), _c('i', [_vm._v("doxa")]), _vm._v(") to which God had called them? Without this hope for public vindication, there might indeed be reason for grief on behalf of those who would be left out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With some confidence, then, we may say that this section of the letter clarifies the timing of the resurrection of the dead in relationship to the parousia. The social context of first-century Thessalonica and other clues in 1 and 2 Thessalonians make it historically probable that Paul says what he does to assure his audience that the dead who had experienced public dishonor because of their suffering faithfulness would share in the public vindication/honor of their "), _c('i', [_vm._v("kyrios")]), _vm._v(" (Lord) as they participated in his victorious royal parade. And if Paul’s habit elsewhere of describing resurrection life with "), _c('i', [_vm._v("doxa")]), _vm._v(" (glory/honor) and its cognates (see comments on 2:12) is allowed to influence the interpretation of this section, we may say that his mention of the resurrection of the members of this community also carries with it connotations of incorruption and life, that is, of transformation."), _c('a', {
    attrs: {
      "id": "fn385"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("385")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s21"
    }
  }, [_c('i', [_vm._v("Death, Resurrection, and the Coming of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Paul’s desire that his brothers and sisters not be uninformed (cf. Rom 1:13; 11:25; 1 Cor 10:1; 12:1; 2 Cor 1:8) signals that what follows is best understood as new, or at least clarifying, information concerning “those who are sleeping,” a common euphemism for those who had died, which Paul also uses elsewhere (1 Cor 11:30; 15:6, 18, 20, 51). The language has little, if anything, to say about the nature of an “intermediate state” and at most simply depicts these dead community members as being capable of being “awakened” by resurrection. But will those who have "), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_vm._v("died in suffering faithfulness (i.e., sharing in the "), _c('i', [_vm._v("pistis Christou")]), _vm._v(" [faithfulness of Christ]) be raised in time to share in Christ’s public vindication? In other words, can Paul’s later words in Rom 8:17 be trusted? If we cosuffer with him, will we indeed be cohonored/coglorified ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνδοξασθῶμεν")]), _vm._v(", "), _c('i', [_vm._v("syndoxasthōmen")]), _vm._v(") with him? Paul attempts to clarify the matter for them so that they will not grieve “just as the rest who have no hope.”")]), _c('a', {
    attrs: {
      "id": "fn386"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("386")])]), _vm._v(" The wording here need not be taken as indicating an absolute prohibition against any grieving at all for their dead brothers and sisters, but rather as prohibiting grief over the specific issue in this context,"), _c('a', {
    attrs: {
      "id": "fn387"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("387")])]), _vm._v(" that is, a fear that those sleeping will not be raised in time to share in the parousia. Whatever concrete form such grief might take, it could make the church publicly indistinguishable from “the rest, the ones who have no hope.” A proper Christian response to death that allows the church to give public witness to its specific form of hope is not to deny grief; it is, rather, to frame such grief with the comforting hope for the particular embodied salvation that comes through our Lord Jesus Christ (5:8). Neither a grief borne out of a sense of hopelessness nor a grief thinly masked by various forms of gnostic speculations of disembodied bliss—often seen at “Christian” funerals where there is no body or ashes present to remind us that Death is the last enemy that will finally be destroyed at the future resurrection—is the kind of grief that enables the church to give public witness to the particular hope that animates it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meaning of the first part of 4:14 is clear. Paul begins a conditional statement with a claim to which both he and his audience adhere: “Since we believe that Jesus died and rose.”"), _c('a', {
    attrs: {
      "id": "fn388"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("388")])]), _vm._v(" This affirmation is in some sense the basis for every eschatological claim Paul makes, in this passage or elsewhere. That God the Father vindicated his Son through the Spirit by raising him from the dead and transforming his body is the past event that functions as the primary lens through which any Christian version of the future is to be imagined and depicted. The “then” part of the clause in 4:14 follows (translated in very wooden fashion): “thus also God the ones who have fallen asleep through/in Jesus ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διὰ τοῦ Ἰησοῦ")]), _vm._v(", "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v("] he will bring [to be] with him ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("σὺν αὐτῷ")]), _vm._v(", "), _c('i', [_vm._v("syn autō")]), _vm._v("].” There are a variety of ways to render this text, depending on how one takes the prepositional phrases "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v(" and "), _c('i', [_vm._v("syn autō.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("With regard to the former, one might take "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v(" as meaning “in Jesus” and as modifying “the ones who have fallen asleep,” as the NIV does: “God will bring with Jesus those who have fallen asleep "), _c('i', [_vm._v("in him.")]), _vm._v("” However, what it might mean to fall asleep “through/in Jesus” is unclear, and it is unconvincing to argue that it does similar duty as Paul’s more usual language of being “in Christ” ("), _c('i', [_vm._v("en Christō")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn389"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("389")])]), _vm._v(" In addition, everywhere else where Paul uses "), _c('i', [_vm._v("dia tou")]), _vm._v(" followed by Jesus, Christ, Lord, or combinations thereof, the phrase always functions instrumentally."), _c('a', {
    attrs: {
      "id": "fn390"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("390")])]), _vm._v(" God will raise followers of Jesus through Jesus himself at the parousia, which resonates with what Paul says elsewhere (e.g., 1 Cor 15:21; Phil 3:21). Alternatively, then, one might take "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v(" instrumentally (“through Jesus”) as modifying “will bring”: “God, through Jesus, will bring those who have fallen asleep” (cf. the NRSV: “through Jesus, God will bring with him those who have died”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With regard to the translation of "), _c('i', [_vm._v("syn autō,")]), _vm._v(" simply translating it as “with him” might create an initial impression that the dead come with Jesus "), _c('i', [_vm._v("from heaven.")]), _vm._v(" But Paul never says any such thing elsewhere, and given what follows in this context, it makes little sense. Rather, "), _c('i', [_vm._v("syn autō")]), _vm._v(" is best taken as equivalent to “so that they might be with him” ("), _c('i', [_vm._v("eis to einai autous syn autō")]), _vm._v("),"), _c('a', {
    attrs: {
      "id": "fn391"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("391")])]), _vm._v(" yielding the following translation of v. 14b: “So also God, through Jesus, will bring those who have fallen asleep so that they might be with him.” That is, God the Father, "), _c('i', [_vm._v("through the activity of the risen Lord Jesus")]), _vm._v(" in his parousia in v. 16,"), _c('a', {
    attrs: {
      "id": "fn392"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("392")])]), _vm._v(" will bring those who have fallen asleep to be with him by raising them "), _c('i', [_vm._v("first")]), _vm._v(" so that they can participate in his royal coming in the very presence of the holy God, along with those living at the time. Hence, they will share not only in Christ’s story of death but also in his resurrection/vindication (cf. 5:10; Rom 6:8; 8:17; 1 Cor 15; Phil 3:20–21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s warrant for saying what follows in 4:15b–17"), _c('a', {
    attrs: {
      "id": "fn393"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("393")])]), _vm._v(" is that it is “in accordance with this message about the Lord ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("λόγῳ κυρίου")]), _vm._v(", "), _c('i', [_vm._v("logō kyriou")]), _vm._v("),” that is, the "), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("mutually believed message about Jesus’ death and resurrection in 4:14a.")]), _c('a', {
    attrs: {
      "id": "fn394"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("394")])]), _vm._v(" Most translate what comes next along the lines of “we who are living and remaining "), _c('i', [_vm._v("at")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς")]), _vm._v(", "), _c('i', [_vm._v("eis")]), _vm._v("] the parousia of the Lord will surely not precede those who have fallen asleep.” This rendering takes the "), _c('i', [_vm._v("eis")]), _vm._v(" as indicating time and modifying “those who remain,” that is, “those who remain "), _c('i', [_vm._v("at the time of")]), _vm._v(" the parousia of the Lord.” But neither Paul nor any other NT writer ever uses "), _c('i', [_vm._v("eis")]), _vm._v(" prior to the word “parousia” elsewhere,"), _c('a', {
    attrs: {
      "id": "fn395"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("395")])]), _vm._v(" which suggests a different way to render the verse here, namely, “we who are living and remaining will surely not precede "), _c('i', [_vm._v("into")]), _vm._v(" ["), _c('i', [_vm._v("eis")]), _vm._v("] the parousia of the Lord the ones who have fallen asleep.”"), _c('a', {
    attrs: {
      "id": "fn396"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("396")])]), _vm._v(" In this rendering, "), _c('i', [_vm._v("eis")]), _vm._v(" has its more typical force of indicating “movement toward or into,” thereby depicting the parousia as something "), _c('i', [_vm._v("into")]), _vm._v(" which people can go—that is, an event in which one might participate. Therefore, what Paul is saying that is conceptually “in accordance with this message about the Lord” is that God, through Jesus’ own activity at the parousia, will raise the dead and lead them into the royal parade to be with Jesus. Those who are still living will not precede those in the community who had died in going into this royal welcoming parade, which affirms that the latter will not miss out on the honor of participating in it. John Chrysostom also recognized the connection of honor and participation in the parousia:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("If He is about to descend, on what account shall we be caught up? "), _c('i', [_vm._v("For the sake of honor.")]), _vm._v(" For when a king drives into a city, "), _c('i', [_vm._v("those who are in honor go out to meet him;")]), _vm._v(" but the condemned await the judge within. . . . For He received Him up in the clouds, and “we shall be caught up in the clouds.” Seest thou "), _c('i', [_vm._v("how great is the honor?")]), _vm._v(" And as He descends, we go forth to meet Him, and, what is more blessed than all, so we shall be with Him. ("), _c('i', [_vm._v("Homily")]), _vm._v(" 8 on 1 Thessalonians, my italics; cf. also his comments on v. 15 in "), _c('i', [_vm._v("Homily")]), _vm._v(" 7)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Because of what the Lord himself will do at the royal coming, the living will “surely not precede” the ones who have fallen asleep. He will descend "), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("from heaven (as in Phil 3:20–21), and the dead will rise first, as a result of God raising them through Christ’s actions.")]), _c('a', {
    attrs: {
      "id": "fn397"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("397")])]), _vm._v(" What actions one should attribute to Jesus other than simply descending from heaven depends on how one understands the following three phrases expressing circumstances that attend to the Lord’s descent. Various construals of these phrases are possible, depending on what sorts of historical and textual parallels one introduces and what one imagines is the main thrust of the passage itself."), _c('a', {
    attrs: {
      "id": "fn398"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("398")])]), _vm._v(" My interpretation will be coherent with what we have argued is Paul’s main focus in this section, namely, that God will raise the dead "), _c('i', [_vm._v("through Jesus")]), _vm._v(" in time for them to participate in the royal welcoming parade. We will also introduce partial parallels with other NT texts to help warrant this way of construing these phrases. Since, as we have noted earlier, 1 Thessalonians is most probably the earliest Christian document in the NT canon, it should be obvious that I am not arguing that Paul would have been aware of any of these parallels. Rather, I am maintaining that, in a theological commentary that affirms that this letter is located not only in a context of first-century Thessalonica but also in the context of a canon of Scripture, it is appropriate to (at least partially) warrant particular textual construals by appealing to parallels with other passages within that canon.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The phrase “with a commanding shout” is best taken as indicating that the Lord will descend with "), _c('i', [_vm._v("his own")]), _vm._v(" shout of command, whose purpose is to command the dead to awake."), _c('a', {
    attrs: {
      "id": "fn399"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("399")])]), _vm._v(" The Fourth Gospel makes the clear claim that it is the Son who will raise up those who “believe into him” on the last day (6:39–40, 44, 54); more to the point here, it claims that he will do so "), _c('i', [_vm._v("with his voice:")])]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('sup', [_vm._v("25")]), _vm._v("Very truly I say to you all that the hour is coming—and now is here—when the dead will hear the voice of the Son of God, and those who hear will come to life. "), _c('sup', [_vm._v("26")]), _vm._v("For just as the Father has life in himself, so also he has granted to the Son to have life in himself. . . . "), _c('sup', [_vm._v("28")]), _vm._v("Do not marvel at this; for the hour is coming when all those in the tombs will hear his voice, "), _c('sup', [_vm._v("29")]), _vm._v("and they will come out, those who have done good into a resurrection of life, "), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("but those who have practiced evil into a resurrection of judgment. (John 5:25–26, 28–29)")]), _c('a', {
    attrs: {
      "id": "fn400"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("400")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Such language is essentially an oral explication of Jesus’ claim to be “the resurrection and the life” (11:25). Shortly after making that claim in 11:25, he demonstrates it with a graphic, albeit proleptic (since Lazarus dies again), portrayal when he stands at the tomb of Lazarus and "), _c('i', [_vm._v("cries out with a loud voice,")]), _vm._v(" “Lazarus, come out!” (11:43). Hence, the Son of God, who raises Lazarus with a loud command and promises to raise the dead with his voice on the last day, will descend at the parousia and keep that promise “with a commanding shout.” On this reading of this phrase, it is Jesus’ own action in his descent that is the agency through which God raises the dead. This reading has the potential for further theological development in a pneumatological direction. We attempt to do so below in the section “You Wonder Where the Spirit Went” in the Theological Horizons portion of the commentary. To anticipate what we will conclude there, through this commanding shout the Son releases the breath/Spirit he receives from the Father to go forth into hopelessly dead bodies to permeate and transform them into bodies appropriate for the new creation, bodies that Paul calls elsewhere “spiritual bodies” (1 Cor 15:44).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Son’s making-alive shout is accompanied by the sound the archangel makes,"), _c('a', {
    attrs: {
      "id": "fn401"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("401")])]), _vm._v(" the one who is (apparently) in charge of “his powerful angels,” who come with Jesus from heaven (2 Thess 1:7) to gather the elect as in Matt 24:31 (cf. Jude 9, where Michael is identified as “the archangel”). This sound that the archangel makes is probably blowing the trumpet belonging to God,"), _c('a', {
    attrs: {
      "id": "fn402"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("402")])]), _vm._v(" but certainty about the matter is neither possible nor necessary. Granted, the use of trumpets was not typical of the parousia tradition in the Greco-Roman world,"), _c('a', {
    attrs: {
      "id": "fn403"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("403")])]), _vm._v(" which is not surprising, for Paul is not attempting to forge a one-to-one correspondence "), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("between the Lord’s coming and the parousia tradition (on which, see below). Trumpets do, however, have a number of functions in Israel’s Scriptures that make a trumpet blast clearly appropriate in this context.")]), _c('a', {
    attrs: {
      "id": "fn404"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("404")])]), _vm._v(" Here, the trumpet’s blast signals the commencement of the Day of the Lord, where the King of the cosmos has arrived to lead the final battle, in which Death as the last enemy is completely destroyed and God becomes “all in all” (cf. 1 Cor 15:23–28, 50–58).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With the ink still drying on the word “first” at the end of v. 16, Paul begins v. 17 with “then,” rhetorically emphasizing that the main issue here is that of timing. He affirms that the living will not precede the dead into the parousia but that either they will all be “caught up” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁρπάζω")]), _vm._v(", "), _c('i', [_vm._v("harpazō")]), _vm._v(") together or, possibly, that the community members who had died would go into the parousia right before the living were caught up into it, perhaps increasing their honor even more. In either case, Paul’s main concern here is to emphasize that those who have died will be raised "), _c('i', [_vm._v("in time to be together in the parousia")]), _vm._v(" with those who are still living.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is the only time in the Bible where the verb "), _c('i', [_vm._v("harpazō")]), _vm._v(" (“caught up”) is used in an eschatological context. The Latin equivalent, "), _c('i', [_vm._v("rapio")]), _vm._v(" (I snatch, carry away), is the word from which the English word “rapture” is derived. Hence, this text has been understood throughout most of church history to refer to the “rapture” of Christians, albeit not to the “secret rapture” so beloved by premillennial dispensationalists."), _c('a', {
    attrs: {
      "id": "fn405"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("405")])]), _vm._v(" But here the word Paul uses simply means “snatched up” by sudden, even violent, divine action. Given that its only occurrence in an eschatological context is here, its content should be filled primarily with the images that this passage supplies.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These images follow in v. 17, where both the dead and the living are caught up by/in the clouds. Clouds are an element in numerous OT theophany texts (e.g., Exod 13:21; 19:9; Num 12:5; 14:14; Neh 9:12; Pss 97:1–2; 99:7), and there is no doubt that Paul is depicting this coming of the Lord of the cosmos as a theophany (note that the imagery has numerous parallels to Exod 19:7–25). As was the case with Jesus (Acts 1:9–11), clouds here are the means, or at least the mode, of his followers’ ascension, albeit not into heaven like Jesus, but into the meeting in the "), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("air as they are caught up into the Lord’s parousia. The basic pattern of Christ’s story continues to be that of those who are “in Christ”: faithfulness to Israel’s God in life and death, followed by a vindicating resurrection and ascension. The underlying thought here is analogous to that of Dan 7, in which the “son of man” represents the holy ones of Israel, and his destiny prefigures theirs. In Dan 7 the “son of man” appears to descend on clouds from heaven to earth "), _c('i', [_vm._v("coming to")]), _vm._v(" the Ancient of Days, who has convened court for the judgment of the nations in order that the son of man might be enthroned where “peoples, nations, and languages” would “serve him” (7:14). Jesus draws on this very language to describe his eschatological actions as “son of man” (e.g., Mark 14:62 and par.). Daniel’s “holy ones” are depicted as being on earth, with an arrogant empire “prevailing over them” until the Ancient One "), _c('i', [_vm._v("comes to")]), _vm._v(" them, vindicating them by giving judgment on their behalf and granting them the kingdom (Dan 7:21–22). In other words, in Dan 7 divine deliverance and vindication for God’s holy ones are depicted as coming "), _c('i', [_vm._v("from heaven to earth")]), _vm._v(" (cf. Phil 3:20–21), where they are granted a share in the divine kingdom (cf. 1 Thess 2:12). They are not taken into heaven.")])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("When the dead and the living are caught up by or in the clouds, it is “into a meeting with the Lord ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς ἀπάντησιν τοῦ κυρίου")]), _vm._v(", "), _c('i', [_vm._v("eis apantēsin tou kyriou")]), _vm._v("] in the air.”")]), _c('a', {
    attrs: {
      "id": "fn406"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("406")])]), _vm._v(" The word "), _c('i', [_vm._v("apantēsis")]), _vm._v(" can refer simply to a generic meeting, as it is often used in the LXX and in Greco-Roman culture. Hence, it is not a technical term that, by itself, refers to a particular kind of meeting."), _c('a', {
    attrs: {
      "id": "fn407"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("407")])]), _vm._v(" Along with several synonyms, however, it can be used when referring to the custom of meeting a Hellenistic dignitary (including an emperor) who was coming to visit a Greco-Roman city,"), _c('a', {
    attrs: {
      "id": "fn408"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("408")])]), _vm._v(" or perhaps when a new ruler or victorious commander was coming into a city in triumph."), _c('a', {
    attrs: {
      "id": "fn409"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("409")])]), _vm._v(" When used in conjunction with "), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("a parousia involving the Lord ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κύριος")]), _vm._v(", "), _c('i', [_vm._v("kyrios")]), _vm._v(") of the cosmos, who is being welcomed amid “happy noise,”")]), _c('a', {
    attrs: {
      "id": "fn410"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("410")])]), _vm._v(" "), _c('i', [_vm._v("apantēsis")]), _vm._v(" would evoke loosely the cultural expectations associated with formal receptions of a king coming to claim his kingdom in triumph. In this sort of meeting a delegation often comprising those with the most status or honor—those whose relative status was closer to that of the dignitary—would go outside of the city along the road on which the dignitary would be arriving, greet and welcome him there, and then escort him back into the city (cf. Acts 28:15)."), _c('a', {
    attrs: {
      "id": "fn411"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("411")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Being a part of that delegation involved giving honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξα")]), _vm._v(", "), _c('i', [_vm._v("doxa")]), _vm._v(") to the visiting dignitary and, at least at times, having an opportunity to display one’s own relative status as the delegation escorted him back into the city, thereby accruing public honor for oneself as well (see the quote from Chrysostom above). To be in such a select delegation that goes out to meet and honor a "), _c('i', [_vm._v("cruciform Lord,")]), _vm._v(" one might be expected to share an analogous cruciform character (i.e., “blameless in holiness,” 3:13) marked by suffering faithfulness if one was also going to share in his public "), _c('i', [_vm._v("doxa")]), _vm._v(" in the march back into the city. Hence, the basis for sharing in the honor of this parade is different from that which typically brings status and honor; it is sharing in the cruciform character of the coming Lord. One might say, then, that the images the text evokes here provide a visual display of Paul’s words elsewhere: “We are coheirs with Christ,"), _c('a', {
    attrs: {
      "id": "fn412"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn412",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("412")])]), _vm._v(" if indeed we are suffering with him so that we might be cohonored/coglorified with ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνδοξασθῶμεν")]), _vm._v(", "), _c('i', [_vm._v("syndoxasthōmen")]), _vm._v("] him” (Rom 8:17b). It indeed depicts Christ’s followers sharing in his “kingdom and honor,” to which God is calling this audience (1 Thess 2:12; 2 Thess 1:12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("About the aftermath of this meeting, Paul explicitly says only that “we will always be with the Lord.” He does not say that we will always be with the Lord in the air or always with the Lord in heaven."), _c('a', {
    attrs: {
      "id": "fn413"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("413")])]), _vm._v(" All the preceding political connotations "), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("of the text, along with the use of "), _c('i', [_vm._v("apantēsis")]), _vm._v(" in this verse, point toward affirming that this community who goes to honor the Lord by meeting him in the air shares that honor as they escort him back to earth, where he publicly consummates his reign as Lord of the cosmos.")]), _c('a', {
    attrs: {
      "id": "fn414"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("414")])]), _vm._v(" Indeed, this is precisely what God has called all the suffering faithful (living and dead) into, his own kingdom and honor/glory (1 Thess 2:12; 2 Thess 1:12). God, then, will raise the dead (who had suffered) through the actions of Jesus at the parousia, and they, like the suffering living, will experience public vindication when they share in the honor ("), _c('i', [_vm._v("doxa")]), _vm._v(") accruing to those who form the delegation to meet the true Lord of the cosmos as he comes to publicly consummate his reign.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It should be noted that this is not some sort of interim rule with some connection to a millennium,"), _c('a', {
    attrs: {
      "id": "fn415"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("415")])]), _vm._v(" a concept that is neither warranted from Paul’s letters nor theologically relevant here."), _c('a', {
    attrs: {
      "id": "fn416"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("416")])]), _vm._v(" Rather, the orientation and direction of Paul’s eschatological images move toward imagining the parousia as the time when the cosmos itself is redeemed and God becomes “all in all.” This cosmic redemption is more than the creation being “restored to its paradisal state”;"), _c('a', {
    attrs: {
      "id": "fn417"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("417")])]), _vm._v(" it is “the unrealized promise of the first creation finally achieved,”"), _c('a', {
    attrs: {
      "id": "fn418"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("418")])]), _vm._v(" when God brings humanity and the rest of creation to its intended destiny.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul concludes in v. 18 with what is essentially the antidote to the current (or possible) grief in the community, namely, the admonition to comfort or exhort one another with the words of this section. Given that those who died will be raised in time to participate together with those in the community who are still living, there is no reason for grieving over the uncertainty of their sharing the royal parade of vindication with the living.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hearing these words after two thousand years could certainly generate skepticism, either because the idea of participating in such a victory parade seems so foreign to our thinking, or simply because of the amount of time that has passed without any such parade having happened. Yet, given a nonsectarian ecclesiology, as Robert Jenson calls it,"), _c('a', {
    attrs: {
      "id": "fn419"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("419")])]), _vm._v(" and with the Spirit’s enabling, the words might rather become a rich source of grace for us as well. That is, the words still work to assure us that we will indeed become the one, holy, catholic "), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("church, but only when we are all together in the parousia. That is, we will not be finally vindicated/justified or made completely holy apart from those whose embodying of the faithfulness of Christ ("), _c('i', [_vm._v("pistis Christou")]), _vm._v(") has shaped our very imaginations, bodies, and communities. There is an ecclesiology at work here that moves along the lines of the view in Hebrews that even the holy ones who have died will not be made perfect without us (11:39–40). In other words, it takes "), _c('i', [_vm._v("all")]), _vm._v(" of the one, catholic "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" stretching through time and into eternity to finally be the one, "), _c('i', [_vm._v("holy,")]), _vm._v(" catholic "), _c('i', [_vm._v("ekklēsia.")]), _vm._v(" With them we will be raised (or, if living, transformed) and then be “blameless in holiness” together. Our lives and bodies are too interconnected with each other and with the crucified and risen Christ for it to be any other way!")])]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  })])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467446129',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(112)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(114);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 114 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.bd98ed2b84286bf60c36.js